export default {
	"access.organization.name": "Access to organization card",
	"access.user.card": "Access to user card",
	"action.customize.view": "Personnaliser la disposition",
	"action.default.view": "Vue par défaut",
	"action.viewcart": "Voir le panier",
	"active": "Active",
	"add-suborg.add-suborg": "Ajouter une sous-organisation",
	"add-suborg.admin-info": "Informations sur l'administrateur",
	"add-suborg.administrator": "Administrateur",
	"add-suborg.confirmation": "Confirmation",
	"add-suborg.email": "E-mail de l'administrateur",
	"add-suborg.firstname": "Prénom de l'administrateur",
	"add-suborg.id": "ID de l'organisation",
	"add-suborg.intro": "Pour l'organisation Arcelormittal Europe, sélectionnez une organisation existante ou créez-en une nouvelle :",
	"add-suborg.lastname": "Nom de l'administrateur",
	"add-suborg.matchin-org-intro": "Utiliser les données de l'organisation correspondante :",
	"add-suborg.matching-organizations": "Organisations correspondantes",
	"add-suborg.new-org-intro": "Créez une nouvelle sous-organisation à partir de zéro :",
	"add-suborg.org-info": "Informations sur l'organisation",
	"add-suborg.org-name": "Nom de l'organisation",
	"add-suborg.organization-details": "Détails sur l'organisation",
	"add-suborg.please-select": "Veuillez sélectionner une option",
	"add-suborg.quick-search": "Rechercher un utilisateur",
	"add-suborg.vat-num-already-exists": "Le numéro de TVA existe déjà. Veuillez indiquer un nouveau numéro de TVA",
	"add-suborg.vat-number": "Numéro de TVA",
	"add-user.add-user": "Ajouter un utilisateur",
	"add-user.admin-user": "Promouvoir en tant qu'administrateur de cette organisation",
	"add-user.confirmation": "Confirmation",
	"add-user.email": "E-mail",
	"add-user.email-exist": "L'ID d'e-mail existe déjà",
	"add-user.intro": "Pour l'organisation Arcelormittal Europe, sélectionnez un utilisateur existant ou créez-en un nouveau :",
	"add-user.matchin-users-intro": "Utiliser les données des utilisateurs correspondants :",
	"add-user.matching-users": "Utilisateurs correspondants",
	"add-user.name": "Nom",
	"add-user.new-user-intro": "Créer un nouvel utilisateur à partir de zéro :",
	"add-user.please-select": "Veuillez sélectionner une option",
	"add-user.proceed-to-creation": "Procéder à la création",
	"add-user.referal-organization": "Organisation de référence",
	"add-user.required": "Obligatoire",
	"add-user.services": "Services",
	"add-user.services-management": "Gestion des services",
	"add-user.user-creation": "Création de l'utilisateur",
	"add-user.user-email": "E-mail",
	"add-user.user-exists": "L'utilisateur sélectionné existe déjà pour l'organisation",
	"add-user.user-firstname": "Prénom",
	"add-user.user-informations": "Information de l'utilisateur",
	"add-user.user-lastname": "Nom",
	"add-user.user-not-active": "L'utilisateur sélectionné n'est pas actif",
	"add-user.user-type": "Type of user",
	"add.item.to.cart.error.msg": "Un problème s'est produit lors de l'ajout d'articles au panier, veuillez réessayer après un certain temps.",
	"add.to.cart.label": "Ajouter au panier",
	"administrator.message": "est l'administrateur de l'organisation :",
	"ag-grid.copy": "Copier ",
	"ag-grid.copyWithHeaders": "Copier avec les en-têtes",
	"ag-grid.csvExport": "Export fichier type CSV",
	"ag-grid.excelExport": "Export ficher type Excel (.xlsx)&lrm;",
	"ag-grid.excelXmlExport": "Export ficher type Excel (.xml)&lrm ;",
	"ag-grid.export": "Export",
	"ag-grid.paste": "coller",
	"all.productsFamilies.not.available": "Toutes les familles Produits ne sont pas disponibles",
	"application.procurement.supplier.rfqNumber": "Numéro de RFQ fournisseur",
	"aqdb.N.of.dispatch.note": "N of Dispatch Note",
	"aqdb.ageing.duration": "Duration of ageing",
	"aqdb.ageing.temp": "Temperature of ageing",
	"aqdb.aluminium": "% Al",
	"aqdb.anisotropy.avg.r": "R average",
	"aqdb.anisotropy.direction": "Cutting Direction Compared to Rolling",
	"aqdb.anisotropy.r": "Value R",
	"aqdb.arsenic": "% Ar",
	"aqdb.article.reference": "Article reference",
	"aqdb.aspect.side.1": "Aspect side 1 code",
	"aqdb.aspect.side.2": "Aspect side 2 code",
	"aqdb.av.date": "Available date",
	"aqdb.avg.hardening.ratio": "Coefficient of Average Work Hardening",
	"aqdb.axis": "Axis",
	"aqdb.bakeHardening.with.elongation": "Bake-hardening with 2% elongation",
	"aqdb.bakeHardening.without.elongation": "Bake-hardening without elongation",
	"aqdb.base.product.number": "Base product number",
	"aqdb.base.product.release": "Base product release",
	"aqdb.batch": "Batch",
	"aqdb.batch.reference": "Batch reference",
	"aqdb.bend.indicator": "Code folding",
	"aqdb.boron": "% B",
	"aqdb.calcium": "% Ca",
	"aqdb.carbon": "% C",
	"aqdb.carbon.eq.formula": "Formula carbon-equivalent",
	"aqdb.carbon.equivalent": "Carbon equivalent",
	"aqdb.casting.date": "Casting date",
	"aqdb.casting.mill": "Casting Mill",
	"aqdb.cerium": "% Ce",
	"aqdb.chemical.characteristics": "Chemical characteristics",
	"aqdb.chemical.characteristics.cast.analysis": "Chemical characteristics - Cast analysis",
	"aqdb.chemical.characteristics.product.analysis": "Chemical characteristics - Product analysis",
	"aqdb.chemical.formula": "Another combination",
	"aqdb.chemical.surface.chemical.treatment.avg1": "Average value 1",
	"aqdb.chemical.surface.chemical.treatment.avg2": "Average value 2",
	"aqdb.chemical.surface.chemical.treatment.avg3": "Average value 3",
	"aqdb.chemical.surface.chemical.treatment.avg4": "Average value 4",
	"aqdb.chemical.surface.chemical.treatment.avg5": "Average value 5",
	"aqdb.chemical.surface.chemical.treatment.element1": "Chemical element 1",
	"aqdb.chemical.surface.chemical.treatment.element2": "Chemical element 2",
	"aqdb.chemical.surface.chemical.treatment.element3": "Chemical element 3",
	"aqdb.chemical.surface.chemical.treatment.element4": "Chemical element 4",
	"aqdb.chemical.surface.chemical.treatment.element5": "Chemical element 5",
	"aqdb.chemical.surface.chemical.treatment.type": "Type of chemical coating",
	"aqdb.chemical.surface.treatment": "Coating / Surface characteristics - Inorganic coating",
	"aqdb.chromium": "% Cr",
	"aqdb.coating.surface.face": "Face",
	"aqdb.coating.surface.side": "Side",
	"aqdb.code": "Code",
	"aqdb.combination.value": "Value combination",
	"aqdb.commercial.quality": "Commercial quality",
	"aqdb.complete.message": "Indicator of complete message",
	"aqdb.copper": "% Cu",
	"aqdb.customer.article.ref": "Customer Article Ref.",
	"aqdb.customer.product": "Customer product",
	"aqdb.customer.product.data": "Customer products data",
	"aqdb.datas.transmitted.on.certificate": "Data transmitted on certificate",
	"aqdb.date": "Date",
	"aqdb.date.chemical": "Identification Date",
	"aqdb.delivery.mill": "Delivery mill",
	"aqdb.description": "Technical Quality Label",
	"aqdb.dimensions.form": "Dimensions & Form",
	"aqdb.direction.L": "Longitudinal",
	"aqdb.direction.T": "Transverse",
	"aqdb.dis.elongation": "Lengthening distributed",
	"aqdb.dispatch.advice.number": "Dispatch advice number",
	"aqdb.dispatch.date": "Dispatch Date",
	"aqdb.erichsen.index": "Erichsen index",
	"aqdb.external.diameter": "External diameter of MU",
	"aqdb.face.appearance.code1": "Face appearance code 1",
	"aqdb.face.appearance.code2": "Face appearance code 2",
	"aqdb.family.group.code": "Family group code",
	"aqdb.flag.complete": "Complete",
	"aqdb.flag.incomplete": "Incomplete",
	"aqdb.form": "Form",
	"aqdb.format.actual": "Format (actual/ordered)",
	"aqdb.formula.cal02": "Formula CAL02",
	"aqdb.formula.cal15": "Formula CAL15",
	"aqdb.grade": "Grade",
	"aqdb.gross.weight": "Gross Weight",
	"aqdb.hardness.index": "Hardness number",
	"aqdb.hardness.type": "Condition of the hardness test",
	"aqdb.heat.number": "Heat N°'",
	"aqdb.hydrogen": "% H",
	"aqdb.induction.10000w": "Induction at 10000 W",
	"aqdb.induction.2500w": "Induction at 2500 W",
	"aqdb.induction.5000w": "Induction at 5000 W",
	"aqdb.internal.diameter": "Internal diameter of MU",
	"aqdb.label": "Données AQDB",
	"aqdb.lead": "% Pb",
	"aqdb.level": "Palier",
	"aqdb.losses.15t": "Losses at 1,5 T",
	"aqdb.losses.1t": "Losses at 1 T",
	"aqdb.magnetic.characteristicList": "Magnetic characteristics",
	"aqdb.manganese": "% Mn",
	"aqdb.marked.identity": "Marked Identity",
	"aqdb.measure.type": "Measure type",
	"aqdb.measured.datas": "Measured data",
	"aqdb.mechanical.characteristics.anisotropy": "Mechanical characteristics - Anisotropy",
	"aqdb.mechanical.characteristics.bake.hardening": "Mechanical characteristics - Bake hardening",
	"aqdb.mechanical.characteristics.bending": "Mechanical characteristics - Bending",
	"aqdb.mechanical.characteristics.erichsen": "Mechanical characteristics - Erichsen",
	"aqdb.mechanical.characteristics.hardness": "Mechanical characteristics - Hardness",
	"aqdb.mechanical.characteristics.impact.resistance": "Mechanical characteristics - Resilience",
	"aqdb.mechanical.characteristics.tensile.test": "Mechanical characteristics - Tensile test",
	"aqdb.metal.coating.aluminium": "% Aluminium",
	"aqdb.metal.coating.average.quantity": "Average quantity",
	"aqdb.metal.coating.characteristics": "Coating / Surface characteristics - Metal coating",
	"aqdb.metal.coating.delta.phase": "Mass Phase Delta",
	"aqdb.metal.coating.dzeta.phase": "Mass Phase Dzeta",
	"aqdb.metal.coating.gamma.phase": "Mass Phase Gamma",
	"aqdb.metal.coating.iron.rate": "Iron rate in galvallia",
	"aqdb.metal.coating.lead": "% Lead",
	"aqdb.metal.coating.measure.type": "Type of measurement",
	"aqdb.metal.coating.nature": "Nature of metallic coating",
	"aqdb.metal.coating.nickel": "% Nickel",
	"aqdb.metal.coating.powdering": "Powdering",
	"aqdb.metal.coating.quantity.centre": "Quantity Centre",
	"aqdb.metal.coating.quantity.edge1": "Quantity Edge 1",
	"aqdb.metal.coating.quantity.edge2": "Quantity Edge 2",
	"aqdb.metal.coating.spangling": "Spangling",
	"aqdb.metal.unit": "Metal unit",
	"aqdb.metal.unit.date": "Metal Unit Identification Date",
	"aqdb.metal.unit.information": "Metal unit informations",
	"aqdb.metal.unit.mill": "Metal Unit Identification Mill",
	"aqdb.mill.cast": "Mill Cast Number",
	"aqdb.mill.cast.number": "Mill Cast Number",
	"aqdb.mill.code": "Receiving mill code",
	"aqdb.mill.description": "Mill",
	"aqdb.mill.internal.ref": "Mill internal reference",
	"aqdb.modelled.data": "Modelled data",
	"aqdb.molybdenum": "% Mo",
	"aqdb.mpa.unit": "megapascal (Mpa)",
	"aqdb.nature": "Nature",
	"aqdb.net.weight": "Net weight (t)",
	"aqdb.nickel": "% Ni",
	"aqdb.niobium": "% Nb",
	"aqdb.nitrogen": "% N2",
	"aqdb.no": "No",
	"aqdb.nominal.thickness": "Nominal thickness",
	"aqdb.nominal.width": "Nominal width",
	"aqdb.notch.average.crystallinity.index": "Average crystallinity index",
	"aqdb.notch.average.ductility.rate": "Average ductility rate",
	"aqdb.notch.average.energy": "Average energy (in Joules)",
	"aqdb.notch.crystallinity.index1": "Crystallinity index 1",
	"aqdb.notch.crystallinity.index2": "Crystallinity index 2",
	"aqdb.notch.crystallinity.index3": "Crystallinity index 3",
	"aqdb.notch.energy1": "Energy 1 (in Joules)",
	"aqdb.notch.energy2": "Energy 2 (in Joules)",
	"aqdb.notch.energy3": "Energy 3 (in Joules)",
	"aqdb.notch.percent.ductility1": "Ductility rate 1",
	"aqdb.notch.percent.ductility2": "Ductility rate 2",
	"aqdb.notch.percent.ductility3": "Ductility rate 3",
	"aqdb.organic.coating.bending": "Bending",
	"aqdb.organic.coating.brilliance": "Brilliance",
	"aqdb.organic.coating.characteristics": "Coating / Surface characteristics - Organic coating",
	"aqdb.organic.coating.colour": "Colour",
	"aqdb.organic.coating.delta.a": "Delta A",
	"aqdb.organic.coating.delta.b": "Delta B",
	"aqdb.organic.coating.delta.e": "Delta E",
	"aqdb.organic.coating.delta.l": "Delta L",
	"aqdb.organic.coating.nature": "Nature of organic coating",
	"aqdb.organic.coating.reticulation": "Reticulation",
	"aqdb.organic.coating.thickness": "Thickness",
	"aqdb.origin.mill": "Origin Mill",
	"aqdb.other.characteristics": "Other Characteristics",
	"aqdb.oui": "Oui",
	"aqdb.phosphorus": "% P",
	"aqdb.pos.across.length": "Position test-tube in the length of the product",
	"aqdb.pos.across.width": "Position test-tube in the width of the product",
	"aqdb.product.family": "Product family",
	"aqdb.quality.code": "Technical Quality Code",
	"aqdb.quality.data": "consulter les données sur la qualité",
	"aqdb.quality.label": "Technical Quality Label",
	"aqdb.quality.version": "Technical Quality Version",
	"aqdb.quarter": "Quarter",
	"aqdb.recipient": "Recipient",
	"aqdb.release": "Technical Quality Version",
	"aqdb.roughness.characteristics": "Coating / Surface characteristics - Roughness",
	"aqdb.roughness.cut.off": "Cut-Off",
	"aqdb.roughness.obtainment": "Method of obtainment",
	"aqdb.roughness.peaks": "Number of peaks",
	"aqdb.roughness.ra": "Ra",
	"aqdb.roughness.rt": "Rt",
	"aqdb.roughness.rz": "Rz",
	"aqdb.roughness.threshold": "Threshold",
	"aqdb.roughness.w": "W",
	"aqdb.sample.type": "Type of test-tube",
	"aqdb.segment": "Segment",
	"aqdb.segments.no": "Number of Segments",
	"aqdb.serial.number": "Serial number",
	"aqdb.shipping": "Shipping Information",
	"aqdb.silicium": "% Si",
	"aqdb.steel.condition": "State of Metal",
	"aqdb.sulphur": "% S",
	"aqdb.surface.cleanliness.carbon": "Surface carbon",
	"aqdb.surface.cleanliness.characteristics": "Coating / Surface characteristics - Surface cleanliness",
	"aqdb.surface.cleanliness.iron": "Surface iron",
	"aqdb.surface.mu": "Surface of MU",
	"aqdb.technical.grade": "Technical grade",
	"aqdb.temp.notch": "Temperature notch test",
	"aqdb.tensile.direction": "Direction",
	"aqdb.tensile.re.rm": "Re/Rm",
	"aqdb.tensile.total.lengthening": "Total Lengthening",
	"aqdb.tensile.ultimate.tensile.stress": "Ultimate Tensile Stress",
	"aqdb.tensile.work.hardening.coefficient": "Work-hardening coefficient",
	"aqdb.test.condition": "Condition of the test",
	"aqdb.test.number.anisotropy": "Number of the test of anisotropy",
	"aqdb.test.number.bakehardening": "Number of the test Bake Hardening",
	"aqdb.test.number.bending": "Number of the bending test",
	"aqdb.test.number.erichsen": "Number of the test of Erichsen",
	"aqdb.test.number.hardness": "Number of the Hardness test",
	"aqdb.test.number.res": "Number of the reslience test",
	"aqdb.test.number.tensile": "Number of the tensile test",
	"aqdb.test.steel.condition": "State of the test-tube",
	"aqdb.test.temp": "Temperature of the test",
	"aqdb.thickness.mm": "Thickness (mm)",
	"aqdb.tin": "% Sn",
	"aqdb.titanium": "% Ti",
	"aqdb.unit": "Unit",
	"aqdb.user": "User",
	"aqdb.value.cal02": "CAL02",
	"aqdb.value.cal15": "CAL15",
	"aqdb.vanadium": "% V",
	"aqdb.weight.mu": "Net weight/Gross weight",
	"aqdb.width.mm": "Width (mm)",
	"aqdb.yes": "Yes",
	"aqdb.yield.stress": "Yield Stress",
	"aqdb.zinc": "% Zn",
	"aqdb.zirconium": "% Zr",
	"arcelormittal.need4steel.action.next": "Suivant",
	"arcelormittal.need4steel.action.proceed.to.order.button": "Passer la commande",
	"arcelormittal.need4steel.entry": "ArcelorMittal Need4Steel®",
	"arcelormittal.need4steel.menu.entry": "ArcelorMittal Need4Steel",
	"attachment.limit.description": "PDF, DOC, XLS, PPT ou images uniquement. Max 20Mo par fichier et max 3 fichiers.",
	"auction-material.category.subcategory": "Cat/sous-cat",
	"auction-material.details": "Détails des matériaux",
	"auction-material.downgrading.reason": "Motif de déclassement",
	"auction-material.oil.type": "Type d'huile",
	"auction-offer.now-rows": "Pas d'offre de vente aux enchères ouverte disponible",
	"auction-offer.soldTo.changed.warning": "If you change the corporate name, all the bid details you have entered/modified in current session will be lost.",
	"auction.bid.list": "Enchères - Liste des offres",
	"auction.bid.week": "Semaine d'offres",
	"auction.bidding": "Offres d'enchères le",
	"auction.bids": "Offres",
	"auction.bundle.number": "Numéro d'offre groupée",
	"auction.confirm.bid": "Confirmer l'offre",
	"auction.confirmation": "Confirmation",
	"auction.dashboard": "Tableau de bord des enchères",
	"auction.description": "Description de l'enchère",
	"auction.ended": "Terminé",
	"auction.entry": "Enchères",
	"auction.main.steelgrade": "Principale nuance d'acier (par volume)",
	"auction.market": "Marché",
	"auction.mill": "Usine",
	"auction.my.auction.bids": "Mes offres d'enchères",
	"auction.name": "Nom de l'enchère",
	"auction.new.offer.check": "Consulter la nouvelle offre d'enchères",
	"auction.offer.bid.awarded": "Awarded",
	"auction.offer.bid.pending": "Pending",
	"auction.offer.bid.rejected": "Rejected",
	"auction.offer.bundle": "Offre groupée",
	"auction.offer.clear.infos": "Supprimer les données",
	"auction.offer.customer.reference": "Référence client",
	"auction.offer.customerref.mandatory": "La référence client est obligatoire",
	"auction.offer.delivery.address.mandatory": "Delivery address is mandatory",
	"auction.offer.effective.price": "Prix effectif",
	"auction.offer.exw.price": "Prix départ usine €/t",
	"auction.offer.exwprice.mandatory": "Le prix départ usine est obligatoire",
	"auction.offer.invoicing.in": "Facturation en",
	"auction.offer.lanned.loading.date": "Date de chargement prévue",
	"auction.offer.no.bids": "No bids available",
	"auction.offer.payment.condition": "Conditions de paiement",
	"auction.offer.tmode.mandatory": "Le mode de transport est obligatoire",
	"auction.offer.transport.cost": "Frais de transport",
	"auction.offer.transport.invoiced.conditions": "Conditions de transport facturées",
	"auction.offer.type.of.maritime.transport": "Type de transport maritime",
	"auction.overview": "Votre aperçu de ventes aux enchères cette semaine",
	"auction.price.unit.et": "€/t",
	"auction.product.type": "Type de produit",
	"auction.selection": "Sélection d'enchères",
	"auction.submit.not.authorized.internal": "Action de soumission non autorisée en mode simulation ou délégation",
	"auction.timer.days": "jours",
	"auction.timer.endsin": "Se termine dans",
	"auction.timer.hours": "h",
	"auction.timer.minutes": "min",
	"auction.timer.weight.available": "Disponible",
	"auction.transport.price": "Frais du transport (€/t)",
	"auction.weight.unit.gross": "brut",
	"auctions.menu": "Enchères",
	"auctions.opened": "enchères ouvertes",
	"batch-card.all-documents": "Tous les documents de ce lot",
	"batch-card.batch-information": "Informations produit",
	"batch-card.batch-status": "Statut",
	"batch-card.certificate-display-all": "Afficher tous les certificats",
	"batch-card.create-call-off": "Démarrer un nouvel eCall-off",
	"batch-card.current-location": "Localisation actuelle",
	"batch-card.customer-article-reference": "Référence article client",
	"batch-card.customer-order-number": "Numéro de commande client",
	"batch-card.data-not-found": "Batch data not found",
	"batch-card.date-available-for-dispatch": "Date disponible pour l'expédition",
	"batch-card.days-in-stock": "Nombre de jours en stock",
	"batch-card.detailed-batch-status": "Statut détaillé des produits",
	"batch-card.dispatch-advice-display-all": "Afficher tous les avis d'expédition",
	"batch-card.document-date": "Date",
	"batch-card.document-number": "Numéro de document",
	"batch-card.document-show": "Afficher le document",
	"batch-card.document-type": "Type",
	"batch-card.final-use": "Utilisation final",
	"batch-card.followup": "Suivi",
	"batch-card.gross-weight": "Poids brut",
	"batch-card.heat-number": "Numéro de coulée",
	"batch-card.invoice-display-all": "Afficher toutes les factures",
	"batch-card.last-certificate": "Dernier certificat",
	"batch-card.last-dispatch-advice": "Dernier avis d'expédition",
	"batch-card.last-documents": "Derniers documents",
	"batch-card.last-invoice": "Dernière facture",
	"batch-card.length": "Longueur (mm)",
	"batch-card.mill": "Usine",
	"batch-card.mill-order-number": "Numéro de commande usine",
	"batch-card.net-weight": "Poids net ",
	"batch-card.package-serial-number": "Numéro de série du colis",
	"batch-card.planned-loading-date": "Date de chargement prévue",
	"batch-card.shipments": "Expéditions",
	"batch-card.steelgrade": "Nuance(s) d'acier ",
	"batch-card.stock-alert": "Alerte stock",
	"batch-card.supplier-order-number": "Numéro de commande fournisseur",
	"batch-card.thickness": "Épaisseur (mm)",
	"batch-card.width": "Largeur (mm)",
	"batch-list.last-seen": "Dernière liste des produits consultés",
	"batch.card": "Synthèse du lot",
	"batch.card.article": "Article",
	"batch.card.customer": "Client",
	"batch.card.dimensions": "Dimensions",
	"batch.card.final-use": "Utilisation final",
	"batch.card.go-to-the-order": "Accéder à la commande",
	"batch.card.information": "Informations produit",
	"batch.card.invoiced": "facturé ",
	"batch.card.mill": "Usine",
	"batch.card.mill-order": "Commande usine",
	"batch.card.order": "Commande",
	"batch.card.weight": "Poids",
	"batch.coil-length": "longueur de la bobine",
	"batch.current-location": "Localisation actuelle",
	"batch.current.location": "Localisation actuelle",
	"batch.date-for-dispatch": "Date disponible pour l'expédition",
	"batch.despatch.advice": "Avis d'expédition",
	"batch.despatch.date": "Date de l'avis d'expédition",
	"batch.detailed-batch-status": "État détaillé du lot",
	"batch.ecall-status": "eCall-off status",
	"batch.from.same.invoice": "Uniquement les lots à partir du numéro de facture :",
	"batch.from.same.invoice.available": "sont disponibles pour cette demande",
	"batch.gross": "Poids brut",
	"batch.gross-t": "Poids brut (t)",
	"batch.heat-number": "Numéro de coulée",
	"batch.in-stock": "en stock",
	"batch.in-transit-detail": "En transit - Détails",
	"batch.invoice.date": "Date facture",
	"batch.length": "Longueur",
	"batch.net": "Poids net",
	"batch.net-t": "Poids net (t)",
	"batch.not.invoiced": "Lot non facturé",
	"batch.not.invoiced.select.other": "Revenez plus tard pour soulever un problème de qualité sur cette unité matérielle.",
	"batch.not.invoiced.sorry": "Désolé, le lot que vous avez choisi n'est pas encore facturé",
	"batch.package-serial-number": "Numéro de série du colis",
	"batch.planned-loading-date": "Date de chargement prévue",
	"batch.reference": "lot ",
	"batch.requested-delivery-date": "Date de livraison demandée pour l'appel",
	"batch.requested-delivery-date-from": "Requested delivery date from",
	"batch.requested-delivery-date-to": "Requested delivery date to",
	"batch.shipment.date": "date d'expédition",
	"batch.shipto": "Expédié à",
	"batch.status": "Statut",
	"batch.supplier.invoice.number": "Numéro facture",
	"batch.view.all": "Afficher tous les produits",
	"batch.view.all.at": "Afficher tous les produits à {{value}}",
	"batches.detailed.batch.status": "Statut détaillé du lot",
	"batches.doc": "Doc ",
	"batches.gross-t": "brut (t)",
	"batches.net-t": "Net (t)",
	"batches.number.of.day.in.stock": "Nb de jours en stock",
	"blocked-service-alert.plural": "Désolé, ces services ne sont pas disponibles pour le moment, veuillez réessayer plus tard : {{services}}",
	"blocked-service-alert.refresh": "Actualiser",
	"blocked-service-alert.singular": "Désolé, ce service nest pas disponible pour le moment, veuillez réessayer plus tard : {{service}}",
	"browse.files": "Parcourir les fichiers",
	"cancel.issue": "Cancel your issue",
	"card.no.selected": "aucun produit sélectionné",
	"card.prototype": "Prototype",
	"card.prototype.lastModificationdate": "Last modification date",
	"card.prototype.production": "Production",
	"card.selected": "{{value}} produits sélectionnés",
	"cdd.in.date": "CDD (jours)",
	"cdd.in.week": "CDD en semaines",
	"chart-title.M1": "janv.",
	"chart-title.M10": "oct.",
	"chart-title.M11": "nov.",
	"chart-title.M12": "déc.",
	"chart-title.M2": "févr.",
	"chart-title.M3": "mars",
	"chart-title.M4": "avr.",
	"chart-title.M5": "mai",
	"chart-title.M6": "juin",
	"chart-title.M7": "juill.",
	"chart-title.M8": "août",
	"chart-title.M9": "sept.",
	"chart-title.Q1": "Q1",
	"chart-title.Q2": "Q2",
	"chart-title.Q3": "Q3",
	"chart-title.Q4": "Q4",
	"chart-title.S1": "S1",
	"chart-title.S2": "S2",
	"check.new.offer": "Consulter les nouvelles offres",
	"choose.customer.last.used": "Dernières sélections:",
	"choose.customer.restrict": "Veuillez sélectioner un utilisateur lorsque vous utilisez l'application SteelUser, car il s'agit d'une application réservée aux clients.",
	"choose.customer.select": "En tant qu'utilisateur interne, vous devez sélectionner le client pour lequel vous souhaitez afficher les données.",
	"choose.visibility.select": "Veuillez sélectionner votre visibilité parmi les options disponibles :",
	"claim-batch.receipt-date": "Date de réception",
	"claim.action.plan.notif": "Si nécessaire, appelez votre contact technique pour recevoir une action corrective.",
	"claim.add-batch-to-this-issue": "Ajouter un lot à cette question",
	"claim.add.attachment": "Ajouter une pièce jointe",
	"claim.additional.costs.invalid": "Le montant demandé au titre des autres frais doit être valable",
	"claim.additional.costs.mandatory": "Le montant demandé au titre des autres frais est obligatoire",
	"claim.additional.costs.requested": "Frais supplémentaires demandés",
	"claim.amount.for.other.costs": "Montant réclamé pour d'autres frais",
	"claim.amount.previous.value": "Votre valeur précédente : {{value}}",
	"claim.amount.unit.error": "La facture est exprimée en:",
	"claim.archived": "Archivé",
	"claim.attach.several.documents": "Joindre un ou plusieurs documents",
	"claim.attachment.error": "Vos pièces jointes n'ont pas été téléchargées correctement, veuillez réessayer.",
	"claim.attachment.filename.error": "Please make sure that your filename is less than 80 characters",
	"claim.attachment.limit.zl": "Le nom du fichier doit comporter moins de 80 caractères",
	"claim.attachment.limit.zr": "Veuillez fournir tous les détails pertinents nécessaires pour valider le montant et la quantité réclamés, tels que les numéros de bobines concernées, le poids et toute autre information à l'appui. Fournir des informations complètes et précises nous aidera à traiter votre réclamation rapidement et efficacement. Le nom du fichier doit comporter moins de 80 caractères",
	"claim.attachment.mandatory": "Veuillez ajouter au moins une pièce jointe",
	"claim.attachment.uploading.error": "Certaines pièces jointes sont toujours en cours de téléchargement, veuillez patienter.",
	"claim.attachments": "Pièces jointes",
	"claim.attachments.description": "Veuillez joindre au moins un justificatif (photo ou une vidéo) pour aider ArcelorMittal à fournir un retour concernant votre demande",
	"claim.barcode.number": "Numéro du code-barres",
	"claim.batch": "Lot",
	"claim.batch.reference.mandatory": "La référence du lot est obligatoire",
	"claim.batch.selection": "Sélection de lot",
	"claim.batches": "Produits",
	"claim.choose.defect": "choisir le défaut",
	"claim.claimtype.label": "Type de réclamation",
	"claim.comment": "Commentaire(s)",
	"claim.comment.mandatory": "Le commentaire est obligatoire",
	"claim.comment.placeholder": "Saisissez un bref commentaire pour expliquer le problème de qualité. Essayez d'être aussi détaillé et précis que possible.",
	"claim.contact.type.mandatory": "Le type de contact est obligatoire",
	"claim.created": "Créé",
	"claim.created.by": "Créé par",
	"claim.current.status": "Statut actuel",
	"claim.current.statusddot": "Statut actuel:",
	"claim.dashboard.services": "Mes services",
	"claim.dashboard.services.claims": "Retour qualité",
	"claim.defect": "Défaut",
	"claim.defect.mandatory": "Le défaut est obligatoire",
	"claim.display-pending-drafts": "commentaire(s) en attente",
	"claim.display-saved-drafts": "brouillon(s) enregistré(s)",
	"claim.first.batch.selection": "Première sélection de lot",
	"claim.full.quantity": "Quantité intégrale",
	"claim.go-back-to-batch-management": "Revenir à la gestion des produits",
	"claim.guarantee.request": "DEMANDER UNE NOUVELLE GARANTIE",
	"claim.impacted.quantity": "Quantité impactée",
	"claim.impacted.quantity.mandatory": "La quantité impactée est obligatoire",
	"claim.impacted.quantity.minimum": "Veuillez saisir une quantité valide supérieure ou égale à 1.",
	"claim.impacted.quantity.t": "Quantité impactée (t)",
	"claim.last.modification": "Dernière modification",
	"claim.main.batch.remove": "Supprimer",
	"claim.main.batch.selected": "Lot sélectionné",
	"claim.material.costs": "Coûts du matériel",
	"claim.material.unit": "Unité du matériel",
	"claim.multi.batch.related.order": "Commande associée",
	"claim.no.attachment": "Pas de pièce jointe",
	"claim.no.reference": "Pas de référence",
	"claim.no.sample.needed": "Pas d'échantillon nécessaire pour ce défaut.",
	"claim.not-existing-or-not-permission": "Le litige n'existe pas ou vous n'avez pas l'autorisation d'accéder aux informations relatives à ce litige.",
	"claim.optional": "En option",
	"claim.other.amount.cost": "Montant réclamé pour d'autres frais",
	"claim.paid.amount": "Montant payé",
	"claim.placeholder.reference.number": "Numéro de référence du client",
	"claim.quality.issue": "Litige",
	"claim.quality.issue.information": "Informations sur la qualité",
	"claim.quality.issue.summary": "Résumé sur la qualité",
	"claim.quantity.limit.error": "Quantité demandée supérieure à la quantité facturée.",
	"claim.quantity.previous.value": "Votre valeur précédente : {{value}}",
	"claim.quantity.tons.error": "La quantité impactée doit être inférieure à 1 000 par unité : tonnes métriques",
	"claim.quantity.unit.error": "La facture est exprimée en:",
	"claim.raise-new-quality-issue": "Remonter un problème de qualité",
	"claim.receipt.date.mandatory": "La date de réception est obligatoire",
	"claim.reference.number": "Numéro de référence",
	"claim.request.type": "Type de référence",
	"claim.requested.amount": "Montant demandé",
	"claim.requested.material.costs": "Coûts du matériel demandés",
	"claim.sample": "L'échantillon sera envoyé à:",
	"claim.sample.agency": "Contact commercial",
	"claim.sample.cts": "Contact technique",
	"claim.sample.mandatory": "Un échantillon est obligatoire",
	"claim.sample.not": "Je n'envoie pas d'échantillon",
	"claim.sample.not.recommended": "(non recommandé)",
	"claim.sample.other": "Autre",
	"claim.sample.other.comment": "Entrez la destination de l'échantillon",
	"claim.status.created": "Créé",
	"claim.total.amount": "Total du montant évalué",
	"claim.total.requested.amount": "Montant total demandé",
	"claim.total.requested.calculated": "Montant total demandé calculé",
	"claim.total.weight": "Poids total",
	"claim.type.filter.label": "Type de réclamation",
	"claim.type.zl": "Réclamation client ZL",
	"claim.type.zr": "Régularisation de réclamation ZR",
	"claim.visit": "Contact de ArcelorMittal",
	"claim.visit.text": "I want to be contacted by an ArcelorMittal contact.",
	"claim.warning": "Alerte",
	"claim.warning.takenintoaccount": "Alerte prise en compte",
	"claim.zr.attachment.info": "Veuillez toujours mentionner tous les lots affectés et tout détail supplémentaire pertinent (par exemple, la quantité par lot) pour assurer un traitement efficace des réclamations.",
	"coil.calculator.additional.data": "Données complémentaires",
	"coil.calculator.all.other.coils": "Toutes les autres bobines",
	"coil.calculator.density.text": "Se base sur une densité constante de « 7,85t/m³ ».",
	"coil.calculator.inner.diameter": "Diamètre interne de la bobine",
	"coil.calculator.inner.diameter.label": "Diamètre interne de la bobine (mm)",
	"coil.calculator.inner.diameter.mandatory": "Le diamètre interne de la bobine est obligatoire",
	"coil.calculator.input.parameters": "Paramètres d'entrée",
	"coil.calculator.length": "Longueur de la bobine",
	"coil.calculator.length.label": "Longueur de la bobine (m)",
	"coil.calculator.length.mandatory": "La longueur de la bobine est obligatoire",
	"coil.calculator.metallic.coating.thickness.label": "Épaisseur du revêtement métallique (g/㎡)",
	"coil.calculator.metallic.coating.type.label": "Type de revêtement métallique",
	"coil.calculator.metallic.coating.type.mandatory": "Le type de revêtement métallique est obligatoire",
	"coil.calculator.no.result.text": "Veuillez remplir tous les champs pour afficher les résultats.",
	"coil.calculator.nominal.thickness.label": "Épaisseur nominale (mm)",
	"coil.calculator.nominal.thickness.mandatory": "L'épaisseur nominale est obligatoire",
	"coil.calculator.organic.coated.coils": "Bobines à revêtement organique",
	"coil.calculator.organic.coated.film.thickness.label": "Épaisseur du revêtement organique (μm)",
	"coil.calculator.outer.diameter": "Diamètre externe de la bobine",
	"coil.calculator.outer.diameter.label": "Diamètre externe de la bobine (mm)",
	"coil.calculator.outer.diameter.mandatory": "Le diamètre externe de la bobine est obligatoire",
	"coil.calculator.outer.less.than.inner.error": "Valeur plus petite que le Ø interne",
	"coil.calculator.product.information": "Informations sur le produit",
	"coil.calculator.result": "Résultat",
	"coil.calculator.specific.weight": "Poids spécifique",
	"coil.calculator.specific.weight.label": "Poids spécifique (kg/mm)",
	"coil.calculator.specific.weight.mandatory": "Le poids spécifique est obligatoire",
	"coil.calculator.technical.feasibility.text": "L'outil n'assure aucunement un calcul de faisabilité technique des bobines de nos usines.",
	"coil.calculator.tool.text": "Ce calculateur de bobines est un outil qui vous aide à calculer le diamètre externe, le poids de la bobine, la longueur de la bobine ou le poids spécifique.",
	"coil.calculator.total.paint.thickness.label": "Épaisseur totale de la peinture en haut et en bas (μm)",
	"coil.calculator.weight": "Poids de la bobine",
	"coil.calculator.weight.label": "Poids de la bobine (tonnes)",
	"coil.calculator.weight.mandatory": "Le poids de la bobine est obligatoire",
	"coil.calculator.width.label": "Largeur (mm)",
	"coil.calculator.width.mandatory": "La largeur est obligatoire",
	"comment.offer.set": "Commentaires :",
	"commercial-documents-da.enduser": "Utilisateur final",
	"commercial-documents-da.heat": "Coulée",
	"commercial-documents-da.serial": "Séquentiel",
	"commercial-documents-da.supplier-article-reference": "Référence article fournisseur",
	"commercial-documents.all-my-documents": "Tous mes documents",
	"commercial-documents.amount": "Montant certifié",
	"commercial-documents.batch-number": "Numéro de lot",
	"commercial-documents.batches-details": "Détails des produits",
	"commercial-documents.ce.enduser": "Utilisateur final",
	"commercial-documents.ce.serial-number": "Numéro de série",
	"commercial-documents.ce.supplier-article-reference": "Référence article fournisseur",
	"commercial-documents.certificate-card": "Détails du certificat",
	"commercial-documents.certificate-date": "Date du certificat",
	"commercial-documents.certificate-number": "Numéro du certificat",
	"commercial-documents.certificate-type": "Type de certificat",
	"commercial-documents.customer": "Client",
	"commercial-documents.customer-article-reference": "Référence article client",
	"commercial-documents.customer-claim-reference": "Référence litige client",
	"commercial-documents.customer-order-number": "Numéro de commande client",
	"commercial-documents.date": "Date du document",
	"commercial-documents.dimensions": "Dimensions",
	"commercial-documents.discount": "Réduction",
	"commercial-documents.dispatch-advice-date": "Date de l'avis d'expédition",
	"commercial-documents.dispatch-advice-number": "Numéro de l'avis d'expédition",
	"commercial-documents.display-all-orders": "Afficher toutes les commandes",
	"commercial-documents.docsWithCreationDateGtLastConnectionDate": "Documents enregistrés depuis votre dernière connexion",
	"commercial-documents.documents": "documents",
	"commercial-documents.download-cart": "Panier de téléchargement",
	"commercial-documents.emptyHeatNumber": "N/A",
	"commercial-documents.endQuarter": "Trimestre de fin",
	"commercial-documents.enduser": "Utilisateur final",
	"commercial-documents.final-use": "Utilisation final",
	"commercial-documents.general-information": "Informations générales",
	"commercial-documents.heat-number": "Numéro de coulée",
	"commercial-documents.invoice": "Factures",
	"commercial-documents.invoice-amount": "Montant de la facture (total)",
	"commercial-documents.invoice-amount-without-vat": "Montant de la facture hors TVA (total)",
	"commercial-documents.invoice-card": "Détails de la facture",
	"commercial-documents.invoice-currency": "Devise de la facture",
	"commercial-documents.invoice-date": "Date de la facture",
	"commercial-documents.invoice-discount": "Rabais sur facture (totale)",
	"commercial-documents.invoice-number": "Numéro de facture",
	"commercial-documents.invoice-quantity": "QUANTITÉ FACTURÉE",
	"commercial-documents.invoice-tax-amount": "Montant de la taxe sur la facture",
	"commercial-documents.invoice-type": "Type de facture",
	"commercial-documents.invoiced-quantity": "Quantité facturée",
	"commercial-documents.invoiced-quantity-unit": "Quantité facturée (unités)",
	"commercial-documents.line-status": "Statut de la ligne",
	"commercial-documents.mill": "Usine",
	"commercial-documents.mill-order-number": "Numéro de commande usine",
	"commercial-documents.my-commercial-documents": "Mes documents commerciaux",
	"commercial-documents.number": "Numéro de document",
	"commercial-documents.order-acknowledgement-date": "Date de confirmation de commande",
	"commercial-documents.order-acknowledgement-number": "Numéro de confirmation de commande",
	"commercial-documents.order-acknowledgement-type": "Type de confirmation de commande",
	"commercial-documents.order-quantity": "Quantité ",
	"commercial-documents.order-reference": "Référence de la commande",
	"commercial-documents.orderAcknowledgement-card": "Confirmation de commande",
	"commercial-documents.ordered-quantity": "Quantité commandée (t)",
	"commercial-documents.orders-line-details": "Détails de la ligne de commande",
	"commercial-documents.orders-number": "Numéro de commande",
	"commercial-documents.payer": "Payeur",
	"commercial-documents.payer-vat-number": "Numéro de TVA du payeur",
	"commercial-documents.payment-due-date": "Date d'échéance du paiement",
	"commercial-documents.payment-due-to": "Paiement dû au",
	"commercial-documents.payment-information": "Informations de paiement",
	"commercial-documents.plant-invoice-number": "Numéro de facture de l'usine",
	"commercial-documents.product": "Produit",
	"commercial-documents.product-descriptions": "Description du produit",
	"commercial-documents.proforma": "Proforma",
	"commercial-documents.received-by-steeluser": "Reçu par SteelUser",
	"commercial-documents.rrp": "Type de RRP",
	"commercial-documents.shipto": "Expédié à",
	"commercial-documents.soldto": "Vendu à",
	"commercial-documents.steel-grade": "Nuance(s) d'acier",
	"commercial-documents.subtype": "Sous-catégorie de documents",
	"commercial-documents.supplier-claim-reference": "Référence litige fournisseur",
	"commercial-documents.supplier-order-number": "Numéro de commande fournisseur",
	"commercial-documents.supplier-vat-number": "Numéro de TVA fournisseur",
	"commercial-documents.tax": "Taxes",
	"commercial-documents.transport-mode": "Mode de transport",
	"commercial-documents.transport-reference": "N° de transport",
	"commercial-documents.type": "Type de document",
	"commercial-documents.vat": "TVA",
	"commercial-documents.vat-percentage": "Taux de TVA",
	"commercial-documents.weight": "Poids",
	"commercial-documents.without-vat": "Sans TVA",
	"commercial-documents.xcarbsubtype": "Sous-type XCarb®",
	"confirm.continue": "Souhaitez-vous continuer ?",
	"confirm.modified": "Dernière modification le",
	"confirm.respectively": "respectivement.",
	"confirm.same.material": "Il existe une autre réclamation pour cette unité de matériel en ce qui concerne",
	"confirm.thanks": "Merci, nous avons bien reçu votre demande.",
	"confirm.thanks.fastlane": "Merci, nous avons bien reçu votre demande",
	"confirmation.message": "Après confirmation, vous ne pourrez plus annuler cette action.",
	"contact.us": "Contactez e-Business support",
	"contactmail.popup.success.msg-line1": "Merci, nous avons bien reçu votre message.",
	"contactmail.popup.success.msg-line2": "Nous vous répondrons dès que possible.",
	"contactmail.submit.attachment.error.msg": "Désolé, il y a un soucis avec votre pièce jointe, merci d’essayer de la recharger.",
	"contactmail.submit.error.msg": "Désolé, il y a eu un soucis during l’envoie de mail. Merci de réessayer plus tard.",
	"contactmail.submit.session.error.msg": "Désolé, il y a un soucis avec votre session, merci d’essayer de vous reconnecter.",
	"continue.draft": "Continuer votre brouillon",
	"corrosion.A": "Atmospheric",
	"corrosion.S": "Soil Corrosion",
	"create.new.order": "Créer une nouvelle commande",
	"create.new.request": "CRÉER UNE NOUVELLE DEMANDE",
	"customer.share.view": "Partager la vue",
	"customer.simulation": "Sélectionnez un client",
	"dashboard.active.parameters": "Paramètres actifs",
	"dashboard.add-widget": "Ajouter un suivi",
	"dashboard.add-widget-instruction": "Veuillez sélectionner le widget que vous souhaitez ajouter",
	"dashboard.cancel": "annuler",
	"dashboard.card.time-in-stock": "Nombre de jours en stock",
	"dashboard.card.time-in-stock.time-to-call": "ALERTE DE CONSOMMATION",
	"dashboard.card.time-in-stock.view-details": "Voir les détails  ",
	"dashboard.claims": "Litiges",
	"dashboard.condition": "Condition:",
	"dashboard.customer-material-reference": "Référence matériel client",
	"dashboard.customize-indicator": "Personnaliser l'indicateur",
	"dashboard.customize-information": "Personnaliser les informations",
	"dashboard.delete.confirmation-question": "Voulez-vous vraiment supprimer ce widget ?",
	"dashboard.documents-since-last-connection": "Documents enregistrés depuis votre dernière connexion",
	"dashboard.drag-customer-article-here": "Mettez la référence de l'article du client ici",
	"dashboard.drag-drop-information": "Glissez et déposez les valeurs dans la case de droite.",
	"dashboard.drag-steelgrades-here": "Mettez les nuances d'acier ici",
	"dashboard.efeasibility": "eFeasibility",
	"dashboard.efeasibility.add.new": "Ask for a new feasibility",
	"dashboard.indicator": "Indicateur",
	"dashboard.information": "Information",
	"dashboard.key-indicator": "Indicateurs clés",
	"dashboard.key-information": "Informations clés",
	"dashboard.my-business-overview": "Tableau de bord",
	"dashboard.my.data": "mes données",
	"dashboard.order-status": "Statut de la commande",
	"dashboard.orders": "Commandes",
	"dashboard.rts-widget.title": "Les Stocks",
	"dashboard.rts-widget.tooltip": "Quantité prête à être expédiée disponible pour ce produit dans tous les stocks.",
	"dashboard.savechanges": "Enregistrer les modifications",
	"dashboard.saving": "Les widgets du tableau de bord sont sauvegardés",
	"dashboard.schedule.business.order-status": "Schedule business order status",
	"dashboard.spot.order-status": "Suivi des commandes Spot",
	"dashboard.steelgrade": "Nuance(s) d'acier",
	"dashboard.validate": "Valider",
	"dashboard.view.more": "Voir plus",
	"dashboard.widget-configuration": "Configuration",
	"dashboard.widget-preview": "Apperçu",
	"dashboard.widget.highest-stocks": "Top 5 des stocks les plus élevés",
	"dashboard.widget.material-ready-to-ship": "Matériaux prêts à être expédiés",
	"dashboard.without-value": "Sans valeur",
	"datacenter-filter.LMD": "Modification date",
	"datacenter-filter.PO-Reception-date": "PO Reception date",
	"datacenter-filter.PO-Reception-week": "PO Reception week",
	"datacenter-filter.Proposed-Total-weight": "Proposed total weight",
	"datacenter-filter.Proposed-blank-weight": "Proposed blank weight",
	"datacenter-filter.Proposed-price": "Proposition de prix",
	"datacenter-filter.additional-desc": "Additional item information",
	"datacenter-filter.back-office-customer": "Client back-office",
	"datacenter-filter.back-office-role": "Rôle back-office",
	"datacenter-filter.batch-reference": "Référence du lot",
	"datacenter-filter.batch-status": "Detailed batch status",
	"datacenter-filter.batches-not-delivered-gross": "Batches not yet delivered to final destination (Gross, t)",
	"datacenter-filter.batches-not-delivered-net": "Batches not yet delivered to final destination (net, t)",
	"datacenter-filter.bill-to": "Facturé à",
	"datacenter-filter.carrier-name": "Carrier name",
	"datacenter-filter.cdd": "CDD (Semaine)",
	"datacenter-filter.cdd-date": "CDD ",
	"datacenter-filter.chemical-passivation": "Chemical Passivation",
	"datacenter-filter.choice": "Choix",
	"datacenter-filter.coating": "Spécification du revêtement",
	"datacenter-filter.coilAxis": "CoilAxis",
	"datacenter-filter.collate-documents": "Rassembler des documents",
	"datacenter-filter.color-bottom-side": "Couleur face inférieure",
	"datacenter-filter.color-category-bottom-side": "Color Category Bottom Side",
	"datacenter-filter.color-category-top-side": "Color Category Top Side",
	"datacenter-filter.color-top-side": "Couleur face supérieure",
	"datacenter-filter.creation-date": "Date de ",
	"datacenter-filter.current-location": "Localisation actuelle",
	"datacenter-filter.customer-article-reference": "Référence article client",
	"datacenter-filter.customer-order-number": "Numéro de commande client",
	"datacenter-filter.customer-order-number-without-item": "Customer order nr w/o item",
	"datacenter-filter.customer-req-name": "Customer request name",
	"datacenter-filter.customerRefusal": "Customer refusal comments",
	"datacenter-filter.data-sheet-bottom-side": "Fiche organique face inf",
	"datacenter-filter.data-sheet-top-side": "Fiche organique  face sup",
	"datacenter-filter.date-available-for-dispatch": "Date disponible pour l'expédition",
	"datacenter-filter.delay": "Delay",
	"datacenter-filter.delivery-address": "Adresse de livraison",
	"datacenter-filter.delivery-address-order": "Delivery address for order",
	"datacenter-filter.delivery-location": "Delivery location",
	"datacenter-filter.delivery-mode": "Mode de livraison",
	"datacenter-filter.destination-address": "Destination Address",
	"datacenter-filter.destination-by-boat": "Destination en bateau",
	"datacenter-filter.destination-name": "Destination Name",
	"datacenter-filter.detailed-batch-status": "Statut détaillé des produits",
	"datacenter-filter.dimension": "Dim (mm)",
	"datacenter-filter.dispatch-advice": "Avis d'expédition",
	"datacenter-filter.dispatch-advice-date": "Date de l'avis d'expédition",
	"datacenter-filter.dispatch-advice-date-n1": "N-1 Date d'expédition",
	"datacenter-filter.dispatch-advice-date-n2": "N-2 Date d'expédition",
	"datacenter-filter.dispatch-advice-number": "Numéro de l'avis d'expédition",
	"datacenter-filter.dispatch-advice-number-n1": "N-1 Numéro de l'avis d'expédition",
	"datacenter-filter.dispatch-advice-number-n2": "N-2 Numéro de l'avis d'expédition",
	"datacenter-filter.dispatch-date": "Date d'expédition",
	"datacenter-filter.easy-film-bottom": "EasyFilm Bottom",
	"datacenter-filter.easy-film-top": "EasyFilm Top",
	"datacenter-filter.end-user": "Utilisateur final",
	"datacenter-filter.final-use": "Utilisation final",
	"datacenter-filter.first-name": "Prénom",
	"datacenter-filter.form": "Forme",
	"datacenter-filter.grade": "Nuance(s) d'acier",
	"datacenter-filter.gross-consignment": "Consignation (Brut, t)",
	"datacenter-filter.gross-first-batch": "Premier lot en stock (semaine)",
	"datacenter-filter.gross-in-transit-details": "Détails en transit (Brut, t)",
	"datacenter-filter.gross-last-batch": "Dernier lot en stock (semaine)",
	"datacenter-filter.heat-number": "Numéro de coulée",
	"datacenter-filter.hts-code": "hts code",
	"datacenter-filter.incoterm2": "Incoterm 2 ",
	"datacenter-filter.internal-diameter": "Internal Diameter",
	"datacenter-filter.interpretation-delivery-date": "Date de livraison",
	"datacenter-filter.invalid-number": "Numéro non valide",
	"datacenter-filter.item-sold-to-party": "Article donneur d'ordre",
	"datacenter-filter.last-name": "Nom",
	"datacenter-filter.length": "Longueur (m)",
	"datacenter-filter.loading-program-number": "Loading program number",
	"datacenter-filter.material-not-avilable": "Material not available",
	"datacenter-filter.materialAvailability": "Material Availability",
	"datacenter-filter.mill": "Usine",
	"datacenter-filter.mill-order-number": "Numéro de commande usine",
	"datacenter-filter.net-consignment": "Consignation. (Net, t)",
	"datacenter-filter.net-in-transit": "En transit (Net, t)",
	"datacenter-filter.net-in-transit-details": "Détails en transit (Net, t)",
	"datacenter-filter.net-ready-to-ship": "Disponible (Net, t)",
	"datacenter-filter.nominal-gloss-bottom-side": "Brillance nominale côté inférieur",
	"datacenter-filter.nominal-gloss-top-side": "Brillance nominale côté supérieur",
	"datacenter-filter.oil-reference": "Oil Reference",
	"datacenter-filter.order-created-by": "Order created by",
	"datacenter-filter.order-creator": "Order creator",
	"datacenter-filter.order-item-status": "Statut poste de commande",
	"datacenter-filter.order-reason": "Motif de commande",
	"datacenter-filter.organic-structure-bottom-side": "Structure revêt.org.face inf",
	"datacenter-filter.organic-structure-top-side": "Structure revêt.org.face sup",
	"datacenter-filter.organization-city": "Ville",
	"datacenter-filter.organization-id": "ID de l'organisation",
	"datacenter-filter.organization-name": "Nom de l'organisation",
	"datacenter-filter.organization-role": "Rôle",
	"datacenter-filter.organization-service": "Service de l'organisation",
	"datacenter-filter.organization-status": "Statut de l'organisation",
	"datacenter-filter.organization-suppliers": "Fournisseurs de l'organisation",
	"datacenter-filter.organization-type": "Type d'organisation",
	"datacenter-filter.package-serial-number": "Numéro de série du colis",
	"datacenter-filter.paint-marking-for-sh": "Paint Marking (for SH)",
	"datacenter-filter.pattern-for-sh": "Pattern (for SH)",
	"datacenter-filter.planned-shipment-date": "Date de chargement prévue",
	"datacenter-filter.ponumber": "PO Number",
	"datacenter-filter.price-unit": "Price unit",
	"datacenter-filter.produced-length-dimension": "Actual length",
	"datacenter-filter.producedDimension": "Dim produite",
	"datacenter-filter.producedLength": "Longueur produite (m)",
	"datacenter-filter.producedThickness": "Épaisseur produite (mm)",
	"datacenter-filter.producedWidth": "Largeur produite (mm)",
	"datacenter-filter.product-category": "Catégorie de produit",
	"datacenter-filter.product-description": "Description du produit",
	"datacenter-filter.proposed-coating": "Proposed coating",
	"datacenter-filter.proposed-inner-diameter": "Proposed inner diameter",
	"datacenter-filter.proposed-length": "Proposed length",
	"datacenter-filter.proposed-oiling": "Proposed oiling",
	"datacenter-filter.proposed-outside-diameter": "Proposed outer diameter",
	"datacenter-filter.proposed-packing": "Proposed packaging",
	"datacenter-filter.proposed-quantity": "Proposed quantity",
	"datacenter-filter.proposed-steelgrade": "Proposed steel grade",
	"datacenter-filter.proposed-thickness": "Proposed thickness",
	"datacenter-filter.proposed-unit": "Proposed quantity unit",
	"datacenter-filter.proposed-weight": "Proposed sheet weight",
	"datacenter-filter.proposed-width": "Proposed width",
	"datacenter-filter.protection": "Protection",
	"datacenter-filter.proto-name": "Prototype name",
	"datacenter-filter.proto-status": "Prototype status",
	"datacenter-filter.provisional-firm-item": "Article prévisonnel/ferme",
	"datacenter-filter.quantity-unit": "Quantity Unit",
	"datacenter-filter.rdd": "RDD (Semaine)",
	"datacenter-filter.rdd-date": "RDD ",
	"datacenter-filter.rdd-week": "RDD (week)",
	"datacenter-filter.ready-to-ship-date": "Date available for dispatch",
	"datacenter-filter.readyForDispatch": "Ready for dispatch at PO receipt (week)",
	"datacenter-filter.req-desc": "Request Description",
	"datacenter-filter.sales-quarter": "Trimestre de vente",
	"datacenter-filter.service-level": "Niveau de service",
	"datacenter-filter.service-request": "Demande de service",
	"datacenter-filter.ship-to": "Expédié à",
	"datacenter-filter.ship-to-address": "Delivery address",
	"datacenter-filter.shipment-reference-date": "Dispatch date",
	"datacenter-filter.shipping-date": "Shipping date",
	"datacenter-filter.shipping-week": "Expected shipping week",
	"datacenter-filter.sold-to": "Client",
	"datacenter-filter.special-stock-partner": "Stock partner",
	"datacenter-filter.spot-or-schedule": "Spot ou flux",
	"datacenter-filter.standard": "Standard",
	"datacenter-filter.standard-steel-grade": "Nuance(s) d'acier",
	"datacenter-filter.steeluser-order-number": "Référence de la commande eBusiness",
	"datacenter-filter.stockist": "Stockist",
	"datacenter-filter.supplier-rfq": "SupplierRfqNumber",
	"datacenter-filter.surface": "Surface",
	"datacenter-filter.thickness": "Épaisseur (mm)",
	"datacenter-filter.total-thickness-coating-bottom": "Epaisseur revêtement organique inférieur (G/M2)",
	"datacenter-filter.total-thickness-coating-top": "Epaisseur revêtement organique supérieur (G/M2)",
	"datacenter-filter.trademark-name-bottom-side": "Type de peinture côté inférieur",
	"datacenter-filter.trademark-name-top-side": "Type de peinture côté supérieur",
	"datacenter-filter.transport-mode": "mode de transport",
	"datacenter-filter.transport-mode-n1": "N-1 mode de transport",
	"datacenter-filter.transport-mode-n2": "N-2 mode de transport",
	"datacenter-filter.transport-reference": "N° de transport",
	"datacenter-filter.transport-reference-n1": "N-1 N° de transport",
	"datacenter-filter.transport-reference-n2": "N-2 N° de transport",
	"datacenter-filter.transportRef": "Transport reference",
	"datacenter-filter.ultrasonic-testing": "Ultrasonic Testing",
	"datacenter-filter.user-creation-date": "Date de création",
	"datacenter-filter.user-email": "E-mail",
	"datacenter-filter.user-first-name": "Prénom",
	"datacenter-filter.user-id": "ID",
	"datacenter-filter.user-last-name": "Nom",
	"datacenter-filter.user-organization-name": "Nom de l'organisation",
	"datacenter-filter.user-role": "Rôle",
	"datacenter-filter.user-status": "Statut",
	"datacenter-filter.users-city": "Ville",
	"datacenter-filter.users-countrycode": "Code du pays",
	"datacenter-filter.width": "Largeur (mm)",
	"datacenter-filter.z-test-certificat": "Z-test Certificat",
	"datacenter-shipment.batch": "Lot",
	"datacenter-shipment.customer": "Client",
	"datacenter-shipment.customer-article-reference": "Référence article client",
	"datacenter-shipment.customer-order-number": "Numéro de commande client",
	"datacenter-shipment.date-available-for-dispatch": "Date de disponibilité pour expédition",
	"datacenter-shipment.dispatch-advice-date": "Date de l'avis d'expédition",
	"datacenter-shipment.dispatch-advice-number": "Numéro de l'avis d'expédition",
	"datacenter-shipment.grade": "Nuance(s) d'acier",
	"datacenter-shipment.gross-weight": "Poids brut (t)",
	"datacenter-shipment.mill": "Usine",
	"datacenter-shipment.net-weight": "Poids net (t)",
	"datacenter-shipment.ship-to": "Expédié à",
	"datacenter-shipment.shipment-quantity-gross": "Quantité expédiée (Brut, t)",
	"datacenter-shipment.shipment-quantity-net": "Quantité expédiée (Net, t)",
	"datacenter-shipment.supplier-order-number": "Numéro de commande fournisseur",
	"datacenter-shipment.thickness": "Épaisseur (mm)",
	"datacenter-shipment.transport-mode": "Mode de transport",
	"datacenter-shipment.transport-reference": "N° de transport",
	"datacenter-shipment.width": "Largeur (mm)",
	"datacenter.add-columns": "Ajouter des colonnes",
	"datacenter.all": "Tout",
	"datacenter.all-columns-added-to-grid": "Toutes les colonnes sont ajoutées à la disposition.",
	"datacenter.all-data-center": "Tous les centres de données",
	"datacenter.annealed": "Recuit",
	"datacenter.apply": "Appliquer",
	"datacenter.aqdb": "eAQDB",
	"datacenter.aqdb-view": "Data center: eAQDB",
	"datacenter.at-reshipper-gross": "Chez le réexpéditeur (Brut, t)",
	"datacenter.at-reshipper-net": "Chez le réexpéditeur (Net, t)",
	"datacenter.balanced-not-produced": "Solde non produit",
	"datacenter.batch": "Colis",
	"datacenter.batches": "Centre de données: Colis",
	"datacenter.calloff": "Centre de données : eCall-off",
	"datacenter.calloff-by-batch": "eCall-off par produit",
	"datacenter.calloff-by-volume": "eCall-off par volume",
	"datacenter.cancel": "Annuler",
	"datacenter.click-on-items-on-the-right": "Cliquez sur les articles à droite pour ajouter un filtre",
	"datacenter.cold-rolled": "Laminé à froid",
	"datacenter.columns": "Colonnes",
	"datacenter.commercial-documents": "Centre de données : Documents commerciaux",
	"datacenter.composite": "Composite",
	"datacenter.create-new-view": "Créer une nouvelle disposition",
	"datacenter.current-layout": "Disposition actuelle",
	"datacenter.customize-view": "Personnaliser la disposition",
	"datacenter.cutting-beveling": "Decoupe et chanfreinage",
	"datacenter.data-center": "Centre de données",
	"datacenter.data-center-shipments": "Centre de données : Expéditions",
	"datacenter.default": "Vue par défaut",
	"datacenter.delete": "Supprimer",
	"datacenter.do-you-want-remove": "Voulez-vous supprimer la disposition",
	"datacenter.document": "Documents commerciaux",
	"datacenter.documents": "Documents",
	"datacenter.download-invoice": "Télécharger la facture",
	"datacenter.drag-and-drop-item-hint": "Faire glisser et déposer un article pour ajouter ou supprimer une colonne",
	"datacenter.drag-element-here-fixed": "Faire glisser ici pour ajouter des colonnes fixes.",
	"datacenter.drag-element-here-hide": "Faire glisser un élément ici pour masquer les colonnes sur la grille.",
	"datacenter.drag-element-here-scrollable": "Faire glisser ici pour ajouter des colonnes déroulantes.",
	"datacenter.edit-view": "Modifier la disposition",
	"datacenter.favorite.added": "View added to favorites",
	"datacenter.favorite.max-reached": "Maximum number of favorites reached. Remove an existing favorite before adding a new one.",
	"datacenter.favorite.removed": "View removed from favorites",
	"datacenter.favorite.update-error": "Unable to update favorite status",
	"datacenter.filter.clear": "Clear",
	"datacenter.filters": "Filtres",
	"datacenter.fixed-columns": "Colonnes fixes",
	"datacenter.fixed-columns-scrollable": "Fixed columns (10 maximum)",
	"datacenter.graph.first-bar-label": "≤ 30 jours",
	"datacenter.graph.fourth-bar-label": "Au-dessus + 90 jours",
	"datacenter.graph.second-bar-label": "31 - 60 jours",
	"datacenter.graph.third-bar-label": "61 - 90 jours",
	"datacenter.guarantee": "Centre de données : Garantie",
	"datacenter.handed-over-to-planning": "En planification",
	"datacenter.hot-rolled": "Laminé à Chau",
	"datacenter.in-transit-gross": "En transit (Brut, t)",
	"datacenter.in-transit-to-customer-gross": "En transit vers le client (Brut, t)",
	"datacenter.in-transit-to-customer-net": "En transit vers le client (Net, t)",
	"datacenter.land-transit-gross": "Transit terrestre (Brut, t)",
	"datacenter.land-transit-net": "Transit terrestre (Net, t)",
	"datacenter.layout": "Disposition",
	"datacenter.layout-sorting": "Disposition et tri",
	"datacenter.metallic-coated": "Revêtement métallique",
	"datacenter.minimal-quantity-for-this-item-is": "La quantité minimale pour cet article est de",
	"datacenter.name-your-new-layout": "Nommez votre nouvelle mise en page",
	"datacenter.nb-days-in-stock": "Nbr de jours en stock",
	"datacenter.net-qty-delivered": "Livré (net, t)",
	"datacenter.net-qty-not-delivered": "Not Delivered (Net, t)",
	"datacenter.normalizing": "Normalisation",
	"datacenter.offer": "Offres",
	"datacenter.offer.subcategory": "Sous-catégorie",
	"datacenter.offers": "Centre de données : lignes d'offres",
	"datacenter.on-vessel-gross": "Sur navire (Brut, t)",
	"datacenter.on-vessel-net": "Sur navire (Net, t)",
	"datacenter.open-needs": "Besoins ouverts",
	"datacenter.or-save-as-a-new-view": "Ou enregistrer comme nouvelle mise en page",
	"datacenter.order": "Commandes",
	"datacenter.ordered": "Commandé (t)",
	"datacenter.orders": "Centre de données: Commandes",
	"datacenter.organic-coated": "Revêtu organique",
	"datacenter.organization": "Organisations",
	"datacenter.organizations": "Centre de données : Organisations",
	"datacenter.overseas-transit-gross": "Transit outre-mer (Brut, t)",
	"datacenter.overseas-transit-net": "Transit outre-mer (Net, t)",
	"datacenter.oxi-cutting": "Oxycoupage",
	"datacenter.packing": "Emballage",
	"datacenter.pickled": "Décapé",
	"datacenter.planned-casting": "Coulée planifiée",
	"datacenter.prematerial-ordered": "Pré-matériel commandé",
	"datacenter.prototypes": "Centre de données : Prototypes",
	"datacenter.qty-delivered": "Livré (brut, t)",
	"datacenter.qty-gross": "Brut (t)",
	"datacenter.qty-in-production": "WIP (t)",
	"datacenter.qty-in-transit": "En transit (t)",
	"datacenter.qty-net": "Net (t)",
	"datacenter.qty-not-delivered": "Not Delivered (Gross, t)",
	"datacenter.qty-ordered": "Cde (t)",
	"datacenter.qty-ready-to-ship": "Prêt à l'expédition",
	"datacenter.quality": "Qualité",
	"datacenter.quality-control": "Contrôle de qualité (tonnes)",
	"datacenter.quality-issues": "Centre de données: Litiges",
	"datacenter.requested-quantity-is-greater-than-the-maximum-value": "La quantité demandée est supérieure à la valeur maximale",
	"datacenter.reset-all-filters": "Réinitialiser tous les filtres",
	"datacenter.result": "1 résultat",
	"datacenter.results": "résultats {{value}}",
	"datacenter.rolling-stand": "Support roulant",
	"datacenter.rts-gross": "Disponible (Brut, t)",
	"datacenter.save": "Enregistrer",
	"datacenter.save-as": "Enregistrer en tant que...",
	"datacenter.save-changes-in-the-view": "Enregistrer les modifications de la disposition",
	"datacenter.save-new-layout-as": "Enregistrer la nouvelle disposition en tant que...",
	"datacenter.save-new-view": "Enregistrer la nouvelle disposition",
	"datacenter.save-the-view": "Enregistrer la disposition",
	"datacenter.schedule-business-order": "Commandes à flux",
	"datacenter.schedule-business-orders": "Données: Commandes à flux",
	"datacenter.scrollable-columns": "Colonnes déroulantes",
	"datacenter.select-a-view": "Sélectionner une disposition",
	"datacenter.selected": " ({{value}} sélectionné(s))",
	"datacenter.shipment": "Expéditions",
	"datacenter.shot-blasting": "Grenaillage",
	"datacenter.skin-pass": "Skin-pass",
	"datacenter.slab": "Brame",
	"datacenter.slitting": "Refendage",
	"datacenter.sorting": "Tri",
	"datacenter.stock-blocked-gross": "Stock blocked (Gross, t)",
	"datacenter.stock-blocked-net": "Stock blocked (Net, t)",
	"datacenter.total": "Total",
	"datacenter.users": "Centre de données : Utilisateurs",
	"datacenter.view-load-error": "Impossible de charger les données de la disposition",
	"datacenter.view-name": "Nom de la vue",
	"datacenter.view-name.duplicate.error": "A view with the name '{{viewName}}' already exists. Please choose a different name.",
	"datacenter.view-name.error": "le nom de la mise en page doit être unique",
	"datacenter.view-not-found": "View '{{viewName}}' not found",
	"datacenter.view.add-filters": "Ajouter des filtres",
	"datacenter.you-have-too-many-fixed-columns-to-add-a-new-one": "Vous avez trop de colonnes fixes pour en ajouter une nouvelle",
	"datacenter.you-have-too-many-scroll-columns-to-add-a-new-one": "You have too many scrollable columns to add a new one",
	"datacenterview.Certificate": "Certificat",
	"datacenterview.DispatchAdvice": "Avis d'expédition",
	"datacenterview.Invoice": "Factures",
	"datacenterview.OrderAcknowledgment": "Confirmation de commande",
	"defect.CDCUS00A": "Dimensions",
	"defect.CDCUS00B": "Poids",
	"defect.CDCUS00C": "Aspect de surface",
	"defect.CDCUS00D": "Problème de revêtement",
	"defect.CDCUS00E": "Soudures",
	"defect.CDCUS00F": "Rouille",
	"defect.CDCUS00G": "Planéité",
	"defect.CDCUS00H": "Analyse propriété chimique / mécanique",
	"defect.CDCUS00I": "Problèmes lors du traitement du métal",
	"defect.CDCUS00J": "Emballage",
	"defect.CDCUS00K": "Heure de livraison",
	"defect.CDCUS00L": "Transport",
	"defect.CDCUS00M": "Erreur d'étiquette",
	"defect.Z/CDCUS00A/0600": "Dimensions",
	"defect.Z/CDCUS00B/0100": "Poids de la bobine",
	"defect.Z/CDCUS00B/0200": "Quantité expédiée (trop/pas assez, différence avec la quantité facturée...)",
	"defect.Z/CDCUS00C/0400": "Rouille et oxydation",
	"defect.Z/CDCUS00C/1400": "Aspect de surface",
	"defect.Z/CDCUS00D/0500": "Problème de revêtement",
	"defect.Z/CDCUS00E/0400": "Soudures",
	"defect.Z/CDCUS00F/0400": "Protection de la surface (lubrifiant, film...)",
	"defect.Z/CDCUS00G/0700": "Planéité",
	"defect.Z/CDCUS00H/0600": "Qualité (propriétés mécaniques, analyse chimique...)",
	"defect.Z/CDCUS00I/0600": "Traitement en cours",
	"defect.Z/CDCUS00J/0900": "Présentation (emballage, étiquette, enroulement...)",
	"defect.Z/CDCUS00K/0300": "Heure de livraison",
	"defect.Z/CDCUS00L/0100": "Erreur de transport (adresse, mode)",
	"defect.Z/CDCUS00L/0600": "Dégâts lors du transport",
	"defect.Z/CDCUS00M/0300": "Documentation technique (certificats, description du produit, connaissement...)",
	"delete.draft": "Annuler votre brouillon",
	"delete.only-administrator": "Il n'est pas possible de supprimer cet utilisateur car il n'y a pas d'autre utilisateur dans l'entreprise.",
	"delivery-tracking.at-overseas-stock": "Stock à l'étranger",
	"delivery-tracking.delivery-follow-up": "Suivi de l'expédition",
	"delivery-tracking.in-land-transit": "En transit sur le territoire",
	"delivery-tracking.in-overseas-transit": "En transit à l'international",
	"delivery-tracking.in-transit-to-customer": "En transit à destination client",
	"delivery-tracking.order-and-delivery-overview": "Aperçu commandes et livraisons",
	"delivery-tracking.stock-per-mill": "Stock par usine",
	"delivery-tracking.to-reshipper-in-land-transit-to-warehouse": "Vers réexpéditeur / En transit terrestre / Vers l'entrepôt",
	"delivery-tracking.total": "Total",
	"delivery-tracking.view-details": "Voir les détails",
	"delivery.status.late": "Retardé",
	"delivery.status.on-customer-time": "En temps voulu client",
	"delivery.status.on-supplier-time": "En temps voulu fournisseur",
	"delivery.status.on-time": "À l'heure",
	"dialog-upload-file": "Merci d’uploader un fichier",
	"dialog.all-column-added-to-grid": "Toutes les colonnes sont ajoutées à la disposition.",
	"dialog.apply": "Appliquer",
	"dialog.customize.view.title": "Choisissez les colonnes par un simple glisser-déposer",
	"dialog.delete.description": "Voulez-vous vraiment supprimer cet utilisateur",
	"dialog.delete.title": "Supprimer l'utilisateur",
	"dialog.drag-elements-here-hide": "Glissez les éléments à cacher dans la disposition",
	"dialog.drag-elements-here-scrollable": "Glissez ici les colonnes à ajouter à la disposition",
	"dialog.loose-data-message": "Cette action supprimera toutes vos données. Souhaitez-vous continuer ?",
	"dialog.select.batch": "Sélectionner le lot",
	"doc-ce-subtype.01": "2.1 : Déclaration de conformité avec la commande",
	"doc-ce-subtype.02": "2.1: Declaration of compliance with the order",
	"doc-ce-subtype.17": "3.1 : Certificat d'inspection 3.1",
	"doc-ce-subtype.51": "2.2 : Rapport d'essai",
	"doc-ce-subtype.52": "3.2 : Certificat d'inspection 3.2",
	"doc-ce-subtype.car": "Chemical Analysis Report",
	"doc-ce-subtype.cconf": "Certificat de conformité",
	"doc-ce-subtype.ccpu": "Certificat d'essai",
	"doc-ce-subtype.cem": "Marquage CE",
	"doc-ce-subtype.ceran": "Certification d'essai 2.2 Analyse chimique",
	"doc-ce-subtype.cerre": "Certificat de réception",
	"doc-ce-subtype.cerus": "Certificat de réception",
	"doc-ce-subtype.cinsp": "Certificat d'inspection 3.2",
	"doc-ce-subtype.ctl": "Rapport d'inspection",
	"doc-ce-subtype.fcp": "feuille caractéristiques du produit",
	"doc-ce-subtype.ohsas": "Rapport de sécurité",
	"doc-in-subtype.AVOIR": "Note de crédit",
	"doc-in-subtype.DEBIT": "Lettre de débit",
	"doc-in-subtype.FACTU": "Facture",
	"doc-oa-subtype.N": "Modification",
	"doc-oa-subtype.O": "Original",
	"doc-xcarb-subtype.a": "Green Steel Certificate",
	"doc-xcarb-subtype.b": "Recycled and renewably produced",
	"doc-xcarb-subtype.c": "EcoSheetPilePlus",
	"doc-xcarb-subtype.d": "Steel Certificate",
	"doc-xcarb-subtype.e": "Steel certificate (factor:0.7)",
	"doc-xcarb-subtype.f": "Steel certificate (factor:1.0)",
	"doc-xcarb-subtype.g": "Steel certificate Integral",
	"doc-xcarb.amount": "Amount",
	"doc-xcarb.endquarter": "End quarter",
	"doc-xcarb.rrpDownloadLink": "RRP link",
	"doc-xcarb.rrpType": "RRP type",
	"document-card.data-not-found": "Document data not found",
	"download-detailed-report": "Download detailed report",
	"download.pdf-files": "Télécharger en fichiers PDF",
	"draft.creationdate": "Date de ",
	"draft.deleted.successfully": "Votre proposition d'offre a été supprimée",
	"draft.lastupdate": "Dernière mis à jour",
	"draft.selected.product": "Produit sélectionné",
	"draft.total.tons": "Total tonnage",
	"draft.value": "BROUILLON",
	"draftoffer.list": "Liste provisoire",
	"draftorder.list": "liste brouillon",
	"drafts.all.drafts": "Tous les brouillons",
	"drafts.has.been.deleted": "Le brouillon a été supprimé",
	"drafts.my.drafts": "Mes brouillons",
	"drafts.no.draft": "Aucun brouillon",
	"drafts.saved": "brouillons enregistrés",
	"drafts.search.drafts": "Recherche de brouillons",
	"drafts.sort.by.modification": "Trier par modification",
	"drafts.sort.by.reference": "Trier par référence",
	"drag.and.drop.files": "Glisser-déposer",
	"ecall-comment-grid": "Comment",
	"ecall-off-batch-cancellation-date": "Cancelled Date",
	"ecall-off-call-creater": "eCall-off creator",
	"ecall-off-card-gross-quantity": "Gross Quantity",
	"ecall-off-card-net-quantity": "Net Quantity",
	"ecall-off-creation-date": "Creation date",
	"ecall-off-information-box": "eCall-off information",
	"ecall-off.all-batches": "Tous les lots",
	"ecall-off.apply-for-all": "Appliquer pour tous",
	"ecall-off.batch": "lot",
	"ecall-off.batches": "lots",
	"ecall-off.call-off": "eCall-off",
	"ecall-off.call-off-by-batch": "eCall-off par produit",
	"ecall-off.call-off-by-volume": "eCall-off par volume",
	"ecall-off.call-off-date": "Date d'eCall-off",
	"ecall-off.call-off-follow-up": "Suivi des eCall-off",
	"ecall-off.call-off-header-information": "Informations d'en-tête d'eCall-off",
	"ecall-off.call-off-request": "Demande de eCall-off",
	"ecall-off.callable-weight": "Matériel total disponible (To)",
	"ecall-off.called-batches": "Lots appelés",
	"ecall-off.called-order-items": "Articles de commande appelés",
	"ecall-off.called-volume": "Volume appelé (To)",
	"ecall-off.canceled": "Cancelled date",
	"ecall-off.change-mills": "Changemer l'usine",
	"ecall-off.choose-batches": "Choisissez les lots que vous souhaitez annuler",
	"ecall-off.choose-order-items": "Choisissez les articles de commande que vous souhaitez annuler",
	"ecall-off.closed-or-called": "Called",
	"ecall-off.comment_instruction": "Please fill in this field only if the eCall-off does not follow the standard process. Kindly, do not include messages such as “urgent”, “asap”, “thanks”, or similar. This field is intended only for exceptions to the normal flow.",
	"ecall-off.comment_placeholder": "This field should only be filled in if the eCall-off deviates from the standard flow and the information provided is new and not yet recorded elsewhere.",
	"ecall-off.copy-to": "Copier vers",
	"ecall-off.customer-call-off-reference": "Référence d'eCall-off",
	"ecall-off.do-you-really-want-to-change-mills": "Voulez-vous vraiment changer l'usine ?",
	"ecall-off.ecall-card": "Carte d'eCall-off",
	"ecall-off.exception": "Exception remark",
	"ecall-off.followup": "You will be able to view it in your My eCall-offs.",
	"ecall-off.information-entry": "Entrée des informations d'eCall-off",
	"ecall-off.last-call-off-demand": "Dernière demande d'eCall-off",
	"ecall-off.material-picking": "Choix du matériel",
	"ecall-off.max": "Net {{value}}",
	"ecall-off.mill-section": "Sélection de l'usine",
	"ecall-off.my-ecalls": "Mes eCall-offs",
	"ecall-off.no-batches-found": "Aucun lot trouvé",
	"ecall-off.no-mills": "Il n'existe aucune usine avec lots exigibles",
	"ecall-off.no-selected-batches": "aucun lot sélectionné",
	"ecall-off.open-or-callable": "Callable",
	"ecall-off.order-items": "articles de commande",
	"ecall-off.personnalize-your-call-off-informations": "Personnaliser vos informations d'eCall-off",
	"ecall-off.rdd-mode": "Mode RDDC",
	"ecall-off.ready-to-call": "Vos {{objects}} prêts pour un appel",
	"ecall-off.requested-date": "Date demandée",
	"ecall-off.requested-date-weekend-warning": "The selected requested delivery date falls on a weekend",
	"ecall-off.requested-ship-to": "Requested Ship To",
	"ecall-off.required": "requis",
	"ecall-off.see-card": "Voir la carte",
	"ecall-off.select-a-mill": "Sélectionnez une usine pour consulter votre matériel prêt pour l'expédition",
	"ecall-off.select-your-mill": "Sélectionnez votre usine",
	"ecall-off.selected": "{{value}} sélectionné(s)",
	"ecall-off.selected-batches": "{{value}} lots sélectionnés",
	"ecall-off.selected-batches-only": "Lots sélectionnés uniquement",
	"ecall-off.selected-only": "Sélectionné(s) uniquement",
	"ecall-off.selection-will-be-rest": "La sélection sera réinitialisée",
	"ecall-off.separate-email-addresses": "Veuillez séparer les adresses e-mail par un « ; » (point-virgule)",
	"ecall-off.ship-to": "Ship To",
	"ecall-off.start-a-new-call-off": "DEMANDER UNE NOUVELLE ECALL-OFF",
	"ecall-off.submit-call-off": "Envoyer votre demande d'eCall-off",
	"ecall-off.submitted.successfully": "Your eCall-off {{value}} has been submitted successfully.",
	"ecall-off.summary": "Résumé d'eCall-off",
	"ecall-off.supplier-call-off-reference": "Supplier eCall-off reference",
	"ecall-off.the": "Le(s)",
	"ecall-off.tons": "Tonnes",
	"ecall-off.total-called-weight": "Poids total appelé",
	"ecall-off.total-material-request": "Demande totale de matériel",
	"ecall-off.type-your-comment": "Saisissez votre commentaire",
	"ecall-off.type-your-exception": "Type your exception remark",
	"ecall-off.unloading-reference": "Référence de déchargement",
	"ecall-off.view-batch-card": "Voir la carte de lot",
	"ecall-off.your-batches-ready-to-call": "Vos lots prêts à être appelés",
	"ecall-requested-deliverydate-from-grid": "Requested date from",
	"ecall-requested-deliverydate-to-grid": "Requested date to",
	"ecall-total-volume-called": "Total volume called",
	"ecall.batch.callCreator": "eCall-off creator",
	"ecall.exct-date-error": "You cannot choose exact date for the selected batches",
	"ecall.row.creation.date": "eCall-off creation date",
	"ecall.searchfield.extendable": "Quick search...",
	"edit.draft": "Modifier les brouillons",
	"efeasibility-disclaimer": "While care has been taken regarding the available information about quality or usability of our materials, it only serves as a description. All notices, advices, recommendations, calculations and, more generally, any information you have access from Steel User are given for your guidance, within the framework of a best effort undertaking, and on the basis of our experience and the state of our last knowledge. However, any industrial application/order/implementation based on such content shall have to be validated by your usual contact at ArcelorMittal Group.",
	"efeasibility-disclaimer.end": "ArcelorMittal Group accepts no responsibility or liability for any errors or information which is found to be misleading.  The use of the information contained herein is at the user’s risk and no warranty is implied or expressed by ArcelorMittal Group with respect to the use of the information.\n",
	"efeasibility.excel.file.name": "Feasibility",
	"efeasibility.excel.template": "Get excel template",
	"efeasibility.template.error": "Please upload a file which follows the template provided by SteelUser application",
	"efeasibility.template.product.category.validation": "Product category is mandatory and must be one of the available values. Refer template for values.",
	"efeasibility.template.product.sub.category.validation": "Product sub category is mandatory and must be one of the available values. Refer template for values.",
	"efeasibility.template.soldtoname.validation": "Customer name is mandatory and must be one of the available values. Refer template for values.",
	"efeasibility.template.standard.steelgrade.validation": "Standard steelgrade is mandatory and must be one of the available values. Refer template for values.",
	"efeasibility.template.steelgrade.validation": "Steelgrade is mandatory and must be one of the available values. Refer template for values.",
	"elink.add.attachment": "Ajouter une pièce jointe",
	"elink.category": "Catégorie",
	"elink.comment": "Commentaire*",
	"elink.comment-is-required": "Un commentaire est requis",
	"elink.contact-mill": "Contacter l'usine",
	"elink.copy-to": "Copier vers",
	"elink.data-automatically-sent-with-the-mail": "Données envoyées automatiquement par e-mail",
	"elink.delete": "Supprimer",
	"elink.dimension": "Dimensions (mm)",
	"elink.from": "Depuis",
	"elink.invalid-email-format": "Format d'adresse e-mail invalide",
	"elink.message": "Message",
	"elink.send": "Envoyer",
	"elink.subject": "Sujet",
	"email-message": "Email has been sent to confirm your new mail address",
	"end.date": "Date de fin",
	"eoffer-From.month": "Du mois",
	"eoffer-Period.label": "Période",
	"eoffer-Period.type": "Type de période",
	"eoffer-Period.type.custom": "Pour un intervalle personnalisé",
	"eoffer-Period.type.month": "Pour un intervalle en mois",
	"eoffer-Period.type.quarter": "Pour un intervalle en trimestre",
	"eoffer-Period.type.semester": "Pour un intervalle en semestre",
	"eoffer-Period.type.year": "Pour un intervalle en année",
	"eoffer-Quarter": "Trimestre",
	"eoffer-Semester": "Semestre",
	"eoffer-To.month": "Au mois",
	"eoffer-selected.period": "Période sélectionnée",
	"eoffer.Choose.the.split.of.quantities.by": "Choisissez la répartition des quantités par",
	"eoffer.accepted": "Accepté",
	"eoffer.action.default": "Par défaut",
	"eoffer.action.delete": "Supprimer",
	"eoffer.action.duplicate": "Dupliquer",
	"eoffer.action.new": "Nouveau",
	"eoffer.action.new.request": "Demande",
	"eoffer.action.new.request.for-a-new": "pour une nouvelle offre",
	"eoffer.additional.fields": "Caractéristiques supplémentaires",
	"eoffer.assistant": "Contact commercial (assistant)",
	"eoffer.available.fields": "Caractéristiques disponibles",
	"eoffer.cancel": "Annuler",
	"eoffer.cart.finalise": "Finalisez votre panier",
	"eoffer.cart.input.request": "Indiquez la quantité demandée, la date de livraison et d'autres informations",
	"eoffer.cart.volume.request": "Volume demandé",
	"eoffer.choose.split.quantities.error": "Veuillez choisir la répartition des quantités",
	"eoffer.choose.split.quantity.error": "Veuillez choisir la répartition des quantités",
	"eoffer.cockpit": "Cockpit eOffer",
	"eoffer.comment": "Commentaire",
	"eoffer.comment.product.is": "Laissez un commentaire pour ce produit",
	"eoffer.confirm.thanks": "Merci, nous avons bien reçu votre demande.",
	"eoffer.continue": "Continuer",
	"eoffer.continue.draft": "Continuer ce brouillon",
	"eoffer.create.enduser": "Utilisateur final",
	"eoffer.currency": "Devise",
	"eoffer.current.step": "Étape actuelle",
	"eoffer.customer": "Client",
	"eoffer.datacenter.offerLines": "Centre de données: lignes d'offre",
	"eoffer.delivery.date": "Date de livraison",
	"eoffer.dialog.clear.products": "Si vous modifiez l'adresse du client ou de livraison ou l'utilisateur final, les produits du panier seront perdus. Voulez-vous continuer?",
	"eoffer.dialog.month": "Mois",
	"eoffer.dialog.monthweek": "Mois ou semaine",
	"eoffer.dialog.offer.remove.product": "Enlever le produit sélectionné, voulez-vous continuer?",
	"eoffer.dialog.offer.submission.error": "Erreur lors de la soumission de l'offre",
	"eoffer.dialog.pdm": "Usine de livraison préférée",
	"eoffer.dialog.period": "Choisissez votre période",
	"eoffer.dialog.quantity": "Quantité",
	"eoffer.dialog.requested.delivery.time": "Sélectionnez le délai de livraison souhaité",
	"eoffer.dialog.reset.requested.delivery.time": "Modifiez la période et réinitialisez les délais de livraison demandés, voulez-vous continuer ?",
	"eoffer.dialog.week": "Semaine",
	"eoffer.dialog.year": "Année",
	"eoffer.dimension.mm": "Dimensions (mm)",
	"eoffer.draft": "Brouillon",
	"eoffer.draft.edit.message.line": "pour soumission à ArcelorMittal ou suppression.",
	"eoffer.draft.edit.message.text": "Vous pouvez effectuer une modification ultérieure dans",
	"eoffer.draft.list.link": "votre liste de brouillons",
	"eoffer.draft.saved.successfully": "Votre demande d'offre a bien été enregistrée comme brouillon",
	"eoffer.drafts": "Brouillons",
	"eoffer.enduser": "Utilisateur final",
	"eoffer.entry": "Saisie de l'offre",
	"eoffer.error.loading": "Impossible de charger les valeurs des paramètres",
	"eoffer.error.noenduser": "Sold-to {{value}} sans utilisateur final",
	"eoffer.error.noshipto": "Sold-to {{value}} sans ship-to",
	"eoffer.error.noshiptoenduser": "Sold-to {{value}} sans ship-to et sans utilisateur final",
	"eoffer.error.nosoldto": "Sold-to non trouvé",
	"eoffer.feasibility": "Faisabilité",
	"eoffer.feasibility.no": "Refusé",
	"eoffer.feasibility.pending": "Demande de faisabilité en cours",
	"eoffer.feasibility.yes": "OK",
	"eoffer.field": "Caractéristique",
	"eoffer.form": "Forme",
	"eoffer.header.commercial.contacts": "CONTACTS COMMERCIAUX",
	"eoffer.header.commitment.period": "Période d'engagement :",
	"eoffer.header.custOffNumber": "Référence de l'offre client",
	"eoffer.header.customer": "client",
	"eoffer.header.entity.information": "Informations sur les entités",
	"eoffer.header.last.update.date": "Date de dernière mise à jour",
	"eoffer.header.offer.name": "Nom de l'offre",
	"eoffer.header.offer.validity.date": "Date de validité de l'offre :",
	"eoffer.header.suppOffNumber": "Référence offre fournisseur",
	"eoffer.header.technical.contacts": "CONTACTS TECHNIQUES",
	"eoffer.header.terms.information": "Informations sur les conditions",
	"eoffer.header.total": "Total",
	"eoffer.home": "eOffre",
	"eoffer.home.active": "Offres",
	"eoffer.home.cockpit": "Mon cockpit eOffer",
	"eoffer.home.request": "Nouveau",
	"eoffer.home.tool": "Demander une offre",
	"eoffer.idd.not.found": "Paramètres IDD non trouvés",
	"eoffer.in.calculation": "Calcul en-cours",
	"eoffer.incot.not.found": "Paramètres Incoterm non trouvés",
	"eoffer.incoterms": "Incoterms",
	"eoffer.interpretation.delivery.date": "Date de livraison",
	"eoffer.mandatory.currency.reference": "La devise est obligatoire",
	"eoffer.mandatory.delivery.address": "L'adresse de livraison est obligatoire",
	"eoffer.mandatory.enduser.reference": "Utilisateur final est obligatoire",
	"eoffer.mandatory.idd.reference": "IDD est obligatoire",
	"eoffer.mandatory.incot.reference": "L'incoterm est obligatoire",
	"eoffer.mandatory.priceUnit.reference": "Unité de prix est obligatoire",
	"eoffer.mandatory.quantity": "Quantité est obligatoire",
	"eoffer.mandatory.requestedDeliveryTime": "RDT est obligatoire",
	"eoffer.mandatory.rfq.reference": "Référence RFQ est obligatoire",
	"eoffer.mandatory.soldTo.reference": "sold-to est obligatoire",
	"eoffer.mandatory.tmode.reference": "Transport mode est obligatoire",
	"eoffer.merge.warning": "Certains articles ont été fusionnés. Ils ont été détectés comme étant des produits identiques.",
	"eoffer.message.offer.not.saved": "Impossible d'enregistrer l'offre",
	"eoffer.message.offer.not.submit": "Sélectionnez les conditions de votre offre",
	"eoffer.message.offer.saved": "Ligne d'offre",
	"eoffer.mill": "Lignes d'offre",
	"eoffer.mill.supplier.choice": "Offres - Brouillons",
	"eoffer.minimum.quantity": "Conditions de paiement",
	"eoffer.next": "Suivant",
	"eoffer.offer": "Offre ",
	"eoffer.offer.and.order": "Aperçu de l'offre",
	"eoffer.offer.card": "Carte d'offre",
	"eoffer.offer.dashboard.not.retrived": "Impossible de récupérer les données du tableau de bord de l'offre",
	"eoffer.offer.plural": "Offres",
	"eoffer.offer.request": "Demande d'offres",
	"eoffer.offer.terms": "Sélectionnez les conditions de votre demande d'offre",
	"eoffer.offerLine": "Ligne d'offre",
	"eoffer.offerLine.plural": "Lignes d'offre",
	"eoffer.offers.draft": "Offres - Brouillons",
	"eoffer.paymentTerms": "Conditions de paiement",
	"eoffer.pc.label.weightDiameterMax": "Max",
	"eoffer.pc.label.weightDiameterMin": "Min",
	"eoffer.pc.label.weightDiameterUnit": "Unité",
	"eoffer.period": "Période",
	"eoffer.period.end": "Période (fin)",
	"eoffer.period.in.month.value": "{{value}} mois",
	"eoffer.period.month": "Période (en mois)",
	"eoffer.period.orderBook": "Période pour le carnet d'ordres historique",
	"eoffer.period.quarter.initial.letter": "Q",
	"eoffer.period.selection.needed": "Sélection nécessaire",
	"eoffer.period.semester.initial.letter": "H",
	"eoffer.period.start": "Période (début)",
	"eoffer.prefered.delivery.mill": "Usine de livraison préférée",
	"eoffer.previous": "Précédent",
	"eoffer.price": "Prix",
	"eoffer.pricing.unit": "Unité de tarification",
	"eoffer.product": "Produit",
	"eoffer.product.card": "Afficher les détails du produit",
	"eoffer.product.family": "Famille de produits",
	"eoffer.product.family.infos.text": "Veuillez sélectionner un client, une adresse de livraison et un utilisateur final pour accéder à la liste des produits",
	"eoffer.product.family.plural": "Familles de produits",
	"eoffer.product.load.content": "Impossible de charger le contenu du produit",
	"eoffer.product.not.found": "La description du produit n'est pas disponible",
	"eoffer.product.plural": "Produits",
	"eoffer.quantity": "Quantité",
	"eoffer.quantity.error": "Veuillez entrer une quantité valide",
	"eoffer.quantity.ton": "Quantité (tonnes)",
	"eoffer.quit.with.save": "Sauvegarder et quitter",
	"eoffer.quit.without.save": "Quitter sans sauvegarder",
	"eoffer.referenceAm": "Référence AM",
	"eoffer.refresh": "Actualiser",
	"eoffer.remove.product": "Continuer et supprimer le produit sélectionné",
	"eoffer.request.new.offer": "Demander une nouvelle offre",
	"eoffer.request.new.offer.from.draft": "Copier et adapter une nouvelle offre",
	"eoffer.requested": "Demande",
	"eoffer.requested.delivery.time": "Poursuivre et réinitialiser les délais de livraison",
	"eoffer.reset.requested.delivery.time": "Poursuivre et réinitialiser les délais de livraison",
	"eoffer.review.selections.and.submit": "Vérifiez vos sélections et soumettez",
	"eoffer.rfq.id": "Votre ID RFQ unique est",
	"eoffer.rfq.reference": "Votre référence RFQ",
	"eoffer.save": "sauvegarder  ",
	"eoffer.save.offer.draft": "Enregistrer la demande d'offre comme brouillon",
	"eoffer.save.offer.question": "Quitter sans sauvegarder l'offre, voulez-vous continuer?",
	"eoffer.searchfield.extendable": "Recherche rapide",
	"eoffer.select.period.info": "Cliquez ci-dessous pour sélectionner une période allant de 1 mois à 1 année calendrier.",
	"eoffer.select.price": "Sélectionnez la période d'engagement de prix pour cette offre",
	"eoffer.selector": "Sélecteur",
	"eoffer.set.entities": "Définir les entités pour cette offre",
	"eoffer.shipto": "Adresse de livraison",
	"eoffer.simulation.shipto.enduser.error": "Erreur due à la force autre [shipto/enduser] après simulation.",
	"eoffer.soldto": "Adresse de livraison",
	"eoffer.status": "statut",
	"eoffer.status.accepted": "Accepté",
	"eoffer.status.accepted.plural": "Accepté",
	"eoffer.status.canceled": "annulé",
	"eoffer.status.canceled.plural": "annulé",
	"eoffer.status.draft": "Brouillon",
	"eoffer.status.draft.plural": "Brouillons",
	"eoffer.status.offered": "Offert",
	"eoffer.status.offered.plural": "Offert",
	"eoffer.status.rejected": "Rejeté",
	"eoffer.status.requested": "Demandé",
	"eoffer.status.requested.plural": "Demandé",
	"eoffer.steelGrade": "Nuance(s) d'acier",
	"eoffer.subcategory": "Sous-catégorie",
	"eoffer.submission.feedback": "Vous pouvez suivre l'état de votre RFQ via votre tableau de bord de demande d'offre",
	"eoffer.submit": "Soumettre",
	"eoffer.supplier.offer.number": "Référence offre fournisseur",
	"eoffer.table.customer": "Client",
	"eoffer.table.enduser": "Utilisateur final",
	"eoffer.table.header.colTopSide": "Couleur face supérieure",
	"eoffer.table.header.custMatRef": "Référence article client",
	"eoffer.table.header.custOffRef": "Référence de l'offre client",
	"eoffer.table.header.delivery.mill": "Usine de livraison préférée",
	"eoffer.table.header.dim": "Dim (mm)",
	"eoffer.table.header.dimension": "Dimensions (mm)",
	"eoffer.table.header.dimensions": "Dimensions",
	"eoffer.table.header.feasibility": "Faisabilité",
	"eoffer.table.header.last.update": "Date de la dernière mise à jour",
	"eoffer.table.header.orderCount": "Articles",
	"eoffer.table.header.period": "Période",
	"eoffer.table.header.price": "Prix",
	"eoffer.table.header.qttOrdered": "Quantité",
	"eoffer.table.header.quantity": "Quantité (tonnes)",
	"eoffer.table.header.rfqRef": "Référence RFQ",
	"eoffer.table.header.standsteelGrade": "Nuance d’acier",
	"eoffer.table.header.status": "Statut",
	"eoffer.table.header.steelGrade": "Nuance(s) d'acier",
	"eoffer.table.item.number": "Poste d'article",
	"eoffer.table.morw": "Mois ou semaine",
	"eoffer.table.price.unit": "Prix (unité)",
	"eoffer.table.price.value": "Prix (valeur)",
	"eoffer.table.quantity.unit": "Quantité (unité)",
	"eoffer.table.quantity.value": "Quantité (valeur)",
	"eoffer.table.shipto": "Expédié à",
	"eoffer.title.my.offers": "Mes offres",
	"eoffer.title.productlist.filter": "Choisissez le produit sur lequel vous souhaitez demander",
	"eoffer.title.section.coilWeightInPercent": "Poids de la bobine en %.",
	"eoffer.title.section.dimensionUnit": "Unité de dimension",
	"eoffer.title.section.length": "Longueur",
	"eoffer.title.section.organicCoating": "Revêtement organique",
	"eoffer.tonnes": "Tonnes",
	"eoffer.total.quantity.for.period.draft": "Quantité totale pour la période",
	"eoffer.track.status": "Vous pouvez suivre le statut de votre RFQ par",
	"eoffer.transport.mode": "Mode de transport",
	"eoffer.validityDate": "Validité",
	"eoffer.weightAndInvoicing": "Poids et factures",
	"eoffer.wizard.cart": "Panier",
	"eoffer.wizard.delivery.address": "Adresse de livraison",
	"eoffer.wizard.end": "Réviser-soumettre",
	"eoffer.wizard.error.products.families": "Familles de produits non trouvées",
	"eoffer.wizard.header.entity.information": "Informations sur les entités",
	"eoffer.wizard.header.terms.information": "Informations sur les conditions",
	"eoffer.wizard.parameters.error": "Impossible de charger les paramètres de l'offre",
	"eoffer.wizard.period.error": "La date a été réinitialisée",
	"eoffer.wizard.period.selection.error": "Veuillez sélectionner une date future et dans la période de validité sélectionnée",
	"eoffer.wizard.request": "Demander une offre",
	"eoffer.wizard.specs": "Spécifications du produit",
	"eoffer.wizard.step.status": "Étape {{step}} sur 4",
	"eoffer.wizard.submit": "Déposez votre demande d'offre",
	"eoffer.wizard.table.header.quantity": "Quantité (t)",
	"eoffer.wizard.terms": "Conditions de l'offre",
	"eorder.action.next": "Suivant",
	"eorder.action.save.draft": "Enregistrer la commande en tant que brouillon",
	"eorder.add.item.confirm.action": "Souhaitez-vous confirmer cette action ?",
	"eorder.add.item.confirm.change": "Souhaitez-vous confirmer cette modification ?",
	"eorder.add.item.different.family.warning": "Le(s) article(s) sélectionné(s) n'est (ne sont) pas de la même famille que le(s) article(s) dans le panier. Nous allons vider le panier avant d'ajouter le(s) nouvel(aux) article(s) demandé(s).",
	"eorder.add.item.different.form.warning": "Le(s) article(s) sélectionné(s) n'est (ne sont) pas de la même forme que le(s) article(s) dans le panier. Nous allons vider le panier avant d'ajouter le(s) nouvel(aux) article(s) demandé(s).",
	"eorder.add.item.empty.customer.warning": "Le champ « client » est vide. Il n'est pas possible d'ajouter un article au panier.",
	"eorder.add.item.limit.exeeds.warning": "En ajoutant [X] article(s) au panier, la commande sera trop importante pour le processus actuel (>100 articles). Veuillez réduire le contenu du panier ou le nombre d'articles à ajouter et réessayer.",
	"eorder.add.item.success": "[X] article(s) bien ajouté(s) au panier",
	"eorder.confirm.message": "Confirmer",
	"eorder.create.order.title": "Informations sur la commande",
	"eorder.customer.change.warning": "La modification du champ Client videra le panier en cours. Une commande donnée ne peut pas mélanger des articles provenant de différents clients.",
	"eorder.draft.deleted.successfully": "Votre brouillon de commande a été supprimé avec succès",
	"eorder.draft.edit.message.text": "Vous pourrez le modifier dans",
	"eorder.draft.last.update.date": "Date de dernière mise à jour",
	"eorder.draft.list.link": "votre liste de brouillons.",
	"eorder.draft.norequest": "Aucun brouillon de demande",
	"eorder.draft.order-card.edit": "Modifier ce brouillon",
	"eorder.draft.order-card.no-item.text": "Aucun article brouillon",
	"eorder.draft.order-card.placed.text": "Détails de la commande préliminaire",
	"eorder.draft.order-card.title": "Détails de la commande préliminaire",
	"eorder.draft.product.family": "Famille",
	"eorder.draft.product.number": "Nombre de produit(s)",
	"eorder.draft.requested.quantity": "Quantité demandée",
	"eorder.draft.saved.successfully": "Votre brouillon a été enregistré.",
	"eorder.fixed-columns": "Colonnes fixes",
	"eorder.grid.header.view.label": "Voir",
	"eorder.line.select.family.product": "Pour ajouter un article au panier, choisissez le nombre d'exemplaires d'un produit et cliquez sur le bouton correspondant Ajouter au panier",
	"eorder.mandatory.currency": "La devise est obligatoire",
	"eorder.mandatory.end.user": "L'utilisateur final est obligatoire",
	"eorder.mandatory.idd": "L'interprétation date de livraison est obligatoire",
	"eorder.mandatory.pricingUnit": "L'unité de prix est obligatoire",
	"eorder.mandatory.shipTo.reference": "L'adresse de livraison est obligatoire",
	"eorder.message.order.not.saved": "Impossible d'enregistrer la commande",
	"eorder.no.product.family": "Aucun produit trouvé pour le client sélectionné",
	"eorder.order": "Demande de commande",
	"eorder.order.creation": "Création de la commande",
	"eorder.orders.request": "Demande de commande",
	"eorder.product.color.bottom": "Teinte (Bas)",
	"eorder.product.colour.top": "Teinte (Haut)",
	"eorder.product.custmaterialnum": "Référence client du matériel",
	"eorder.product.data.commercial.steelgrade.id": "IDNuanceAcierCommercial",
	"eorder.product.data.customer.article": "articleClient",
	"eorder.product.dimension": "Dimensions",
	"eorder.product.empty.row": "Pas de produit actif lié à ce modèle",
	"eorder.product.family.infos.title": "Merci de sélectionner le client pour cette demande, pour pouvoir voir la liste des produits associés. Tous les articles dans le panier doivent être lié au même client pour une demande.",
	"eorder.product.fc.products.label": "Produits complètement configurés",
	"eorder.product.grid.note.fc": "[Y] produit(s).",
	"eorder.product.grid.note.nfc": "[X] modèle(s) et [Y] produit(s). Un modèle est un article avec des variables vides pour vous permettre de créer un nouveau produit",
	"eorder.product.lastused": "Dernière utilisation",
	"eorder.product.lastused.default": "Jamais",
	"eorder.product.metalliccoating": "Revêtement métallique",
	"eorder.product.organiccoating.datasheet.top": "Fiche technique sur les revêtements organiques (Haut)",
	"eorder.product.organicdatasheet.bottom": "Fiche technique sur les revêtements organiques (Bas)",
	"eorder.product.removablefilm": "Film protecteur amovible",
	"eorder.product.steelgrade": "Qualité",
	"eorder.product.surfaceaspect": "Aspect de surface",
	"eorder.product.template.add.to.cart": "Ajouter comme produit vide au panier",
	"eorder.product.type.fc": "Produit catalogue",
	"eorder.product.type.fm": "À configurer (avec des valeurs par défaut)",
	"eorder.product.type.nfc": "À configurer",
	"eorder.product.variables": "variables(s)",
	"eorder.product.variables.title": "Variables sur ce modèle:",
	"eorder.save.draft.confirmation": "Voulez-vous enregistrer [X] comme brouillon ?",
	"eorder.save.draft.error.message": "Désolé, une erreur s'est produite lors de l'enregistrement de votre brouillon de commande. Veuillez réessayer plus tard ou envoyer un message à votre contact AM.",
	"eorder.save.draft.success.message": "Un brouillon de votre demande de commande a été correctement enregistré.",
	"eorder.select.product.spec": "Liste des produits",
	"eorder.submit.error.msg.bad.data": "Données erronées dans la demande.",
	"eorder.submit.error.msg.rqd.data.missing": "Données obligatoires manquantes",
	"eorder.submit.order.success.follow.up.link": "SUIVI DES COMMANDES ET EXPÉDITIONS.",
	"eorder.submit.order.success.follow.up.text": "Vous pouvez suivre l'évolution de son statut dans votre",
	"eorder.submit.order.success.text1": "Votre commande",
	"eorder.submit.order.success.text2": "a été traitée.",
	"eorder.wizard.header.customer": "Le client est obligatoire",
	"eorder.wizard.header.customer-order-number": "Numéro de commande client",
	"eorder.wizard.header.customer-order-number.error.invalid": "Numéro de commande client non valide",
	"eorder.wizard.header.customer-order-number.error.mandatory": "Le numéro de commande client est obligatoire",
	"eorder.wizard.header.purchase-order-contract.error.invalid": "Numéro de contrat invalide",
	"eorder.wizard.header.purchase-order-contract.error.mandatory": "Le contrat de commande d'achat est obligatoire",
	"eorder.wizard.order.currency": "Devise",
	"eorder.wizard.order.enduser": "Utilisateur final",
	"eorder.wizard.order.idd": "Date de livraison",
	"eorder.wizard.order.pricingUnit": "Unité de tarification",
	"eorder.wizard.order.purchase.contract": "Contrat d'achat de commande",
	"eorder.wizard.order.shipto.name": "Adresse de livraison",
	"eorder.wizard.order.soldto.name": "client",
	"eorder.wizard.parameters.error": "Impossible de charger les paramètres de la commande électronique",
	"eorder.wizard.product.action.delete": "Supprimer",
	"eorder.wizard.product.action.duplicate": "Dupliquer",
	"eorder.wizard.product.card.error": "⚠ This item is no more valid or has issues to be loaded",
	"eorder.wizard.product.itemnumber": "Numéro d'article",
	"eorder.wizard.product.modification.no.products": "Aucun produit.",
	"eorder.wizard.product.modification.order.title": "Commande",
	"eorder.wizard.product.modification.title.cart": "Votre panier",
	"eorder.wizard.product.modification.title.item": "article",
	"eorder.wizard.product.modification.title.items": "article(s)",
	"eorder.wizard.product.quantity": "Quantité (t)",
	"eorder.wizard.product.rdd": "RDD",
	"eorder.wizard.product.rdd.error": "Date dans le passé",
	"eorder.wizard.product.rdd.type": "Type RDD",
	"eorder.wizard.product.service.level": "Niveau de service",
	"eorder.wizard.product.steelgrade": "Nuance d'acier",
	"eorder.wizard.product.thickness": "épaisseur",
	"eorder.wizard.product.width": "largeur",
	"eorder.wizard.quantity.error": "Veuillez saisir une quantité valide supérieure ou égale à 1.",
	"eorder.wizard.stepper.step.order.information": "Information de commande et sélection de produit",
	"eorder.wizard.stepper.step.product.modification": "Modification du produit",
	"eorder.wizard.stepper.step.summary": "Résumé de la commande",
	"eorder.wizard.summary.header.contract.po": "Contrat (PO)",
	"eorder.wizard.summary.header.currency.po": "Devise de facturation",
	"eorder.wizard.summary.header.order.title": "Informations sur la commande",
	"eorder.wizard.summary.order.placed.text": "Commande passée - ",
	"eorder.wizard.summary.terms.conditions.text": "En cliquant sur Passer la commande, vous acceptez les conditions générales de l'entrée de commande web",
	"eorder.wizard.summary.total.quantity": "Quantité totale (t)",
	"epassivefilm.P": "E-Passivation®",
	"epassivefilm.S": "Easyfilm®",
	"error.cancelling.issue": "Error while cancelling issue",
	"error.choose.pdf.manager": "Veuillez installer un gestionnaire de pdf sur votre téléphone",
	"error.deleting.draft": "Erreur lors de la suppression du brouillon",
	"error.file.download": "Une erreur s'est produite pendant le téléchargement",
	"error.file.not.found": "Ce fichier n'existe pas",
	"error.inavlid.transport.cost": "Frais de transport non valides",
	"error.place.atleast.one.bid": "Placez au moins une offre avant d'enregistrer",
	"exception-report.amlno": "Nº AML",
	"exception-report.comment-by-am": "Historical exception report Arcelormittal comment",
	"exception-report.comment-by-customer": "Historical exception report customer comment",
	"exception-report.delete": "Votre demande de rapport d'exception a été supprimée avec succès",
	"exception-report.dialog.add-comment.title": "Ajoutez un commentaire pour finaliser votre rapport d'exception sur commande",
	"exception-report.dialog.current-status.title": "Le statut actuel de votre demande en cours de commande",
	"exception-report.dialog.processing": "Traitement en cours",
	"exception-report.docNo": "Nº de document",
	"exception-report.edit-request": "Modifier commentaire",
	"exception-report.last.comment-by-am": "Exception report Arcelormittal last comment",
	"exception-report.last.comment-by-customer": "Exception report customer last comment",
	"exception-report.make-new-request": "Request exception report",
	"exception-report.order-card-header": "Demande spéciale",
	"exception-report.save": "Votre demande de rapport d'exception a été envoyée. Vous pouvez suivre votre demande hebdomadaire dans la LISTE DE COMMANDE.",
	"exception-report.status": "Statut du commentaire",
	"exception-report.yearweek": "Année semaine",
	"fabrication.process.H": "Tubing + HF",
	"fabrication.process.L": "Tubing + Laser",
	"fabrication.process.R": "Roll Forming",
	"fabrication.process.S": "Stamping",
	"fast.lane.entry": "Fast Lane",
	"fastlane.attachments": "Pièces jointes",
	"fastlane.create.details.field.currency": "Sélectionner votre devise",
	"fastlane.delivery.address": "L’adresse de livraison est obligatoire!",
	"fastlane.delivery.infos.title": "Merci de choisir une addresse de livraison pour vos articles dans la liste de celles prédéfinie ou en personnaliser une. Dans le cas d’une destination personnalisée, vous devrez fournir des détails supplémentaires.",
	"fastlane.error.nosoldto": "Sold-to non trouvé",
	"fastlane.file.import.button": "Importer",
	"fastlane.file.import.note": "Préremplir tous les articles en utilisant un fichier",
	"fastlane.file.import.progressMessage": "Importation en cours.",
	"fastlane.file.import.result.label": "Résultat",
	"fastlane.file.import.result.text": "Merci d’uploader un fichier",
	"fastlane.file.import.validate": "Valider",
	"fastlane.file.template.download.note": "Utiliser un format de fichier approprié en téléchargeant le modèle en cliquant ici",
	"fastlane.header.customer-request-name.error.mandatory": "Le nom de la demande est obligatoire !",
	"fastlane.header.wizard.customer-request-name": "Nom de la demande",
	"fastlane.import.popup.text.1": "Uploader un fichier XLS pour préremplir an une fois tous les articles. Merci de suivre le modèle afin de permettre une détection automatique.",
	"fastlane.import.popup.text.2": "Si certains champs sont trop longs en tant que texte, ils seront tronqués (ex: Le Nom pour un article est limité à 80 caractères)",
	"fastlane.import.popup.text.3": "Si certains champs sont des listes de valeursmais que le fichier contient une valeur inconnue, ils seront ignorés.",
	"fastlane.import.popup.text.4": "Une ligne d'article dans le fichier doit fournir tous les champs obligatoires pour celui si",
	"fastlane.import.popup.text.5": "La liste de tous les défauts sera fournit à la fin du processus afin que vous puissiez les valider ou réessayer.",
	"fastlane.import.popup.title": "Préremplir tous les articles",
	"fastlane.info.commercial.data": "Données commerciales",
	"fastlane.info.request.details": "Détails sur la demande",
	"fastlane.itemlist.coil.inner.diameter": "Diamètre interne",
	"fastlane.itemlist.coil.inner.diameter.508mm": "508 mm",
	"fastlane.itemlist.coil.inner.diameter.610mm": "610 mm",
	"fastlane.itemlist.coil.inner.diameter.NA": "N/A",
	"fastlane.itemlist.coil.inner.diameter.default": "Vertical",
	"fastlane.itemlist.coil.max_outer_diameter": "Diamètre externe maximum",
	"fastlane.itemlist.global.quantity": "Quantité",
	"fastlane.itemlist.global.quantity.error": "Le quantité est obligatoire !",
	"fastlane.itemlist.global.select_unit.error": "Merci de sélectionner une unité",
	"fastlane.itemlist.global.unit": "Unité",
	"fastlane.itemlist.global.unit.error": "L'unité est obligatoire !",
	"fastlane.itemlist.item.additional.info": "Informations supplémentaire sur l’article",
	"fastlane.itemlist.navig.duplicate": "Dupliquer",
	"fastlane.itemlist.navig.reset": "Réinitialiser",
	"fastlane.itemlist.order.thickness": "Épaisseur",
	"fastlane.itemlist.product.blankWeight.error.invalid": "Le poids à vide doit être supérieur à 0",
	"fastlane.itemlist.product.blank_weight": "Poids d’une unité",
	"fastlane.itemlist.product.blank_weight.error": "Le poids d’une unité est obligatoire !",
	"fastlane.itemlist.product.coating.error.invalid": "Le revêtement doit être supérieur à 0",
	"fastlane.itemlist.product.coating.mandatory": "Le revêtement est obligatoire !",
	"fastlane.itemlist.product.coil_axis": "Axe de la bobine",
	"fastlane.itemlist.product.coil_axis.default": "-- Aucun --",
	"fastlane.itemlist.product.coil_axis.horizontal": "Horizontal",
	"fastlane.itemlist.product.coil_axis.vertical": "Vertical",
	"fastlane.itemlist.product.form_blank": "Forme libre",
	"fastlane.itemlist.product.item_form": "Formulaire",
	"fastlane.itemlist.product.item_form.error": "Le formulaire est obligatoire !",
	"fastlane.itemlist.product.item_name": "Nom",
	"fastlane.itemlist.product.item_name.error": "Le nom de l’article est obligatoire !",
	"fastlane.itemlist.product.item_number": "Numéro d'article",
	"fastlane.itemlist.product.length.error": "La longeur est obligatoire !",
	"fastlane.itemlist.product.length.error.invalid": "La longueur doit être supérieure à 0",
	"fastlane.itemlist.product.maxOuterDiameter.error.invalid": "Le diamètre externe max. doit être supérieur à 0",
	"fastlane.itemlist.product.quantity.error.invalid": "La quantité doit être supérieure à 0",
	"fastlane.itemlist.product.select_form.error": "Merci de sélectionner une forme",
	"fastlane.itemlist.product.slitting_coil": "Bobine refendue",
	"fastlane.itemlist.product.steel_grade": "Nuance d'acier",
	"fastlane.itemlist.product.steel_grade.error": "La nuance d’acier est obligatoire !",
	"fastlane.itemlist.product.thickness.error": "L'épaisseur est obligatoire !",
	"fastlane.itemlist.product.thickness.error.invalid": "L'épaisseur doit être comprise entre 0.1 et 999",
	"fastlane.itemlist.product.width.error": "La largeur est obligatoire !",
	"fastlane.itemlist.product.width.error.invalid": "La largeur doit être supérieure à 0",
	"fastlane.itemlist.productcharacteristic.oilquantity": "Huilage",
	"fastlane.itemlist.quality.calculator.coil": "Bobine",
	"fastlane.itemlist.quality.calculator.sheet": "Feuille",
	"fastlane.itemlist.unit.blanks": "Exemplaires",
	"fastlane.itemlist.unit.sheets": "Feuilles",
	"fastlane.itemlist.unit.tons": "Tonnes",
	"fastlane.mandatory.delivery.address": "L'adresse de livraison est obligatoire",
	"fastlane.prototype.dialog.week": "semaine",
	"fastlane.prototype.not.found": "Not found",
	"fastlane.prototyperequest.request": "Demande Fast Lane",
	"fastlane.request.title": "Information sur la demande",
	"fastlane.soldto.shipto.error": "Désolé, il y a un soucis dans vos settings de service, merci de prendre contact avec un admnistrateur SteelUser",
	"fastlane.submit.error.msg": "Il y a eu un soucis. Merci de contacter votre administrateur SteelUser.",
	"fastlane.submit.error.msg.mandatoryfield": "Des champs obligatoires sont manquants.",
	"fastlane.submit.error.msg.nosoldtoshipto": "Il y a un soucis avec vos settings pour ce service",
	"fastlane.submit.error.msg.notoken": "Votre session a expiré. Merci de vous reloguez dans l’application.",
	"fastlane.submit.request.error.msg.title": "Erreur durant la validation de votre demande",
	"fastlane.template.addinfo.validation": "Les Informations Supplémentaires sur l’article ne peuvent dépasser les 255 caractères ([X] détecté(s))",
	"fastlane.template.blankweight.validation": "Le Poids d’une Unité est obligatoire pour une Forme libre et doit être un nombre plus grand ou égal à 1 avec maximum 2 chiffres après la virgule (tronqué si plus). ([X] détecté)",
	"fastlane.template.coating.validation": "Le Revêtement est obligatoire et ne peut dépasser les 50 caractères ([X] détecté(s))",
	"fastlane.template.coilaxis.validation": "L’Axe de la Bobine est obligatoire et doit être l'une des valeurs suivantes : -- Aucun --, Horizontal, Vertical, Forme libre (“[X]” détecté). “-- Aucun --” sera défini par défaut",
	"fastlane.template.currency.validation": "La Devise est obligatoire et doit être l'une des valeurs suivantes : EUR, GPB, USD (“[X]” détecté). EUR sera défini par défaut",
	"fastlane.template.deliveryaddress.validation": "L’Adresse de Livraison n'est pas obligatoire, mais si elle est renseignée, elle ne doit pas dépasser 150 caractères ([X] détecté(s))",
	"fastlane.template.description.validation": "La Description est obligatoire et ne peut dépasser les 255 caractères ([X] détecté(s))",
	"fastlane.template.detected.items": "[X] articles détectés dans le file",
	"fastlane.template.form.validation": "La Forme est obligatoire et doit être l'une des valeurs suivantes : Bobine, Feuille, Bobine refendue, Forme libre (“[X]” détecté). Bobine sera définie par défaut",
	"fastlane.template.format.error": "Le fichier doit être un modèle fourni par ArcelorMittal. Nous ne sommes pas en mesure de l'analyser, il peut s'agir d'un fichier erroné ou corrompu. Si vous avez des doutes, communiquez avec votre contact AM en lui envoyant le fichier.",
	"fastlane.template.global.data.issue": "Données globales avec des problèmes",
	"fastlane.template.global.error": "Erreur(s) globale(s) empêchant toute analyse du document",
	"fastlane.template.incoterms.validation": "L’incoterms est obligatoire et doit être l'une des valeurs suivantes : -- Aucun --, DAP, CIF, CIP, FCA, DDP (“[X]” détecté). “-- Aucun --” sera défini par défaut",
	"fastlane.template.innerdiameter.validation": "Le Diamètre Interne de la bobine est obligatoire et doit être l'une des valeurs suivantes : N/A, 508 mm, 610 mm (“[X]” détecté). “N/A” sera défini par défaut",
	"fastlane.template.item.issue.header": "[X] articles avec des problèmes",
	"fastlane.template.itemname.validation": "Le Nom de l’Article est obligatoire et ne peut dépasser les 80 caractères ([X] détecté(s))",
	"fastlane.template.length.validation": "La Longueur est obligatoire pour une Feuille et doit être un nombre plus grand ou égal à 1 avec 0 chiffre après la virgule (tronqué si présent). ([X] détecté)",
	"fastlane.template.line": "Ligne",
	"fastlane.template.mill.validation": "L’Usine est obligatoire et doit être l'une des valeurs valides. (“[X]” détecté). “-- Aucun --” sera défini par défaut",
	"fastlane.template.oiling.validation": "Le Huilage ne peut dépasser les 50 caractères ([X] détecté(s))",
	"fastlane.template.outerdiameter.validation": "Le Diamètre Externe Maximum de la bobine doit être un nombre plus grand ou égal à 1 avec 0 chiffre après la virgule (tronqué si présent). ([X] détecté)",
	"fastlane.template.packing.validation": "L’Emballage ne peut dépasser les 50 caractères ([X] détecté(s))",
	"fastlane.template.quantity.validation": "La quantité est obligatoire et doit être un nombre positif valide avec un maximum de 2 ou 0 chiffres en fonction de l'unité sélectionnée (tronqué si plus). ([X] détecté)",
	"fastlane.template.rddday.validation": "Une Date de Livraison a été fourni en Jour, mais cela ne respecte pas le bon format (jj/mm/aaaa, ex: 02/02/2024).  (“[X]” détecté)",
	"fastlane.template.rddweek.validation": "Une Date de Livraison a été fourni en Semaine, mais cela ne respecte pas le bon format (Wss/AAAA, ex: W01/2024).  (“[X]” détecté)",
	"fastlane.template.rddwnd.validation": "Le jour founit pour la Date de Livraison ne correspondant pas à la semaine (“[Y]” ne fait pas parti de la semaine “[X]”)",
	"fastlane.template.request": "Requête",
	"fastlane.template.requestname.validation": "Le Nom de la Requête est obligatoire et ne peut dépasser les 120 caractères ([X] détecté(s))",
	"fastlane.template.steelgrade.validation": "La Nuance d’Acier est obligatoire et ne peut dépasser les 255 caractères ([X] détecté(s))",
	"fastlane.template.thickness.validation": "L’Epaisseur est obligatoire et doit être un nombre positif avec au maximum 2 chiffres après la virgule (tronqué si plus). Doit être inférieure ou égale à 999. ([X] détecté)",
	"fastlane.template.tmode.validation": "Le mode de transport est obligatoire et doit être l'une des valeurs suivantes : -- Aucun --, Train, Bateau, Camion, Avion (“[X]” détecté). “-- Aucun --” sera défini par défaut",
	"fastlane.template.unitbasic.validation": "L’Unité est obligatoire et doit être l'une des valeurs suivantes : Tonnes, Feuilles, m², Exemplaires (“[X]” détecté). Une valeur par défaut va être forcée selon la Forme détectée.",
	"fastlane.template.unitform.validation": "La Quantité “[X]” n’est pas valide pour la forme “[Y]”",
	"fastlane.template.upload.confirmation.text1": "Fichier correctement importé dans la session.",
	"fastlane.template.upload.confirmation.text2": "Veuillez revérifier tous les éléments dans la session avant de confirmer la demande.",
	"fastlane.template.upload.warning.text": "Vous pouvez valider ce résultat partiel ou essayer de réimporter le fichier en corrigeant les problèmes",
	"fastlane.template.valid.items": "[X] articles sans aucun problème",
	"fastlane.template.width.validation": "La Largeur est obligatoire et doit être un nombre plus grand ou égal à 1 avec 0 chiffre après la virgule (tronqué si présent). ([X] détecté)",
	"fastlane.template.xls.mime.type": "Le fichier doit être un fichier Excel. Veuillez utiliser le modèle fourni par l'application SteelUser.",
	"fastlane.wizard.contact.person.mandatory": "La personne de contact est obligatoire !",
	"fastlane.wizard.contact.phone.number": "Numéro de téléphone de ce contact",
	"fastlane.wizard.currency": "Devise",
	"fastlane.wizard.custom.destination": "Destination personnalisée",
	"fastlane.wizard.custom.destination.contact.person": "Personne de contact à cette adresse",
	"fastlane.wizard.decide.later": "-- Décider plus tard --",
	"fastlane.wizard.delivery.address": "Adresse de livraison prédéfinie",
	"fastlane.wizard.header.customer": "Le client est obligatoire",
	"fastlane.wizard.header.customer-request-name": "Nom de la demande",
	"fastlane.wizard.header.customer-request-name.error.invalid": "Invalid Request name",
	"fastlane.wizard.header.global.description": "Description",
	"fastlane.wizard.header.no.item.list": "Aucun article dans cette demande",
	"fastlane.wizard.header.request.data": "Données de la demande",
	"fastlane.wizard.items.details.addanitem": "Ajouter un article",
	"fastlane.wizard.items.details.datetype": "Type de Date",
	"fastlane.wizard.items.details.datetype.errormsg": "Le type de date est obligatoire !",
	"fastlane.wizard.items.details.datetype.rdd": "Date de livraison demandée",
	"fastlane.wizard.items.details.day": "Jour",
	"fastlane.wizard.items.details.itemrequest": "Demandes d’articles",
	"fastlane.wizard.items.details.sheet.weight": "Poids d’une feuille (en kg)",
	"fastlane.wizard.items.details.total.weight": "Poids total (en tonnes)",
	"fastlane.wizard.items.details.week": "Semaine",
	"fastlane.wizard.parameters.error": "Impossible de charger les paramètres fastlane",
	"fastlane.wizard.phone.number.mandatory": "La numéro de téléphone est obligatoire !",
	"fastlane.wizard.product.transport.desired.arcelormittal.plant": "Usine ArcelorMittal souhaitée",
	"fastlane.wizard.product.transport.desired.arcelormittal.plant.errmsg": "L’usine est obligatoire !",
	"fastlane.wizard.product.transport.mode.errormsg": "Le mode de transport est obligatoire !",
	"fastlane.wizard.shipto.name": "L’adresse de livraison",
	"fastlane.wizard.soldto.name": "Client",
	"fastlane.wizard.stepper.step.items.details": "Détails des articles",
	"fastlane.wizard.stepper.step.main.data": "Données principales",
	"fastlane.wizard.stepper.step.transport.details": "Détails du transport",
	"fastlane.wizard.stepper.step.transport.summary": "Résumé",
	"fastlane.wizard.summary.header.currency.po": "Devise de facturation",
	"fastlane.wizard.summary.submitBtn": "Soumettre votre demande Fast Lane",
	"fastlane.xlx.template": "Modèle XLS",
	"favorite-orders.title": "Mes commandes marquées",
	"feasibility-status": "Feasibility",
	"feasibility.product-category": "Product category",
	"feasibiliy-characteristics": "Characteristics",
	"feasible-results": "Feasibility Results",
	"fields.number.error": "Thickness and width should be in number format",
	"filter.abandon": "Abandonner",
	"filter.add": "Ajouter",
	"filter.add.dimension": "Dimensions (en mm)",
	"filter.all": "Tout",
	"filter.apply": "Appliquer",
	"filter.atConsignment": "En consignation",
	"filter.batchid": "N° du lot",
	"filter.bottom-color": "Couleur du fond",
	"filter.cancel": "Annuler",
	"filter.cdd": "Date de livraison confirmée",
	"filter.cddGtRdd": "CDD > RDD",
	"filter.coating": "Spécification du revêtement",
	"filter.confirmation.deleteall": "Voulez-vous vraiment supprimer tous les filtres?",
	"filter.contractNumber": "Numéro de contrat",
	"filter.criteria.applied": "Filtre appliqué",
	"filter.criteria.no.applied": "Aucun filtre appliqué",
	"filter.customerArticleReference": "Référence article client",
	"filter.customerOrderNumber": "Numéro de commande client",
	"filter.date": "Date...",
	"filter.date.from": "De",
	"filter.date.invalid": "La date doit être valide",
	"filter.date.to": "À",
	"filter.deleteall": "Effacer tout",
	"filter.delivered": "Livré",
	"filter.deliveryMode": "Mode de livraison",
	"filter.dimension": "Dimensions",
	"filter.dimensions.length": "Longueur",
	"filter.dimensions.thickness": "Épaisseur",
	"filter.dimensions.width": "Largeur",
	"filter.dispatchAdviceNumber": "Numéro d'avis d'expédition",
	"filter.dispatchDate": "Date d'avis d'expédition",
	"filter.enddate.inferior": "Cette date doit être supérieure à la précédente",
	"filter.field.invalid": "Valeur non valide",
	"filter.field.required": "Ce champ est obligatoire",
	"filter.filters": "Filtres",
	"filter.format.day": "Format jour",
	"filter.format.week": "Format semaine",
	"filter.grossOrdersWithMaterial": "Commandes brutes avec matériaux",
	"filter.inTransit": "En transit",
	"filter.is-not-a-number": "La valeur doit être un nombre.",
	"filter.is-not-a-positive-number": "La valeur doit être un nombre positif",
	"filter.length": "Longueur (m)",
	"filter.less-than": "Égal ou inférieur à",
	"filter.mill": "Usine  ",
	"filter.more-than": "Égal ou supérieur à",
	"filter.multiple-values": "Valeurs multiples...",
	"filter.netOrdersWithMaterial": "Commandes nettes avec matériaux",
	"filter.no-matching-value": "Aucune valeur correspondante",
	"filter.no-value": "Aucune valeur",
	"filter.no.predefined": "Pas de valeur prédéfinie",
	"filter.number.from": "De",
	"filter.number.to": "A",
	"filter.ok": "Ok",
	"filter.operator.exact": "Exacte",
	"filter.operator.range": "Gamme",
	"filter.order-number.item": "Article",
	"filter.order-number.reference": "Référence",
	"filter.order.item.number": "Numéro d'article",
	"filter.order.reference": "Référence de la commande",
	"filter.orderWithCddGtRdd": "RDD < CDD",
	"filter.ordersWithMaterial": "Commandes avec matériel",
	"filter.placeholder.list": "Sélectionner dans la liste",
	"filter.placeholder.suggestive.list": "Rechercher une valeur",
	"filter.predefined": "Prédéfini",
	"filter.readyToShip": "Prêt à expédier",
	"filter.reset": "Réinitialiser",
	"filter.schedule-business-order": "Commande Flux",
	"filter.scheduleBusinessOrdersWithMaterial": "Schedule Business Orders with material",
	"filter.shipment-section-n1": "En cours de fabrication (WIP)",
	"filter.shipment-section-n2": "En cours de fabrication (WIP)",
	"filter.spot-order": "Commande Spot",
	"filter.standardsteelgrade": "Nuance d’acier",
	"filter.supplierOrderNumber": "Numéro de commande fournisseur",
	"filter.text": "Utilisez ; comme signe de séparation, * comme caractère de remplacement.",
	"filter.thickness": "Épaisseur (mm)",
	"filter.top-color": "Couleur supérieure",
	"filter.week.to": "Vers",
	"filter.width": "Largeur (mm)",
	"filter.workInProgress": "En cours de fabrication (WIP)",
	"filter.x-filter-applied": "Vers",
	"filter.x-filters-applied": "Travaux en cours (WIP)",
	"filter.x-selected-values": "{{value}} filtre appliqué",
	"filter.yes": "{{value}} filtres appliqués",
	"footer.alerts": "{{value}} valeurs sélectionnées",
	"footer.home": "Oui",
	"footer.message": "Alertes",
	"footer.search": "Message",
	"form.blanks": "Blanks",
	"form.coil": "Coil",
	"form.heavy.plate": "Heavy Plate",
	"form.indif.04": "Slab",
	"form.indif.06": "Coil",
	"form.indif.07": "Sheet",
	"form.indif.08": "Blanks",
	"form.indif.09": "Heavy Plate",
	"form.indif.10": "Thick Plate",
	"form.indif.12": "Slit coil",
	"form.indif.15": "Scrolled sheet",
	"form.indif.16": "Mixed Coil",
	"form.indif.17": "Welded Coil",
	"form.mixed.coil": "Mixed Coil",
	"form.scrolled.sheet": "Scrolled Sheet",
	"form.sheet": "Sheet",
	"form.slab": "Slab",
	"form.slit.coil": "Slit Coil",
	"form.thick.plate": "Thick Plate",
	"form.welded.coil": "Welded Coil",
	"full.product.catalogue": "Catalogue de produits complet",
	"global-subcategory.BL": "laminé à chaud,  non décapé",
	"global-subcategory.CR": "Cold rolled",
	"global-subcategory.MS": "Metal studs",
	"global-subcategory.PI": "Hot rolled pickled and oiled",
	"global-subcategory.Z": "Hot dip galvanized",
	"global.action.cancelled": "Action annulée",
	"global.business-type": "Business Type",
	"global.cancelled": "Annulé",
	"global.clickhere": "Recherche",
	"global.closed": "Fermé",
	"global.copyto": "CC mail",
	"global.error": "Une erreur est survenue lors de la tentative d’obtenir votre liste de produits",
	"global.error.unexpected": "Erreur inattendue",
	"global.internal.server.error": "Erreur de serveur interne",
	"global.internal.soldto.error": "Erreur de paramétrage sur votre compte, vous ne pouvez pas effectuer cette demande de commande (client). Veuillez vous connecter avec votre contact AM.",
	"global.message": "Message",
	"global.message-error": "Le message est obligatoire !",
	"global.next": "Suivant",
	"global.no": "Non",
	"global.none": "Aucun",
	"global.open": "Ouvert",
	"global.or": "OU",
	"global.search-filter": "Recherche globale",
	"global.search.fastlane-entry": "FastLane",
	"global.search.fastlane-requests": "FastLane requests",
	"global.send": "Envoyer",
	"global.servicelevel": "Niveau de Service",
	"global.subject": "Sujet",
	"global.subject-error-msg": "Le sujet est obligatoire !",
	"global.submit.error.unexpected": "Une erreur inattendue s'est produite pendant le processus de soumission, veuillez réessayer plus tard ou vous connecter avec votre contact AM.",
	"global.submit.service.error": "Votre compte ne dispose pas des autorisations nécessaires pour soumettre une demande de commande. Veuillez vous connecter avec votre contact AM.",
	"global.unexpected.error.identified": "Une erreur inattendue s'est produite",
	"global.warning": "Alerte",
	"global.yes": "Oui",
	"guaranatee.aluminium.parts": "Aluminium pour pièces",
	"guarantee.Others": "Autres",
	"guarantee.Poultry": "Volailles",
	"guarantee.acoustic": "Barrières acoustiques",
	"guarantee.acoustic.concrete": "Existe-t-il une base en béton installée permettant de séparer du sol les éléments dotés d'un revêtement Magnelis® ?",
	"guarantee.acoustic.railroad": "Barrières acoustiques pour voie ferrée",
	"guarantee.acoustic.road.traffic": "Dispositif de réduction des bruits de circulation / barrières acoustiques pour routes",
	"guarantee.activity.building": "Activité dans le bâtiment",
	"guarantee.activity.specify": "Veuillez préciser l'activité",
	"guarantee.add.parts": "Ajouter des composants",
	"guarantee.additional.comments": "Informations ou commentaires supplémentaires",
	"guarantee.additional.documents": "Documents supplémentaires",
	"guarantee.address": "Ville / Pays",
	"guarantee.age.material": "Age du matériel à remplacer",
	"guarantee.agricultural": "Agricole",
	"guarantee.agricultural.questions": "Question pour bâtiment agricole",
	"guarantee.agricultural.specify": "Veuillez préciser",
	"guarantee.air.renewal": "spécifier le taux de renouvellement de l'air (en m3/h/animal)",
	"guarantee.allocation.building": "Affectation et destination du bâtiment",
	"guarantee.altitude.above.900m": "Au-dessus de 900 m",
	"guarantee.altitude.below.900m": "En dessous de 900 m",
	"guarantee.aluminium": "Aluminium",
	"guarantee.ambiance": "Ambiance à l'intérieur du bâtiment",
	"guarantee.ammonia": "spécifier la concentration en ammoniac à l'intérieur (en ppm)",
	"guarantee.animals.density": "Densité d'animaux par m² ?",
	"guarantee.animals.inside.building": "Quels sont les animaux détenus à l'intérieur du bâtiment ?",
	"guarantee.animals.shed": "Spécifier le nombre d'animaux dans l'étable",
	"guarantee.area": "Nom de la zone",
	"guarantee.atmospheric.corrosion": "Corrosion atmosphérique",
	"guarantee.attachment": "Document joint",
	"guarantee.attachment.categorize.title": "Étiquetez chaque document avec l'analyse à laquelle il correspond :",
	"guarantee.attachment.category.label": "Type de document",
	"guarantee.attachment.category.other": "Autre",
	"guarantee.attachment.category.soil": "Analyse du sol",
	"guarantee.attachment.category.water": "Analyse de l'eau",
	"guarantee.attachment.column.actions": "Actions",
	"guarantee.attachment.column.file": "Nom du fichier",
	"guarantee.attachment.column.size": "Taille",
	"guarantee.attachment.description": "Chargez et étiquetez vos documents. Chaque fichier doit être étiqueté avec l'analyse à laquelle il correspond.",
	"guarantee.attachment.limit": "La taille maximale du fichier est de 115 MB.",
	"guarantee.attachment.missing.soil": "Manquant : document pour l'analyse du sol",
	"guarantee.attachment.missing.title": "Document requis manquant",
	"guarantee.attachment.missing.water": "Manquant : document pour l'analyse de l'eau",
	"guarantee.attachment.size": "La taille de la pièce jointe ne doit pas dépasser 115 MB",
	"guarantee.attachment.title": "Pièces jointes",
	"guarantee.attachment.uploaded.title": "Documents téléchargés",
	"guarantee.between.2kmand10km": "Situé entre 2 et 10 km de la côte",
	"guarantee.between.300mand2km": "Situé entre 300 m et 2 km de la côte",
	"guarantee.breeding.animals": "Élevage d'animaux",
	"guarantee.building.altitude": "Altitude",
	"guarantee.building.heated": "Le bâtiment est-il chauffé ?",
	"guarantee.cancelled": "Annuler",
	"guarantee.card.client.project.name": "Nom du projet client",
	"guarantee.card.details": "Détails de la demande de garantie",
	"guarantee.card.info": "Informations sur la garantie",
	"guarantee.card.title": "Carte de garantie - Demande de garantie",
	"guarantee.cattle": "Bétail",
	"guarantee.certificate.issued": "Certificat émis",
	"guarantee.certificate.request": "Demander un certificat",
	"guarantee.certificate.request.confirmation": "Confirmez-vous la demande de certificat pour cette demande de garantie",
	"guarantee.certificate.request.failed": "Désolé, une erreur inattendue s'est produite pendant le processus. Veuillez réessayer plus tard.",
	"guarantee.certificate.request.success": "La demande de certificat a été envoyée avec succès.",
	"guarantee.certificate.request.unavailable": "Cette garantie n'est plus disponible pour une demande de certificat.",
	"guarantee.certificate.requested": "Certificat demandé",
	"guarantee.characteristics": "Caractéristiques du projet",
	"guarantee.chimney": "Cheminée",
	"guarantee.choose.applicationtype": "Sélectionnez le type de garantie que vous souhaitez.",
	"guarantee.cladding": "Bardage",
	"guarantee.cladding.double.skin": "Double peau",
	"guarantee.cladding.single.skin": "Simple peau",
	"guarantee.cladding.specify.material.type": "En bardage (préciser le type de matériau et la surface couverte)",
	"guarantee.client.project.name": "Nom du projet",
	"guarantee.coastal.marine": "Dans un environnement côtier ou maritime",
	"guarantee.cold.structure": "Structures formées à froid dans le bâtiment (pannes, rampes...)",
	"guarantee.composite.floor": "Sol composite",
	"guarantee.concrete.foundations": "Béton pour fondations",
	"guarantee.condensation.rink": "Existe-t-il un risque de condensation dans le bâtiment ?",
	"guarantee.condition.material": "État du matériau à remplacer",
	"guarantee.construction.new.building": "Construction complète d'un bâtiment neuf",
	"guarantee.construction.site": "Site de construction",
	"guarantee.construction.site.mandatory": "L'emplacement GPS (Latitude et Longitude) est obligatoire",
	"guarantee.contact": "(par exemple, acier galvanisé à chaud en continu, acier post-galvanisé, bois, etc.)",
	"guarantee.contact.orther.parts": "Quels autres matériaux seront utilisés en contact avec les pièces dotées d'un revêtement Magnelis® ? Veuillez préciser, le cas échant.",
	"guarantee.contact.parts": "Quels revêtements seront utilisés pour les éléments en contact avec les pièces revêtues de Magnelis® ? Veuillez préciser, le cas échéant.",
	"guarantee.coordinates.decimal": "Coordonnées en degrés décimaux",
	"guarantee.coordinates.dms": "Coordonnées en degrés minutes secondes",
	"guarantee.coordinates.pair.mandatory": "Veuillez renseigner à la fois la Latitude et la Longitude",
	"guarantee.corporate.name.mandatory": "Le champ Client est obligatoire",
	"guarantee.current.status": "Statut actuel",
	"guarantee.customer.information": "Informations sur le client",
	"guarantee.customer.name": "Client",
	"guarantee.customer.rejected": "Rejeté par le client",
	"guarantee.desert": "Dans le désert",
	"guarantee.designation": "Désignation",
	"guarantee.direction.of.cladding.installation": "Sens de pose du bardage",
	"guarantee.distance.3KM.seafront": "Si la distance est inférieure à 3 km du bord de mer, veuillez préciser la distance",
	"guarantee.distance.lake": "Distance avec un lac ou une rivière (km)",
	"guarantee.distance.less than 300m": "Situé à moins de 300 m de la côte",
	"guarantee.distance.seafront": "Si la distance est inférieure à 10 km du bord de mer, veuillez préciser la distance",
	"guarantee.distance.seafrontkm": "Distance avec le bord de mer (km)",
	"guarantee.distance.site": "Distance avec le site (km)",
	"guarantee.documents": "Documents de garantie",
	"guarantee.documents.title": "Documents",
	"guarantee.double.skin.roof": "Toiture double peau",
	"guarantee.draft": "Brouillon",
	"guarantee.draft.edit": "Vous pourrez le modifier dans le brouillon de suivi.",
	"guarantee.draft.saved.successfully": "Votre brouillon a été enregistré",
	"guarantee.duckboard": "À travers une grille en béton/un caillebotis",
	"guarantee.duration.year": "{{value}} an",
	"guarantee.duration.years": "{{value}} ans",
	"guarantee.duration.years.indoor": "Durée de garantie prévue intérieure (en années)",
	"guarantee.duration.years.outdoor": "Durée de garantie prévue extérieure (en années)",
	"guarantee.emission.type": "Type d'émissions",
	"guarantee.epassivation.type": "Type E-Passivation®",
	"guarantee.epc": "Ingénierie, fourniture des équipements et constructions (EPC)",
	"guarantee.epc.company.name": "Nom de la société",
	"guarantee.equipment": "Quels sont les équipements disponibles pour l'évacuation des fumées, des émanations, des vapeurs et de l'humidité ?",
	"guarantee.extension.existing.building": "Extension d'un bâtiment existant",
	"guarantee.extension.solar.plant": "Extension d'une installation solaire existante",
	"guarantee.extractor": "Extracteur",
	"guarantee.fabrication": "Processus de fabrication",
	"guarantee.fastners": "Matériaux de fixation",
	"guarantee.fertilizer": "Stockage d'engrais",
	"guarantee.floating.solar.installation": "Installation solaire flottante",
	"guarantee.floating.solar.magnelis": "Garantie pour les installations solaires flottantes avec Magnelis®.",
	"guarantee.fodder": "Stockage de fourrage",
	"guarantee.forced": "ventilation forcée",
	"guarantee.forced.ventilation": "Ventilation forcée",
	"guarantee.gas.building": "Existe-t-il des émissions de gaz ou de vapeurs dans le bâtiment ?",
	"guarantee.gratings": "Sur caillebotis",
	"guarantee.ground.mounted": "Au sol / centrale solaire à échelle industrielle",
	"guarantee.heating.type": "Type de chauffage",
	"guarantee.horizontal.rails": "Rails horizontaux des glissières de sécurité",
	"guarantee.humidity.high": "Haut",
	"guarantee.humidity.low": "Bas",
	"guarantee.humidity.medium": "Moyen",
	"guarantee.humidity.rate.inside.building": "Taux d'humidité à l'intérieur du bâtiment",
	"guarantee.humidity.saturated": "Saturé",
	"guarantee.humidity.specify": "Spécifier le taux d'humidité",
	"guarantee.humidity.very.high": "Très élevé",
	"guarantee.hydrogen.sulphide": "spécifier la concentration en sulfure d'hydrogène à l'intérieur (en ppm)",
	"guarantee.industrial": "Industriel",
	"guarantee.industrial.questions": "Question pour bâtiment industriel",
	"guarantee.industry.type": "Type d'industrie",
	"guarantee.inside-building.activity": "Please specify the activity inside the building",
	"guarantee.installation.direction.horizontal": "Horizontal",
	"guarantee.installation.direction.vertical": "Vertical",
	"guarantee.last.modified.date": "Dernière mise à jour",
	"guarantee.lat.degree": "Degrés (0-89)",
	"guarantee.lat.degrees": "Lat. degrés",
	"guarantee.lat.max": "Latitude (-90 à 90)",
	"guarantee.lat.minutes": "Lat. minutes",
	"guarantee.lat.seconds": "Lat. secondes",
	"guarantee.latitude": "Latitude",
	"guarantee.latlong.degree.pattern": "Le nombre maximal de décimales est de 6",
	"guarantee.latlongmin.max": "Minutes (0-59)",
	"guarantee.latlongsec.max": "Secondes (0-59,9999)",
	"guarantee.latlongsec.pattern": "Le nombre maximal de décimales est de 4",
	"guarantee.launch.analysis": "Lancer l'analyse",
	"guarantee.long.degrees": "Degrés long.",
	"guarantee.long.max": "Longitude (-180 à 180)",
	"guarantee.long.minutes": "Long. minutes",
	"guarantee.long.seconds": "Long. secondes",
	"guarantee.longdegress.max": "Degrés (0-179)",
	"guarantee.longitude": "Longitude",
	"guarantee.magnelis": "Poids du revêtement Magnelis®",
	"guarantee.magnelis.other": "Autre",
	"guarantee.magnelis.poles": "Masse du revêtement Magnelis® pour poteaux",
	"guarantee.magnelis.upper.structure": "Masse du revêtement Magnelis® pour structure supérieure",
	"guarantee.magnelis.zm310": "Magnelis® ZM310 avec revêtement métallique de 310 g/m² des deux côtés",
	"guarantee.magnelis.zm430": "Magnelis® ZM430 avec revêtement métallique de 430 g/m² des deux côtés",
	"guarantee.magnelis.zm620": "Magnelis® ZM620 avec revêtement métallique de 620 g/m² des deux côtés",
	"guarantee.magnelis.zm800": "Magnelis® ZM800 avec revêtement métallique de 800 g/m² des deux côtés",
	"guarantee.magnelisbuilding.long": "Magnelis® pour applications de bâtiment",
	"guarantee.magnelisbuilding.short": "Bâtiment Magnelis®",
	"guarantee.magnelisothers.long": "Magnelis® pour autres applications",
	"guarantee.magnelisothers.short": "Magnelis® Autres",
	"guarantee.magnelissolar.long": "Magnelis® pour applications solaires",
	"guarantee.magnelissolar.short": "Magnelis® Solaire",
	"guarantee.manure.management": "Gestion du fumier pour bâtiments avec animaux",
	"guarantee.mineral.wool.insulation": "Laine minérale",
	"guarantee.mounting.system.producer": "Producteur de système de montage",
	"guarantee.msp.company.name": "Nom de la société",
	"guarantee.name.copy": "copier",
	"guarantee.name.unique.error": "Une erreur inattendue s'est produite lors du processus ({{errordetails}})",
	"guarantee.name.unique.reason.duplicate": "unicité du nom",
	"guarantee.name.unique.reason.network": "impossible d'atteindre le serveur",
	"guarantee.natural.ventilation": "Ventilation naturelle",
	"guarantee.nature.content": "Nature et teneur de l'ambiance intérieure",
	"guarantee.nature.material": "Nature du matériau à remplacer",
	"guarantee.new.solar.plant": "Construction complète d'une nouvelle centrale solaire neuve",
	"guarantee.no.duckboard": "Pas de caillebotis",
	"guarantee.no.parts.magnelis": "Aucune pièce avec revêtement Magnelis®",
	"guarantee.notypes.available": "Aucun type de garantie disponible",
	"guarantee.open.building": "Bâtiment ouvert",
	"guarantee.open.building.specify": "Préciser",
	"guarantee.organiccoating.long": "Aciers revêtu organique pour le bâtiment",
	"guarantee.other": "Autres applications",
	"guarantee.other.application": "Veuillez indiquer l'application",
	"guarantee.other.building": "Autre (par ex. bureau, hôpital, hôtel, sports et loisirs, parking...)",
	"guarantee.other.coatings": "Acier doté d'autres revêtements",
	"guarantee.other.materials": "Autres matériaux utilisés en contact direct avec Magnelis®",
	"guarantee.other.materials.used": "Autres matériaux utilisés",
	"guarantee.others.animals": "Autres",
	"guarantee.others.please.specify": "Veuillez préciser",
	"guarantee.part.corrosion": "Type de corrosion",
	"guarantee.part.magnelis": "Poids du revêtement Magnelis® (g/m²)",
	"guarantee.parts.magnelis": "Pièces avec revêtement Magnelis®",
	"guarantee.pdf.page": "Page",
	"guarantee.per.app": "Pour quelle application utilisez-vous la tôle perforée ?",
	"guarantee.per.rich": "Veuillez indiquer le procédé de perforation",
	"guarantee.perforated.sheet": "Tôle perforée",
	"guarantee.pigs": "Porcs",
	"guarantee.pir.insulation": "PIR",
	"guarantee.planned.operations": "Opération(s) prévue(s)",
	"guarantee.poles.magnelis": "Garantie pour poteaux dans le cadre de projets Magnelis® avec poteaux au sol",
	"guarantee.poles.soil": "Projets avec poteaux au sol",
	"guarantee.power.generation": "Production électrique",
	"guarantee.presence.animals": "Présence d'animaux dans le bâtiment",
	"guarantee.prevailing.wind": "Les émissions de gaz, de fumées ou de produits pulvérulents sont-elles portées par les vents dominants ?",
	"guarantee.project.characteristics": "Caractéristiques du projet",
	"guarantee.project.environment": "Environnement du projet",
	"guarantee.project.for.floating.solar": "Projet pour solaire flottant",
	"guarantee.project.location": "Emplacement du projet",
	"guarantee.project.name": "Nom du projet",
	"guarantee.project.name.mandatory": "Le nom du projet est obligatoire",
	"guarantee.project.size": "Taille du projet",
	"guarantee.project.type": "Type de projet",
	"guarantee.proposal.ongoing": "Proposition en cours",
	"guarantee.proposals": "Proposition et documents additionnels",
	"guarantee.proximity.buildings": "À proximité d'un ou de plusieurs bâtiments abritant des animaux ou des produits de fermentation",
	"guarantee.pu.insulation": "PU",
	"guarantee.purpose.building": "Veuillez préciser la fonction du bâtiment",
	"guarantee.questions": "Questions pour bâtiments industriels et agricoles",
	"guarantee.radio.na": "NA",
	"guarantee.radio.no": "Non",
	"guarantee.radio.yes": "Oui",
	"guarantee.rainwater.systems": "Systèmes de collecte de l'eau de pluie / Gouttières",
	"guarantee.reason": "Raison",
	"guarantee.refineries.factories": "Comprenant principalement des raffineries, usines d'incinération, centrales au charbon ou au mazout, distilleries, cimenteries, usines de papier, centrales chimiques...",
	"guarantee.register": "Produit - demande de garantie",
	"guarantee.register.magnelisbuilding": "Produit - demande de certificat de garantie - Magnelis® pour applications de bâtiment",
	"guarantee.register.magnelisothers": "Produit - demande de certificat de garantie - Magnelis® pour d'autres applications",
	"guarantee.register.magnelissolar": "Produit - demande de certificat de garantie - Magnelis® pour applications solaires",
	"guarantee.relative.humidity": "Veuillez préciser l'humidité relative",
	"guarantee.remarks": "Veuillez apporter tout autre détail ou précision concernant votre projet :",
	"guarantee.request.author": "Auteur",
	"guarantee.request.certificate.id": "Certificat",
	"guarantee.request.date": "Date",
	"guarantee.request.drafts": "Demande de garantie - projet de liste",
	"guarantee.request.duplicate": "Dupliquer",
	"guarantee.request.followup": "Vous pourrez la consulter dans Mes demandes de garantie.",
	"guarantee.request.id": "ID de garantie",
	"guarantee.request.list": "Mes demandes de garantie",
	"guarantee.request.requested.date": "Date demandée",
	"guarantee.request.submitted.successfully": "Votre demande de garantie a été envoyée avec succès.",
	"guarantee.request.type": "Type",
	"guarantee.requested": "Garantie demandée",
	"guarantee.requested.type.indoor": "Intérieur",
	"guarantee.requested.type.indoor.label": "Garantie intérieure demandée",
	"guarantee.requested.type.outdoor": "Extérieur",
	"guarantee.requested.type.outdoor.label": "Garantie extérieure demandée",
	"guarantee.residential": "Usage résidentiel",
	"guarantee.retrofitting.existing.building": "Modernisation/Réparation d'un bâtiment existant",
	"guarantee.retrofitting.solar.plant": "Modernisation/Réparation d'une centrale solaire existante",
	"guarantee.road.restraint": "Systèmes de retenue des véhicules",
	"guarantee.roofing": "Toiture",
	"guarantee.roofing-cladding.anti-condensation.felt": "Feutre anti-condensation",
	"guarantee.roofing-cladding.color": "Couleur",
	"guarantee.roofing-cladding.desired.back.coat": "Envers de bande souhaité",
	"guarantee.roofing-cladding.desired.coating": "Revêtement souhaité",
	"guarantee.roofing-cladding.external.skin": "Peau externe",
	"guarantee.roofing-cladding.insulation": "Isolation",
	"guarantee.roofing-cladding.internal.skin": "Peau interne",
	"guarantee.roofing-cladding.made.with.product": "Toiture et/ou bardage entièrement réalisés avec le produit",
	"guarantee.roofing-cladding.metallic.coating.weight": "Poids du revêtement métallique",
	"guarantee.roofing-cladding.overlapping": "Chevauchement",
	"guarantee.roofing-cladding.perforation": "Perforation",
	"guarantee.roofing-cladding.pv.solar.roof": "PV / toiture solaire",
	"guarantee.roofing-cladding.substrate.thickness": "Épaisseur du substrat",
	"guarantee.roofing-cladding.surface": "Surface",
	"guarantee.roofing.decking.roof": "Complexe d’étanchéité",
	"guarantee.roofing.roofslope": "Pente du toit (%)",
	"guarantee.roofing.specify.material.type": "En toiture (préciser le type de matériau et la surface couverte)",
	"guarantee.rooftop.installation": "Installation en toiture",
	"guarantee.rrs.miscellaneous": "Pièces diverses pour systèmes de retenue des véhicules, soumises à une corrosion atmosphérique",
	"guarantee.rrs.poles": "Poteaux pour systèmes de retenue des véhicules",
	"guarantee.rrs.welded": "Les pièces fabriquées à partir de Magnelis® seront-elles soudées ?",
	"guarantee.rural.area": "Dans une zone rurale à moins de 10 km de la côte",
	"guarantee.rural.area.20KM": "Dans une zone rurale à moins de 20 km de la côte",
	"guarantee.sandwich.panel": "Toiture en panneaux sandwichs",
	"guarantee.satisfied": "Satisfait",
	"guarantee.save.failed": "Échec de l'envoi de la garantie.",
	"guarantee.save.failed.message": "Veuillez réessayer plus tard ou contacter ebusiness.support@arcelormittal.com",
	"guarantee.service.requests": "Mes demandes de garantie",
	"guarantee.sheet.thickness": "Épaisseur de la tôle (mm)",
	"guarantee.silo": "Silo",
	"guarantee.silo.cylinder": "Corps du silo",
	"guarantee.silo.liner": "Le silo sera-t-il doté d'un revêtement ?",
	"guarantee.silo.parts": "Quelles pièces du silo seront fabriquées à partir de Magnelis®",
	"guarantee.silo.products": "Quels types de produits seront stockés dans le silo ?",
	"guarantee.silo.roof": "Toit du silo",
	"guarantee.silo.soil": "Base du silo, en contact avec le sol ou le béton",
	"guarantee.single.skin.roof": "Toiture simple peau",
	"guarantee.soil.analysis": "Disposez-vous d'une analyse complète des sols ?",
	"guarantee.soil.document": "Si oui, veuillez joindre le document d'analyse des sols :",
	"guarantee.soil.information": "L'analyse des sols doit contenir au moins les informations suivantes : granulométrie, pH, teneur en humidité, teneur en chlorure, teneur en sulfates, résistivité, présence d'eau souterraine. Toute autre information sur les sols conformément à la norme DIN 50929-3:2018 peut également s'avérer utile.",
	"guarantee.soil.requirements.title": "Exigences pour l'analyse du sol",
	"guarantee.specific.environment": "Dans un environnement spécifique (combinaison de l'exposition ci-dessus et de certains effets supplémentaires, haute température, forte humidité, dépôts de poussière conséquents, etc.)",
	"guarantee.specify": "Veuillez préciser :",
	"guarantee.specify.perforation.scheme": "Spécifier le schéma de perforation",
	"guarantee.stainless.steel": "Acier inoxydable",
	"guarantee.steel.parts": "Acier inoxydable pour pièces",
	"guarantee.storage.chemicals": "Présence et/ou utilisation et/ou stockage de produits chimiques",
	"guarantee.storage.fermentation": "Présence et/ou stockage de produits de fermentation",
	"guarantee.structure": "La structure est entièrement composée de Magnelis®",
	"guarantee.suggested.coating.mass": "Poids de revêtement estimée par ArcelorMittal en fonction de la durée de garantie prévue",
	"guarantee.summary": "Résumé",
	"guarantee.supplier.rejected": "Rejeté par le fournisseur",
	"guarantee.surface.building": "Pour des applications de construction : surface (m²) :",
	"guarantee.tonnage.magnelis": "Tonnage de l'acier avec revêtement Magnelis®",
	"guarantee.type": "Type de garantie",
	"guarantee.type.application": "Type d'application",
	"guarantee.type.of.installation": "Type d'installation",
	"guarantee.types.of.guarantee": "Types de garantie",
	"guarantee.unknown": "Unknown",
	"guarantee.upper.structure": "Garantie pour structure supérieure avec Magnelis®",
	"guarantee.urban.agglomeration": "Dans une agglomération urbaine et/ou un environnement industriel",
	"guarantee.use.of.other.materials": "Utilisation d'autres matériaux, notamment le ciment, les parpaings",
	"guarantee.ventilation.roof": "ventilation naturelle grâce à des stores dans le toit",
	"guarantee.ventilation.walls": "ventilation naturelle grâce à des stores dans les murs",
	"guarantee.wall.facade": "Mur / Façade",
	"guarantee.water.analysis": "Une analyse de l'eau est-elle disponible ?",
	"guarantee.water.document": "Veuillez joindre l'analyse de l'eau à la demande de garantie.",
	"guarantee.water.information": "L'analyse de l'eau doit contenir au moins les informations suivantes : Teneur en chlorure, teneur en sulfate, teneur en calcium, teneur en magnésium, alcalinité Ks4,3, valeur du pH, structure/potentiel de l'eau UH, conductivité. Toute autre information sur l'eau, conforme à la norme DIN 50929-3:2018, sera utile.",
	"guarantee.water.requirements.title": "Exigences pour l'analyse de l'eau",
	"guarantee.with.partial.momentary.wetting": "Avec attaque partielle ou momentanée par l’eau de mer et/ou action directe des embruns",
	"guarantee.without.direct.wetting": "Sans possibilité d'attaque directe par l'eau de mer et/ou action directe des embruns",
	"guarantee.without.gratings": "Sans caillebotis",
	"guarantee.zinc": "Acier à revêtement de zinc",
	"gurantee.duration.years": "Durée de garantie prévue (en années)",
	"gurantee.other.coating.mass": "Autre masse de revêtement",
	"help.data.documents": "Documents",
	"help.documents": "Documents d'aide",
	"highest.stocks.widget.title": "Top 5 des stocks les plus élevés",
	"home.batch-list": "Mes produits",
	"home.customer.feedback": "Commentaires des clients",
	"home.dashboard": "Tableau de bord",
	"home.deliveryschedule": "Prévision des livraisons ou suivi des livraisons",
	"home.diplay.last.batches": "Afficher les 20 derniers produits consultés",
	"home.identify.batch": "Identifier un lot",
	"home.last.seen.batch": "Dernière liste des produits consultés",
	"home.no.service": "Votre profil ne vous autorise pas à gérer ce service. Veuillez contacter votre Relay SteelUser pour obtenir plus d'accès à l'application.",
	"home.no.service.alert": "Sans service",
	"home.order-tracking.commercial-documents": "Mes documents commerciaux",
	"home.order-tracking.my-schedule-business-order": "Mes commandes à flux",
	"home.order-tracking.orders": "Mes commandes",
	"home.ordertracking": "Suivi des commandes",
	"home.quality-issues.issues": "Suivi des litiges",
	"import.data": "Import data",
	"import.excel": "Import excel",
	"import.file.message": "Upload an XLS file to import data from existing file. Please follow the template in order to allow automatic detection.",
	"import.file.message.all.fields.mandatory": "All the fields are mandatory.",
	"incoterm.22": "CFR Landed Duty Unpaid",
	"incoterm.23": "CFR Liner Terms Duty Unpaid",
	"incoterm.24": "CFR Free Out Duty Unpaid",
	"incoterm.25": "CIF Landed Duty Unpaid",
	"incoterm.26": "CIF LINER TERMS DUTY UNPAID",
	"incoterm.27": "CIF FREE OUT",
	"incoterm.28": "CFR sous palan",
	"incoterm.33": "CFR FO Quick Custom Desp",
	"incoterm.CFR": "Cost and Freight",
	"incoterm.CIF": "Cost, Insurance, Freight",
	"incoterm.CIP": "Carriage and Insurance Paid to",
	"incoterm.CPT": "Carriage Paid To",
	"incoterm.DAF": "Livré à la frontière",
	"incoterm.DAT": "Livré au terminal",
	"incoterm.DDP": "Delivered Duty Paid",
	"incoterm.DDU": "Delivered Duty Unpaid",
	"incoterm.DEQ": "Carriage Paid To Quay",
	"incoterm.DES": "Delivered Ex Ship",
	"incoterm.FAS": "Free Alongside Ship",
	"incoterm.MAD": "Mise à disposition à l'usine",
	"incoterm.RC": "Y compris le transport chez le client",
	"incoterm.dap": "Livré a lieu de livraison",
	"incoterm.exw": "Ex works",
	"incoterm.fca": "Free Carrier",
	"incoterm.fob": "Free On Board",
	"inner.greater.than.outer.error": "Champ supérieur au Ø extérieur.",
	"internal.placeholder.choose.customer": "Entrez le nom du client",
	"issue.acceptedquantity": "Quantité acceptée",
	"issue.acceptedquantity.value": "Quantité acceptée (valeur)",
	"issue.action.data.center": "Centre de données",
	"issue.action.filters": "Filtres",
	"issue.attach.documents": "Ajouter une pièce jointe",
	"issue.batch.cdd": "CDD",
	"issue.batch.commercial.documents": "Documents commerciaux",
	"issue.batch.customer.order.number": "Numéro de commande client",
	"issue.batch.dimension": "Dimensions (mm)",
	"issue.batch.invoiced": "Invoiced",
	"issue.batch.no.result": "Aucun résultat",
	"issue.batch.number": "Numéro de lot",
	"issue.batch.quick.search": "Recherche rapide",
	"issue.batch.status": "Statut",
	"issue.batch.steelgrade": "Nuance(s) d'acier ",
	"issue.batch.view-details": "Voir les détails",
	"issue.batchesassociated": "produits associés à ce litige",
	"issue.calimed.quantity": "Quantité demandée",
	"issue.calimed.quantity.value": "Quantité demandée (valeur)",
	"issue.cancel": "Your claim has been cancelled successfully",
	"issue.claim": "Litige",
	"issue.closingdate": "Date de clôture",
	"issue.contact.info": "Informations de contact",
	"issue.contact.label": "Je souhaite être contacté par un contact d'ArcelorMittal",
	"issue.contact.type": "Type de contact",
	"issue.creditnote": "Note de crédit",
	"issue.creditnotedate": "Date de la note de crédit",
	"issue.currency": "Devise",
	"issue.customer.defect": "Défaut client",
	"issue.customer.reference": "Référence de litige client",
	"issue.decision": "Décision",
	"issue.defect.type": "Type de défaut",
	"issue.do.you.want.to.be.contacted": "Souhaitez-vous être contacté ?",
	"issue.draft": "Brouillon",
	"issue.draft.deleted": "Votre brouillon a été supprimé avec succès",
	"issue.drag.and.drop.files": "Faites un glisser-déposer de vos fichiers ici",
	"issue.filterbystatus": "Filtrer par statut",
	"issue.followup.widget.title": "Retour qualité",
	"issue.inprocess": "En cours de traitement",
	"issue.invoiced.batch": "Invoiced batches only",
	"issue.issuecard": "Synthèse du litige",
	"issue.issuedocuments": "Documents",
	"issue.issueinformation": "Informations sur le problème",
	"issue.ok.value": "OK",
	"issue.origin": "Origine",
	"issue.origin.ach": "Système de saisie des réclamations d'ArcelorMittal",
	"issue.origin.sta": "SteelUser",
	"issue.pending": "En attente",
	"issue.qualityfeedback": "Tableau de bord Qualité - liste des litiges",
	"issue.qualityissues": "Suivi des litiges",
	"issue.qualityissues.drafts": "Litiges - liste de brouillon",
	"issue.register": "Enregistrer un litige",
	"issue.requested.total.amount": "Quantité totale demandée",
	"issue.requested.total.amount.value": "Quantité totale demandée (valeur)",
	"issue.save.as.drafts": "Enregistrer comme brouillon",
	"issue.select.batches.action.next": "Suivant",
	"issue.select.current.batch": "Votre lot actuellement sélectionné :",
	"issue.select.first.batch": "Sélectionnez le premier lot pour l'enregistrement de votre litige",
	"issue.select.other.batch": "Ou sélectionnez un autre lot",
	"issue.send.claim": "Envoyer",
	"issue.sending.sample": "Envoi d'un échantillon",
	"issue.shipments": "Expéditions",
	"issue.submit.quality.feedback": "Envoyer votre retour qualité",
	"issue.supplierdefect": "Défaut fournisseur",
	"issue.supplierissuenumber": "Numéro de litige ArcelorMittal",
	"issue.total.amount.accepted": "Quantité totale acceptée",
	"issue.total.amount.accepted.value": "Quantité totale acceptée (valeur)",
	"issue.type.of.request": "Type de demande",
	"issue.unit": "Unité",
	"issue.widget.overviewofqi": "Aperçu des problèmes de qualité",
	"issue.widget.selector.feedbackselected": "Vous avez sélectionné : suivi des litiges",
	"issue.widget.selector.validateadvice": "Cliquez pour confirmer votre choix",
	"label.calculation": "Obtenir le calcul",
	"label.coil.calculator": "Calculateur de bobines",
	"last.guarantee.requests": "Dernières demandes de garantie",
	"latitude.N": "N",
	"latitude.S": "S",
	"legal-document.needforsteel.sales.framework": "Cadre de vente ArcelorMittal Need4Steel®",
	"legal-documents.agree.to.sales.conditions": "Veuillez accepter notre",
	"legal-documents.and": "et",
	"legal-documents.confirm.cart.with.sales.conditions": "Lorsque vous confirmez votre panier, vous acceptez nos",
	"legal-documents.general.sales.conditions": "conditions générales de vente",
	"legal-documents.non.prime.sales.framework": "cadre des ventes hors prime",
	"legal.data.header": "Politique et conditions générales de vente",
	"line.select.family.period": "Sélectionner une période",
	"line.select.family.product": "Sélectionner une famille de produits",
	"line.select.period.fiveyears": "5 ans",
	"line.select.period.oneyear": "1 an",
	"line.select.period.sixmonths": "6 mois",
	"line.select.period.threemonths": "3 mois",
	"line.select.period.twoyear": "2 ans",
	"line.select.tab.layout": "Sélectionner l'onglet de votre mise en page",
	"linked.soldto": "Client lié",
	"loader.text": "Chargement des produits",
	"longitude.E": "E",
	"longitude.W": "W",
	"manage.services.add-services": "Ajouter des services",
	"manage.services.drag-and-drop-items-on-the-right": "Glissez-déposez des articles sur la droite pour ajouter un service",
	"manual.data.customer": "Numéro de commande client",
	"manual.data.enter.reference": "Veuillez entrer une référence de commande",
	"manual.data.not.found": "Aucun lot trouvé.",
	"manual.data.num": "Poste",
	"manual.data.reference": "Référence",
	"manual.data.supplier": "Numéro de commande fournisseur",
	"manual.data.supplier.or.customer": "Veuillez saisir le numéro de commande du fournisseur ou du client.",
	"materials.rts.widget.title": "Matériaux prêts à être expédiés",
	"menu.closed.issues": "Litiges traités",
	"menu.declare.choose.customer": "Choisir un client",
	"menu.declare.order-tracking": "Web suivi des commandes  ",
	"menu.declare.order-tracking.deliveryschedule": "Prévision de livraison ou suivi de livraison",
	"menu.declare.order-tracking.ordertracking": "Suivi des commandes",
	"menu.declare.quality.issue": "Déclarer un problème de qualité",
	"menu.drafts": "Brouillon",
	"menu.logout": "DÉCONNEXION",
	"menu.modify.quality.issue": "Modifier un litige",
	"menu.order-services": "Commander des services",
	"menu.pending.issues": "Litiges en cours",
	"menu.product-services": "Services de produits",
	"menu.profile": "Profil",
	"menu.sales-services": "Services commerciaux",
	"menu.settings": "Paramètres",
	"menu.sign.in": "Se connecter",
	"modification.error.message": "Votre modification ne sera pas enregistrée",
	"n4steel.contact-add-attachment": "Ajouter une PJ",
	"n4steel.contact-attachment-help": "Glisser et déposer vos fichiers ici",
	"n4steel.contact-mail": "Contacter ArcelorMittal Need4Steel®",
	"n4steel.contact-mail-from": "De",
	"n4steel.contact-mail-invalid-email": "Format d’adresse e-mail invalide",
	"n4steel.contact-mail-mill": "Usine",
	"n4steel.contact-mail-offer": "Offre concernée",
	"n4steel.contact-mail-prefill-data": "Données envoyées automatiquement par e-mail",
	"n4steel.upload.file.size.error.message": "Max 10Mo par fichier et max 3 fichiers.",
	"navig.confirm": "Confirmer",
	"need4steel-logistic-routes.errormsg": "Max coil weight or Packing not compatible due to selected delivery address.",
	"need4steel-logistic-routes.packaging.errormsg": "Packaging is not compatible with delivery address.",
	"need4steel-order.history.errormsg": "Aucune commande de votre historique ne correspond aux options de cette offre",
	"need4steel-order.history.import": "Importer",
	"need4steel-order.history.notfound": "Aucune commande trouvée",
	"need4steel-order.history.subtitle": "Merci de sélectionner les produits à importer ",
	"need4steel-order.history.title": "Historique de commande",
	"need4steel-product-details-tooltip.no-price-msg": "Données du produit non disponibles",
	"need4steel-product-details-tooltip.price-msg": "Voir les données du produit",
	"need4steel-product-details.chemical-treatment": "Traitement chimique",
	"need4steel-product-details.effectivedelivered": "€/t effectif livré",
	"need4steel-product-details.header-msg": "Détails du product -",
	"need4steel-product-details.max-outside-Diameter": "Diamètre extérieur maximal (mm)",
	"need4steel-product-details.min-coil-weight": "Poids min. de la bobine (t)",
	"need4steel-product-details.proposed-price": "Prix proposé",
	"need4steel-product-details.unrolledWelds": "Soudures déroulées",
	"need4steel-product-offers.additional-fields": "Champs supplémentaires",
	"need4steel-product-section-details.min-coil-weight": "Min Coil Weight (t)",
	"need4steel-schedule.button": "Importer depuis l’historique",
	"need4steel-summary-details.effectivedelivered": "effectif livré",
	"need4steel.dialog.coil.weight": "Poids de bobine maximum (t)",
	"need4steel.dialog.coil.weight.range": "de {{minValue}} à {{maxValue}} t",
	"need4steel.dialog.coil.weight.range.title": "Gamme de poids de bobine maximum",
	"need4steel.dialog.max.coilweight.range.content": "Poids de bobine maximum disponible",
	"need4steel.dialog.max.specific.weight.range.content": "Poids spécifique maximum disponible",
	"need4steel.dialog.range.steelgrade": "Pour la nuance",
	"need4steel.dialog.specific.weight.range": "de {{minValue}} à {{maxValue}} kg/mm",
	"need4steel.dialog.specific.weight.range.title": "Gamme de poids max. spécifique",
	"need4steel.dialog.thickness.content": "Veuillez sélectionner une qualité d'acier",
	"need4steel.dialog.thickness.list.content": "s'il est évident de devoir sélectionner une valeur",
	"need4steel.dialog.thickness.range.content": "Les dimensions d'épaisseur disponibles sont les suivantes",
	"need4steel.dialog.thickness.range.title": "Gamme d'épaisseurs",
	"need4steel.dialog.width.content": "Veuillez saisir une valeur appropriée pour l'épaisseur",
	"need4steel.dialog.width.list.content": "Veuillez sélectionner une valeur appropriée pour l'épaisseur",
	"need4steel.dialog.width.range.content": "Dimensions de largeur disponibles",
	"need4steel.dialog.width.range.title": "Gamme de largeurs",
	"need4steel.dialog.width.range.title.content": "et épaisseur",
	"need4steel.offer.error.message": "Désolé, des erreurs se sont produites lors de l'accès à cette offre. Veuillez réessayer ou envoyer un message à votre contact ArcelorMittal.",
	"need4steel.offer.finishingline": "lignePêche",
	"need4steel.offer.simulation.error.message": "Désolé, des erreurs se sont produites. Veuillez réessayer ou envoyer un message à votre contact ArcelorMittal.",
	"need4steel.offers.order.button": "Commande",
	"need4steel.offers.title": "Offres ArcelorMittal Need4Steel®",
	"need4steel.product.details.product.coilweight": "Poids de bobine max (t)",
	"need4steel.product.details.specific.weight": "Poids spécifique max. (kg/mm)",
	"need4steel.product.thickness.tolerance": "toléranceÉpaisseur",
	"need4steel.soldto.shipto.error.message": "Désolé, il y a un problème dans les paramètres de votre service, Veuillez contacter l'administrateur SteelUser.",
	"need4steel.submit.credit.limit.error.msg": "☹ Demande de commande ArcelorMittal Need4Steel® impossible : limite de crédit disponible non suffisante. Merci de nous contacter à need4steel@arcelormittal.com",
	"need4steel.submit.error.msg": "Une erreur s'est produite, veuillez contacter l'administrateur SteelUser",
	"need4steel.submit.exchange.rate.mandatory.error.msg": "Le taux de change est obligatoire",
	"need4steel.submit.exchange.rate.refreshed.error.msg": "Le taux de change a été actualisé pendant votre processus de commande. Veuillez le vérifier avant de soumettre à nouveau votre commande",
	"need4steel.submit.order.error.msg.title": "Erreur pendant la validation de votre commande",
	"need4steel.submit.order.success.msg.row1": "Votre commande a été traitée",
	"need4steel.submit.order.success.msg.row2": "Vous pouvez suivre le statut de votre commande dans le",
	"need4steel.submit.order.success.msg.row2.link": "SUIVI DES COMMANDES ET EXPÉDITIONS.",
	"need4steel.trademark": "®",
	"need4steel.wizard.coil.error": "Veuillez entrer une valeur valide inférieure ou égale à 1000.",
	"need4steel.wizard.estimated": "Estimé:",
	"need4steel.wizard.exchange-rate.rate": "Taux de change",
	"need4steel.wizard.exchange-rate.reference-date": "Date de référence",
	"need4steel.wizard.header.Delivery-address": "L'adresse de livraison est obligatoire",
	"need4steel.wizard.header.customer": "Le client est obligatoire",
	"need4steel.wizard.header.customer-order-number": "Numéro de commande client",
	"need4steel.wizard.header.customer-order-number.error.invalid": "Numéro de commande client non valide",
	"need4steel.wizard.header.customer-order-number.error.mandatory": "Le numéro de commande client est obligatoire",
	"need4steel.wizard.header.delivery.date": "Date de livraison",
	"need4steel.wizard.header.mill": "Usine",
	"need4steel.wizard.header.shipto": "Adresse de livraison",
	"need4steel.wizard.header.soldto": "client",
	"need4steel.wizard.header.transport-mode": "Mode de transport",
	"need4steel.wizard.maxcoilweight.range.error": "Veuillez saisir un poids maximal de bobine valide.",
	"need4steel.wizard.maxspecificweight.range.error": "Veuillez entrer un poids spécifique maximum valide",
	"need4steel.wizard.no.weight.option.error.message": "Problème de paramétrage des modèles : pas d'options de poids",
	"need4steel.wizard.product.coil.weight": "Poids de bobine max. (t)",
	"need4steel.wizard.product.max.specific.weight": "Poids spécifique max. (kg/mm)",
	"need4steel.wizard.product.price.calculate.offline": "Veuillez vous assurer d'avoir un accès à l'internet pour demander un prix",
	"need4steel.wizard.product.specific.weight": "Poids spécifique max. (kg/mm)",
	"need4steel.wizard.product.weight.type.label": "Sélection du type de poids",
	"need4steel.wizard.step.product.title": "Préciser le produit",
	"need4steel.wizard.stepper.product.action.delete": "Supprimer",
	"need4steel.wizard.stepper.product.action.duplicate": "Dupliquer",
	"need4steel.wizard.stepper.product.action.reset": "Réinitialiser",
	"need4steel.wizard.stepper.product.add": "Ajouter un produit",
	"need4steel.wizard.stepper.product.coil": "# (Bobine)",
	"need4steel.wizard.stepper.product.coilweight": "Poids de bobine max (t)",
	"need4steel.wizard.stepper.product.itemnumber": "Numéro d'article",
	"need4steel.wizard.stepper.product.steelgrade": "Nuance d'acier",
	"need4steel.wizard.stepper.product.thickness": "Épaisseur (mm)",
	"need4steel.wizard.stepper.product.total.weight": "Poids total",
	"need4steel.wizard.stepper.product.width": "Largeur (mm)",
	"need4steel.wizard.stepper.step.product.specification": "Spécifications du produit",
	"need4steel.wizard.stepper.step.summary": "Résumé",
	"need4steel.wizard.summary.confirm.to.order.button": "Confirmer la commande",
	"need4steel.wizard.summary.proceed.order.button": "Passer la commande",
	"need4steel.wizard.summary.product.coils": "Non. de bobines",
	"need4steel.wizard.summary.product.dimension": "Dimensions (mm)",
	"need4steel.wizard.summary.product.price": "Prix (€/t)",
	"need4steel.wizard.summary.product.selection": "Sélection des produits",
	"need4steel.wizard.summary.product.total.weight": "Poids total (t)",
	"need4steel.wizard.summary.terms.conditions.text": "En cliquant sur Passer la commande, vous acceptez les conditions générales d'ArcelorMittal Need4Steel®",
	"need4steel.wizard.thickness.range.error": "Veuillez saisir une épaisseur valide.",
	"need4steel.wizard.thickness.tolerance.field": "Tolérance d'épaisseur",
	"need4steel.wizard.width.range.error": "Veuillez saisir une largeur valide.",
	"new.offer.request.message": "Connaissez-vous la quantité nécessaire pour chaque spécification d'article ?",
	"news.detail": "Voir les détails",
	"news.last-news": "Dernières nouvelles",
	"news.news-list": "Liste de nouvelles",
	"news.view-all": "Voir tout",
	"no.data.error": "No data found in the feasibility sheet",
	"no.guarantee.documents": "Aucun document de garantie",
	"no.legal.documents": "Aucun document trouvé",
	"no.product.family": "Aucune famille de produits trouvée.",
	"no.result": "Aucun résultat trouvé",
	"notifications.daily": "Quotidien",
	"notifications.immediatly": "Immédiatement",
	"notifications.management": "Gestion des notifications",
	"notifications.monthly": "Mensuel",
	"notifications.weekly": "Hebdomadaire",
	"number.of.items.in.order": "Trop d'articles à ajouter à cette commande.",
	"number.of.items.infos.message": "Veuillez saisir le numéro de copie de ce produit que vous souhaitez ajouter comme article à cette commande",
	"number.of.items.label": "Nombre d'articles",
	"number.of.items.limit.in.order": "Nous acceptons uniquement 100 articles par commande. Veuillez revoir votre sélection.",
	"offer-dashboard-card.accepted": "Accepté",
	"offer-dashboard-card.annually": "Annuellement",
	"offer-dashboard-card.monthly": "Mensuellement",
	"offer-dashboard-card.offered": "Proposé",
	"offer-dashboard-card.order": "Commande",
	"offer-dashboard-card.other-period": "Autre Période",
	"offer-dashboard-card.quarterly": "Par trimestre",
	"offer-dashboard-card.remaining-to-order": "Restant à commander",
	"offer-dashboard-card.requested": "Demandé",
	"offer-dashboard-card.semesterly": "Par semestre",
	"offer-dashboard-card.view-details": "Voir les détails",
	"offer-period.from": "Depuis",
	"offer-period.reset": "Réinitialiser",
	"offer-period.to": "À",
	"offer.card.table.header.quantity": "Quantité (t)",
	"offer.current.total.tons": "t",
	"offer.dashboard.services": "Mes services",
	"offer.end.date": "Date de fin",
	"offer.enduser.update.cart.warning": "cet utilisateur final n'est pas compatible avec certains produits sélectionnés. Ils seront automatiquement retirés du panier.",
	"offer.multiple.families": "Multiple",
	"offer.new.request.title": "Nouvelle Demande",
	"offer.product.disabled.tooltip": "Ce produit n'est pas compatible avec l'adresse de livraison ou l'utilisateur final actuellement sélectionné",
	"offer.product.family": "Famille de produits",
	"offer.quantity.framework": "Choisissez les quantités par famille, sur lesquelles vous souhaitez recevoir une offre ",
	"offer.quantity.spot": "Choisissez les quantités par article, sur lesquelles vous souhaitez recevoir une offre ",
	"offer.shipto.update.cart.warning": "Cette adresse de livraison n'est pas compatible avec certains produits sélectionnés. Ils seront automatiquement retirés du panier.",
	"offer.sub.family": "Sous-famille",
	"offer.template.disabled.tooltip": "Ce modèle n'est pas compatible avec l'adresse de livraison ou l'utilisateur final actuellement sélectionné",
	"offer.transport.condition": "Conditions de transport",
	"offer.type.no": "Non",
	"offer.type.yes": "Oui",
	"offer.weight": "Poids",
	"offers.action.next": "Suivant",
	"offers.commercial.terms": "Conditions commerciales",
	"offers.commitment.period": "Période d’engagement",
	"offers.create.details.customer.offer-name": "Numéro de RFQ client",
	"offers.create.details.customer.offer-name.error.mandatory": "Le numéro d’appel d’offres du client est obligatoire",
	"offers.create.details.field.currency": "Sélectionner votre devise",
	"offers.create.details.field.offer-name": "Nom de la demande d'offre",
	"offers.create.details.field.offer-name.error.mandatory": "Le nom de la demande d'offre est obligatoire",
	"offers.create.details.section.entities": "Entités",
	"offers.create.details.section.offer-period": "Durée d'engagement et des conditions de l'offre",
	"offers.create.path.cart": "définir votre quantité",
	"offers.create.path.confirmation": "déposez votre demande d'offre",
	"offers.create.request.offer": "Demander une offre",
	"offers.create.section.offer-period": "Durée d'engagement et des conditions",
	"offers.product.list": "List de produits",
	"offers.proposals.price.nooffer": "Aucune offre disponible",
	"offers.proposals.price.period": "Période correspondante",
	"offers.proposals.price.title": "Dernières propositions de prix",
	"offers.request.info": "Informations sur la demande d’offre",
	"offers.soldTo.selection.text": "Veuillez sélectionner le client approprié pour cette demande d'offre, afin de commencer à afficher la liste des produits disponibles. Tous les articles du panier doivent être liés au même client.",
	"offers.sqmeters": "Mètres carrés",
	"offers.wizard.stepper.customization": "Personnalisation",
	"offers.wizard.stepper.request.and.selection": "Demande d’offre & sélection",
	"offers.wizard.stepper.step.offer-summary": "Résumé",
	"offers.wizard.stepper.step.quantity": "Quantité",
	"offline.alert": "Alerte  ",
	"ok.value": "OK",
	"order-card.batches-at-reshipper": "Chez le réexpéditeur",
	"order-card.batches-available": "produits - Disponibles",
	"order-card.batches-blocked": "produits - Stock bloqué",
	"order-card.batches-called": "Called",
	"order-card.batches-consignment-stock": "Stock en consignation",
	"order-card.batches-delivered": "produits - Livrés",
	"order-card.batches-land-transit": "Transit terrestre",
	"order-card.batches-on-vessel": "Sur navire",
	"order-card.batches-overseas-transit": "Transit outre-mer",
	"order-card.batches-ready-to-ship": "Prêt à expédier",
	"order-card.batches-transit-to-customer": "En transit vers le client",
	"order-card.commercial-documents": "Documents commerciaux",
	"order-card.data-not-found": "Order data not found",
	"order-card.document": "Document",
	"order-card.due-to-technical-issue": "En raison d'un problème technique, nous ne sommes pas en mesure d'afficher ces données",
	"order-card.gross": "Brut: {{value}}",
	"order-card.name": "Nom",
	"order-card.net": "Net : {{value}}",
	"order-card.no-rows-to-show": "Aucune ligne à afficher",
	"order-card.proforma": "Proforma",
	"order-card.type": "Type",
	"order-card.we-are-actively-working": "Nous travaillons activement au rétablissement du service.",
	"order-card.wip-quantity": "Quantité (t)",
	"order-card.work-in-progress": "En cours de réalisation",
	"order-item-status.completely-produced": "Totalement produit",
	"order-tracking.card.batches-in-stock": "produits en stock",
	"order-tracking.card.callables-batches.days": "{{value}} jours",
	"order-tracking.card.callables-batches.view-details": "Voir les détails",
	"order-tracking.card.delivery-date.cdd": "CDD ",
	"order-tracking.card.delivery-date.first-batch": "1ER LOT EN STOCK",
	"order-tracking.card.delivery-date.last-batch": "DERNIER LOT EN STOCK",
	"order-tracking.card.delivery-date.rdd": "RDD",
	"order-tracking.card.delivery-date.view-details": "Voir les détails",
	"order-tracking.card.delivery-status": "Statut de livraison",
	"order-tracking.cdd": "CDD ",
	"order-tracking.choice": "Choix",
	"order-tracking.customerArticleReference": "Référence article client",
	"order-tracking.delivered": "Livré",
	"order-tracking.delivered-t": "Livré (t)",
	"order-tracking.dimension": "Dimensions (mm)",
	"order-tracking.final.use": "Utilisation final",
	"order-tracking.form": "Forme",
	"order-tracking.in.production": "En production",
	"order-tracking.in.production-t": "En production (t)",
	"order-tracking.in.stock": "En stock",
	"order-tracking.in.stock-t": "En stock (t)",
	"order-tracking.in.transit": "En transit",
	"order-tracking.in.transit-t": "En transit (t)",
	"order-tracking.list": "Liste",
	"order-tracking.no.connection": "Le service de suivi des commandes en ligne n'est pas disponible",
	"order-tracking.no.result": "Aucun résultat",
	"order-tracking.overview": "Vue globale",
	"order-tracking.product": "Produit",
	"order-tracking.product.category": "Catégorie de produit",
	"order-tracking.product.description": "Description du produit",
	"order-tracking.running.orders": "Commandes en cours",
	"order-tracking.standard-steel-grade": "Nuance(s) d'acier",
	"order-tracking.standard.steelgrade": "Nuance(s) d'acier",
	"order-tracking.steelgrade": "Nuance(s) d'acier",
	"order.avail-t": "Disponibilités (t)",
	"order.bill.to": "Facturé à",
	"order.book.only": "Carnet de commandes uniquement",
	"order.callable.gross.weight": "Callable gross weight",
	"order.called.gross.weight": "Called gross weight",
	"order.card": "Suivi de commande",
	"order.card.all.documents": "Tous les documents de cette commande",
	"order.card.certificate.display.all": "Afficher tous les certificats",
	"order.card.dates": "Dates",
	"order.card.detail.information": "Voir les informations détaillées de la commande",
	"order.card.dispatch.advice.display.all": "Afficher tous les avis d'expédition",
	"order.card.document.certificates": "Certificats",
	"order.card.document.date": "Date",
	"order.card.document.dispatch.advices": "Avis d'expédition",
	"order.card.document.display.batches": "Afficher tous les produits",
	"order.card.document.invoices": "Factures",
	"order.card.document.number": "Numéro de document",
	"order.card.document.order.acknowledgments": "Accusés de réception",
	"order.card.document.show": "Afficher le document",
	"order.card.document.type": "Type",
	"order.card.followup": "Suivi de commande",
	"order.card.in-consignment": "En consignation",
	"order.card.in-consignment-t": "En consignation (t)",
	"order.card.information": "Informations sur la commande",
	"order.card.invoice.display.all": "Afficher toutes les factures",
	"order.card.last.certificate": "Dernier certificat",
	"order.card.last.dispatch.advice": "Dernier avis d'expédition",
	"order.card.last.documents": "Derniers documents",
	"order.card.last.invoice": "Dernière facture",
	"order.card.last.order.acknowledgment": "Dernier accusé de réception ",
	"order.card.order.acknowledgment.display.all": "Afficher toutes les accusés de réception",
	"order.card.product": "Produit",
	"order.card.xcarb": "XCarb®",
	"order.cdd-week": "CDD (semaine)",
	"order.certificate": "Certificat",
	"order.chemical.passivation": "Chemical Passivation",
	"order.choice": "Choix",
	"order.coating": "Revêtement",
	"order.coating-side": "Côté revêtement",
	"order.color-bottom-side": "Couleur face inférieure",
	"order.color-top-side": "Couleur face supérieure",
	"order.color.category.bottom.side": "Color Category Bottom Side",
	"order.color.category.top.side": "Color Category Top Side",
	"order.confirmed.delivery.date": "Date de livraison confirmée",
	"order.contract.number": "Numéro de contrat",
	"order.creation.date": "Date de création ",
	"order.customer": "Client",
	"order.customer-template-reference": "Référence du template client",
	"order.customer.article.reference": "Référence article client",
	"order.customer.order.number": "Numéro de commande client",
	"order.daysInStock": "Nombre de jours en stock",
	"order.delivered-t": "Livré (t)",
	"order.delivery": "Livraison",
	"order.delivery.address": "Adresse de livraison",
	"order.delivery.mode": "Mode de livraison",
	"order.dim-mm": "Dim (mm)",
	"order.easy-film-bottom": "Easy film en inférieur",
	"order.easy-film-top": "Easy film supérieur",
	"order.easy.film.bottom": "EasyFilm Bottom",
	"order.easy.film.top": "EasyFilm Top",
	"order.ebusiness.order.number": "Référence de la commande eBusiness",
	"order.end.user": "Utilisateur final",
	"order.enduser": "Utilisateur final",
	"order.entry": "Saisie de la commande",
	"order.final-use": "Utilisation final",
	"order.firm": "Organization",
	"order.first.batch.available": "Premier lot disponible",
	"order.first.batch.in.stock": "Premier lot en stock",
	"order.form": "Forme",
	"order.grade": "Nuance(s) d'acier",
	"order.incoterm": "Incoterm",
	"order.incoterm2": "Incoterm2",
	"order.internal-diameter": "Diamètre interne (mm)",
	"order.interpretation.delivery.date": "Date de livraison",
	"order.item.reference.soldto.party": "Article donneur d'ordre",
	"order.item.status": "Statut de l'article commandé",
	"order.last.batch.available": "Dernier lot disponible",
	"order.last.batch.in.stock": "Dernier lot en stock",
	"order.last.updated": "Dernière mise à jour",
	"order.maximum-outside-diameter": "Diamètre extérieur maximum (mm)",
	"order.mill": "Usine",
	"order.mill.order.number": "Numéro de commande usine",
	"order.minimum-outside-diameter": "Diamètre extérieur minimum (mm)",
	"order.no-documents": "Aucun document disponible",
	"order.oil-reference": "Référence de l'huile",
	"order.oil-side": "Côté huilé",
	"order.oil.reference": "Oil Reference",
	"order.ord-t": "Ordre (t)",
	"order.order-status": "Statut de la commande",
	"order.ordered": "Commandé",
	"order.ordered-t": "Commandé (t)",
	"order.orders": "Commandes",
	"order.packing": "Emballage",
	"order.paint.marking.for.sh": "Paint Marking",
	"order.pattern.for.sh": "Pattern",
	"order.place.delivery": "Lieu de livraison",
	"order.prevision.item": "Poste de prévision (Spécification tardive)",
	"order.protection": "Protection",
	"order.provisional": "Provisoire",
	"order.provisional.item": "Article provisoire / ferme",
	"order.rdd": "RDD",
	"order.reason": "Motif de commande",
	"order.responsible.order.manager": "Responsable customer service de la commande",
	"order.sales.quarter": "Trimestre de vente",
	"order.service.level": "Niveau de service",
	"order.service.request": "Demande de service",
	"order.ship.to": "Expédié à",
	"order.sortby": "Trier par",
	"order.spangle": "Spangle",
	"order.standard": "Nuance(s) d'acier standard",
	"order.status": "Statut de la commande",
	"order.steelgrade": "Nuance(s) d'acier",
	"order.stock-alert": "Alerte stock",
	"order.sub.category": "Sub Category",
	"order.submit": "Soumettre",
	"order.supplier": "Fournisseur",
	"order.supplier-rfq-number": "Supplier RFQ number",
	"order.supplier.order.number": "Numéro de commande fournisseur",
	"order.surface-aspect": "Aspect de surface",
	"order.thickness": "Épaisseur",
	"order.transport-mode": "mode de transport",
	"order.transport.mode": "mode de transport",
	"order.ultrasonic.testing": "Ultrasonic Testing",
	"order.width": "Largeur ",
	"order.wip": "En production",
	"order.wip-t": "WIP (t)",
	"order.wip.forecast.stock": "Entrée de stock prévisionnelle",
	"order.wip.quantity": "Quantité ",
	"order.woe.version": "version WOE",
	"order.z.test.certificat": "Z-test Certificat",
	"orderview.sort.cdd": "cdd ",
	"orderview.sort.order": "commande",
	"orderview.sort.product": "produit",
	"organization-type.agency": "Agence",
	"organization-type.buyer": "Acheteur",
	"organization-type.lab": "Laboratoire",
	"organization-type.selag": "Agence vendeur",
	"organization-type.seller": "Vendeur",
	"organization-type.super-user": "Super User",
	"organization-users.one-admin": "One administrator should be selected",
	"organization-users.one-admin-only": "Only one administrator should be selected",
	"organization-users.roles-error": "An error occurred during the update of the user, changes are not saved",
	"organization-users.roles-saved": "Roles have been correctly updated",
	"organization.card.administrator.comment": "Actuellement responsable pour cette organisation",
	"organization.card.administrator.email": "E-mail",
	"organization.card.administrator.name": "Nom",
	"organization.card.details": "Détails",
	"organization.card.details.administrator": "Administrateur",
	"organization.card.details.identity": "Utilisateur",
	"organization.card.identity.address": "Adresse",
	"organization.card.identity.city": "Ville",
	"organization.card.identity.country": "Pays",
	"organization.card.identity.country.AD": "Andorre",
	"organization.card.identity.country.AE": "Émirats Arabes Unis",
	"organization.card.identity.country.AF": "Afghanistan",
	"organization.card.identity.country.AG": "Antigua-et-Barbuda",
	"organization.card.identity.country.AI": "Anguilla",
	"organization.card.identity.country.AL": "Albanie",
	"organization.card.identity.country.AM": "Arménie",
	"organization.card.identity.country.AN": "Antilles néerlandaises",
	"organization.card.identity.country.AO": "Angola",
	"organization.card.identity.country.AQ": "Antarctique",
	"organization.card.identity.country.AR": "Argentine",
	"organization.card.identity.country.AS": "Samoa",
	"organization.card.identity.country.AT": "Autriche",
	"organization.card.identity.country.AU": "Australie",
	"organization.card.identity.country.AW": "Aruba",
	"organization.card.identity.country.AZ": "Azerbaïdjan",
	"organization.card.identity.country.BA": "Bosnie-Herzégovine",
	"organization.card.identity.country.BB": "Barbade",
	"organization.card.identity.country.BD": "Bangladesh",
	"organization.card.identity.country.BE": "Belgique",
	"organization.card.identity.country.BF": "Burkina Faso",
	"organization.card.identity.country.BG": "Bulgarie",
	"organization.card.identity.country.BH": "Bahreïn",
	"organization.card.identity.country.BI": "Burundi",
	"organization.card.identity.country.BJ": "Bénin",
	"organization.card.identity.country.BM": "Bermudes",
	"organization.card.identity.country.BN": "Brunei",
	"organization.card.identity.country.BO": "Bolivie",
	"organization.card.identity.country.BR": "Brésil",
	"organization.card.identity.country.BS": "Bahamas",
	"organization.card.identity.country.BT": "Bhoutan",
	"organization.card.identity.country.BU": "Birmanie",
	"organization.card.identity.country.BV": "Île Bouvet",
	"organization.card.identity.country.BW": "Botswana",
	"organization.card.identity.country.BY": "Biélorussie",
	"organization.card.identity.country.BZ": "Bélize",
	"organization.card.identity.country.CA": "Canada",
	"organization.card.identity.country.CC": "Îles Cocos",
	"organization.card.identity.country.CD": "Rép. dém. Congo",
	"organization.card.identity.country.CF": "République centrafricaine",
	"organization.card.identity.country.CG": "Congo",
	"organization.card.identity.country.CH": "Suisse",
	"organization.card.identity.country.CI": "Côte d'Ivoire",
	"organization.card.identity.country.CK": "Îles Cook",
	"organization.card.identity.country.CL": "Chili",
	"organization.card.identity.country.CM": "Cameroun",
	"organization.card.identity.country.CN": "Chine",
	"organization.card.identity.country.CO": "Colombie",
	"organization.card.identity.country.CR": "Costa Rica",
	"organization.card.identity.country.CS": "ne pas utiliser(S/M)",
	"organization.card.identity.country.CU": "Cuba",
	"organization.card.identity.country.CV": "Cap Vert",
	"organization.card.identity.country.CX": "Île Christmas",
	"organization.card.identity.country.CY": "Chypre",
	"organization.card.identity.country.CZ": "République tchèque",
	"organization.card.identity.country.DE": "Allemagne",
	"organization.card.identity.country.DJ": "Djibouti",
	"organization.card.identity.country.DK": "Danemark",
	"organization.card.identity.country.DM": "Dominique",
	"organization.card.identity.country.DO": "Rép. Dominicaine ",
	"organization.card.identity.country.DZ": "Algérie",
	"organization.card.identity.country.EC": "Équateur",
	"organization.card.identity.country.EE": "Estonie",
	"organization.card.identity.country.EG": "Égypte",
	"organization.card.identity.country.EH": "Sahara Occidental",
	"organization.card.identity.country.ER": "Érythrée",
	"organization.card.identity.country.ES": "Espagne",
	"organization.card.identity.country.ET": "Éthiopie",
	"organization.card.identity.country.FI": "Finlande",
	"organization.card.identity.country.FJ": "Fidji",
	"organization.card.identity.country.FK": "Îles Falkland",
	"organization.card.identity.country.FM": "Micronésie",
	"organization.card.identity.country.FO": "Îles Féroé",
	"organization.card.identity.country.FR": "France",
	"organization.card.identity.country.GA": "Gabon",
	"organization.card.identity.country.GB": "Grande-Bretagne",
	"organization.card.identity.country.GD": "Grenade",
	"organization.card.identity.country.GE": "Géorgie",
	"organization.card.identity.country.GF": "Guyane française",
	"organization.card.identity.country.GH": "Ghana",
	"organization.card.identity.country.GI": "Gibraltar",
	"organization.card.identity.country.GL": "Groenland",
	"organization.card.identity.country.GM": "Gambie",
	"organization.card.identity.country.GN": "Guinée",
	"organization.card.identity.country.GP": "Guadeloupe",
	"organization.card.identity.country.GQ": "Guinée équatoriale",
	"organization.card.identity.country.GR": "Grèce",
	"organization.card.identity.country.GS": "S. Îles Sandwich",
	"organization.card.identity.country.GT": "Guatemala",
	"organization.card.identity.country.GU": "Guam",
	"organization.card.identity.country.GW": "Guinée-Bissau",
	"organization.card.identity.country.GY": "Guyane",
	"organization.card.identity.country.HK": "Hong Kong",
	"organization.card.identity.country.HM": "Îles Heard et McDonald",
	"organization.card.identity.country.HN": "Honduras",
	"organization.card.identity.country.HR": "Croatie",
	"organization.card.identity.country.HT": "Haïti",
	"organization.card.identity.country.HU": "Hongrie",
	"organization.card.identity.country.ID": "Indonésie",
	"organization.card.identity.country.IE": "Irlande",
	"organization.card.identity.country.IL": "Israël",
	"organization.card.identity.country.IN": "Inde",
	"organization.card.identity.country.IO": "Territoire britannique de l'océan Indien",
	"organization.card.identity.country.IQ": "Irak",
	"organization.card.identity.country.IR": "Iran",
	"organization.card.identity.country.IS": "Islande",
	"organization.card.identity.country.IT": "Italie",
	"organization.card.identity.country.JM": "Jamaïque",
	"organization.card.identity.country.JO": "Jordanie",
	"organization.card.identity.country.JP": "Japon",
	"organization.card.identity.country.KE": "Kenya",
	"organization.card.identity.country.KG": "Kirghizstan",
	"organization.card.identity.country.KH": "Cambodge",
	"organization.card.identity.country.KI": "Kiribati",
	"organization.card.identity.country.KM": "Comores",
	"organization.card.identity.country.KN": "St.Chr.",
	"organization.card.identity.country.KP": "Corée du Nord",
	"organization.card.identity.country.KR": "Corée du Sud",
	"organization.card.identity.country.KW": "Koweït",
	"organization.card.identity.country.KY": "Îles Caïmans",
	"organization.card.identity.country.KZ": "Kazakhstan",
	"organization.card.identity.country.LA": "Laos",
	"organization.card.identity.country.LB": "Liban",
	"organization.card.identity.country.LC": "Ste. Lucie",
	"organization.card.identity.country.LI": "Liechtenstein",
	"organization.card.identity.country.LK": "Sri Lanka",
	"organization.card.identity.country.LR": "Libéria",
	"organization.card.identity.country.LS": "Lesotho",
	"organization.card.identity.country.LT": "Lituanie",
	"organization.card.identity.country.LU": "Luxembourg",
	"organization.card.identity.country.LV": "Lettonie",
	"organization.card.identity.country.LY": "Libye",
	"organization.card.identity.country.MA": "Maroc",
	"organization.card.identity.country.MC": "Monaco",
	"organization.card.identity.country.MD": "Moldavie",
	"organization.card.identity.country.ME": "Monténégro",
	"organization.card.identity.country.MF": "Saint-Martin",
	"organization.card.identity.country.MG": "Madagascar",
	"organization.card.identity.country.MH": "Îles Marshall",
	"organization.card.identity.country.MK": "Macédoine du Nord",
	"organization.card.identity.country.ML": "Mali",
	"organization.card.identity.country.MM": "Myanmar",
	"organization.card.identity.country.MN": "Mongolie",
	"organization.card.identity.country.MO": "Macau",
	"organization.card.identity.country.MP": "Îles Mariannes du Nord",
	"organization.card.identity.country.MQ": "Martinique",
	"organization.card.identity.country.MR": "Mauritanie",
	"organization.card.identity.country.MS": "Montserrat",
	"organization.card.identity.country.MT": "Malte",
	"organization.card.identity.country.MU": "Île Maurice",
	"organization.card.identity.country.MV": "Les Maldives",
	"organization.card.identity.country.MW": "Maldives",
	"organization.card.identity.country.MX": "Mexique",
	"organization.card.identity.country.MY": "Malaisie",
	"organization.card.identity.country.MZ": "Mozambique",
	"organization.card.identity.country.NA": "Namibie",
	"organization.card.identity.country.NC": "Nouvelle-Calédonie",
	"organization.card.identity.country.NE": "Niger",
	"organization.card.identity.country.NF": "Île Norfolk",
	"organization.card.identity.country.NG": "Nigéria",
	"organization.card.identity.country.NI": "Nicaragua",
	"organization.card.identity.country.NL": "Pays-Bas",
	"organization.card.identity.country.NO": "Norvège",
	"organization.card.identity.country.NP": "Népal",
	"organization.card.identity.country.NR": "Nauru",
	"organization.card.identity.country.NU": "Niué ",
	"organization.card.identity.country.NZ": "Nouvelle-Zélande",
	"organization.card.identity.country.O1": "Autres NON-ESSENTIELS",
	"organization.card.identity.country.O2": "Autres TASIA",
	"organization.card.identity.country.O3": "Autres TAEX",
	"organization.card.identity.country.O4": "Autres TANY",
	"organization.card.identity.country.OM": "Oman",
	"organization.card.identity.country.OT": "Autres pays",
	"organization.card.identity.country.PA": "Panama",
	"organization.card.identity.country.PE": "Pérou",
	"organization.card.identity.country.PF": "Polynésie française",
	"organization.card.identity.country.PG": "Papouasie-Nouvelle-Guinée",
	"organization.card.identity.country.PH": "Philippines",
	"organization.card.identity.country.PK": "Pakistan",
	"organization.card.identity.country.PL": "Pologne",
	"organization.card.identity.country.PM": "St. Pierre",
	"organization.card.identity.country.PN": "Îles Pitcairn",
	"organization.card.identity.country.PR": "Puerto Rico",
	"organization.card.identity.country.PS": "Palestine Territoires",
	"organization.card.identity.country.PT": "Portugal",
	"organization.card.identity.country.PW": "Palau",
	"organization.card.identity.country.PY": "Paraguay",
	"organization.card.identity.country.QA": "Qatar",
	"organization.card.identity.country.RE": "Île de la Réunion",
	"organization.card.identity.country.RO": "Roumanie",
	"organization.card.identity.country.RS": "Serbie",
	"organization.card.identity.country.RU": "Féd. de Russie",
	"organization.card.identity.country.RW": "Rwanda",
	"organization.card.identity.country.SA": "Arabie Saoudite",
	"organization.card.identity.country.SB": "Îles Salomon",
	"organization.card.identity.country.SC": "Seychelles",
	"organization.card.identity.country.SD": "Soudan",
	"organization.card.identity.country.SE": "Suède",
	"organization.card.identity.country.SG": "Singapour",
	"organization.card.identity.country.SH": "Sainte-Hélène",
	"organization.card.identity.country.SI": "Slovénie",
	"organization.card.identity.country.SJ": "Svalbard",
	"organization.card.identity.country.SK": "Slovaquie",
	"organization.card.identity.country.SL": "Sierra Leone",
	"organization.card.identity.country.SM": "Saint-Marin",
	"organization.card.identity.country.SN": "Sénégal",
	"organization.card.identity.country.SO": "Somalie",
	"organization.card.identity.country.SR": "Surinam",
	"organization.card.identity.country.ST": "Sao Tomé",
	"organization.card.identity.country.STL": "Sans état",
	"organization.card.identity.country.SV": "El Salvador",
	"organization.card.identity.country.SY": "Syrie",
	"organization.card.identity.country.SZ": "Swaziland",
	"organization.card.identity.country.TC": "Îles Turks et Caïques",
	"organization.card.identity.country.TD": "Tchad",
	"organization.card.identity.country.TF": "Terres australes et antarctiques françaises",
	"organization.card.identity.country.TG": "Togo",
	"organization.card.identity.country.TH": "Thaïlande",
	"organization.card.identity.country.TJ": "Tadjikistan",
	"organization.card.identity.country.TK": "Îles Tokélaou",
	"organization.card.identity.country.TL": "Timor-Leste",
	"organization.card.identity.country.TM": "Turkménistan",
	"organization.card.identity.country.TN": "Tunisie",
	"organization.card.identity.country.TO": "Tonga",
	"organization.card.identity.country.TP": "Timor-Oriental",
	"organization.card.identity.country.TR": "Turquie",
	"organization.card.identity.country.TT": "Trinité",
	"organization.card.identity.country.TV": "Tuvalu",
	"organization.card.identity.country.TW": "Taïwan",
	"organization.card.identity.country.TZ": "Tanzanie",
	"organization.card.identity.country.UA": "Ukraine",
	"organization.card.identity.country.UG": "Ouganda",
	"organization.card.identity.country.UM": "Îles Mineures éloignées",
	"organization.card.identity.country.US": "USA",
	"organization.card.identity.country.UY": "Uruguay",
	"organization.card.identity.country.UZ": "Ouzbékistan",
	"organization.card.identity.country.VA": "Cité du Vatican",
	"organization.card.identity.country.VC": "Saint-Vincent",
	"organization.card.identity.country.VE": "Venezuela",
	"organization.card.identity.country.VG": "Îles Vierges britanniques",
	"organization.card.identity.country.VI": "Îles Vierges des États-Unis",
	"organization.card.identity.country.VN": "Vietnam",
	"organization.card.identity.country.VU": "Vanuatu",
	"organization.card.identity.country.WF": "Wallis",
	"organization.card.identity.country.WS": "Îles Samoa",
	"organization.card.identity.country.XK": "Kosovo",
	"organization.card.identity.country.YE": "Yémen",
	"organization.card.identity.country.YT": "Mayotte",
	"organization.card.identity.country.YU": "Yougoslavie",
	"organization.card.identity.country.ZA": "Afrique du Sud",
	"organization.card.identity.country.ZM": "Zambie",
	"organization.card.identity.country.ZR": "Zaïre",
	"organization.card.identity.country.ZW": "Zimbabwe",
	"organization.card.identity.name": "Nom",
	"organization.card.identity.postCode": "Code-postal",
	"organization.card.identity.state": "Pays ou état",
	"organization.card.identity.suppliers": "Fournisseurs",
	"organization.card.identity.vat": "Numéro de TVA",
	"organization.card.manage-transactional-visibilities": "Gérer les visibilités transactionnelles",
	"organization.card.organizationcard": "Détails de l'organisation",
	"organization.card.services": "Services",
	"organization.card.services.no-data": "Vous ne disposez d'aucun service",
	"organization.card.services.tab.desc": "Description",
	"organization.card.services.tab.name": "Nom",
	"organization.card.services.title": "Liste des services",
	"organization.card.services.title.desc": "Liste de tous les services disponibles pour cette organisation dans le contexte fournisseur",
	"organization.card.transactional-visibilities": "Visibilités transactionnelles",
	"organization.card.users": "Utilisateurs",
	"organization.card.visibilities": "Visibilité",
	"organization.details-card.flow-chart": "Organigramme",
	"organization.details-card.flow-chart.current-organization": "Organisation actuelle",
	"organization.details-card.flow-chart.customer": "Client",
	"organization.details-card.flow-chart.desc": "Place de l'organisation dans la hiérarchie",
	"organization.details-card.flow-chart.supplier": "Fournisseur",
	"organization.is-payer": "estPayeur",
	"organization.is-shipto": "estExpédierVers",
	"organization.is-soldto": "estVenduÀ",
	"organization.status.deactivated": "Désactivé",
	"organization.status.deleted": "Supprimé",
	"organization.user-accept": "Accepter",
	"organization.user-id": "ID",
	"organization.user-manage": "Gérer",
	"organization.user-reject": "Rejeter",
	"organization.user-status-in-organization": "Statut dans l'organisation",
	"organization.users.list.desc": "Liste des utilisateurs disponibles pour cette organisation",
	"organizationrole.api": "API",
	"organizationrole.dsu": "Administrateur",
	"organizationrole.hlpdk": "Assistance",
	"organizationrole.subscription": "Notification",
	"organizationrole.user": "Utilisateur",
	"overview.survey-answer": "Je réponds",
	"overview.survey-no-answer": "Non merci",
	"overview.survey.please": "S'il vous plaît",
	"overview.survey.questions": "répondez à ces 3 questions après votre navigation (temps estimé 20 sec)",
	"overview.viewby": "Voir par",
	"product.added.to.cart": "produit(s) a (ont) été ajouté(s) au panier",
	"product.card.new.specification": "Nouvelle spécification",
	"product.error": "unexpected error while trying to look for the product",
	"product.feasibility.not-feasible": "not feasible",
	"product.feasibility.ok": "Produit OK",
	"product.feasibility.pending": "Demande de faisabilité en cours",
	"product.feasibility.refused": "Ce produit n'est pas faisable.",
	"product.feasibility.technical-error": "Technical Error",
	"product.message.product.not.saved": "Impossible d'enregistrer le produit",
	"product.message.template.product.not.saved": "Impossible de créer un nouveau produit",
	"product.most.used.values": "Valeurs les plus utilisées",
	"product.no.original.value": "Pas de valeur originale",
	"product.not.exist": "Ce produit n'existe pas",
	"product.original.value": "Valeur originale",
	"product.other.values": "Autres valeurs existantes",
	"product.pc.label.max": "Max",
	"product.pc.label.min": "Min",
	"product.pc.label.unit": "Unité",
	"product.product.submitted": "Produit envoyé",
	"product.quality.dashboard": "Tableau de bord Qualité",
	"product.save.template.product": "Enregistrer comme nouvelle spécification",
	"product.save.template.product.and.add.to.cart": "Enregistrer et ajouter au panier",
	"product.table.header.add": "Ajouter",
	"product.table.header.view": "Afficher",
	"product.template": "Template de produit",
	"product.template.isbeingsimulated": "Nouvelle spécification en cours de validation ...",
	"product.title.group.certificate": "Certificat",
	"product.title.group.coating": "Revêtement",
	"product.title.group.dimensions": "Dimensions",
	"product.title.group.insulationResistanceTest": "Test de résistance de l'isolation",
	"product.title.group.labelling": "Étiquetage",
	"product.title.group.management": "Gestion",
	"product.title.group.packing": "Emballage",
	"product.title.group.productionProcess": "Processus de production",
	"product.title.group.specifications": "Spécifications",
	"product.title.group.stamping": "Emboutissage",
	"product.title.group.surface": "Surface",
	"product.title.group.surfaceTreatment": "Traitement de surface",
	"product.title.group.use": "Utilisation",
	"product.title.group.weightDiameter": "Poids / diamètre",
	"product.title.group.welds": "Soudures",
	"product.title.section.bottom": "Fond",
	"product.title.section.bundleHeight": "Hauteur du colis",
	"product.title.section.bundleWeight": "Poids du colis",
	"product.title.section.coilWeight": "Poids de la bobine",
	"product.title.section.customerArticle": "Article client",
	"product.title.section.diameter": "Diamètre",
	"product.title.section.edge": "Bord",
	"product.title.section.insideDiameter": "Diamètre intérieur",
	"product.title.section.numberSheetsPerBundle": "Nombre de feuilles par paquet",
	"product.title.section.numberSlitCoilsPerPackage": "Nombre de slit coils par paquet",
	"product.title.section.outsideDiameter": "Diamètre extérieur",
	"product.title.section.packageHeight": "Hauteur du paquet",
	"product.title.section.packageHeightWithPalet": "Hauteur du paquet, palette incluse",
	"product.title.section.packageWeight": "Poids du paquet (plus d'une bobine par paquet)",
	"product.title.section.removableProtectiveFilm": "Film de protection amovible",
	"product.title.section.slabWeightInTon": "Poids de la brame en tonne",
	"product.title.section.specificWeight": "Poids spécifique",
	"product.title.section.thickness": "Épaisseur",
	"product.title.section.top": "Haut de page",
	"product.title.section.weight": "Poids",
	"product.title.section.width": "Largeur",
	"profile.no.access": "Veuillez vous assurer d'avoir un accès à Internet et de vous connecter à l'application pour visualiser le profil.",
	"profile.select": "Profil - Sélectionner",
	"profile.select.visibility": "Sélectionnez une entreprise/visibilité",
	"profile.visibility.all": "Tout",
	"progress.message": "Votre transaction est en cours",
	"progress.message.fastlane": "Votre transaction est en cours",
	"promote.user.message": "Utilisateur à promouvoir :",
	"prototype-card": "Carte de prototype",
	"prototype-card-details.proposed-price": "Proposition de prix",
	"prototype-card-details.proposed-price.na": "N/A",
	"prototype-card.data-not-found": "Le prototype n’existe pas",
	"prototype.card.deliveryweek": "Delivery week",
	"prototype.card.product.source": "source",
	"prototype.card.proposal": "Proposition",
	"prototype.card.proposal.deliveries": "Livraison proposée",
	"prototype.card.proposal.product.information": "Produit proposé",
	"prototype.card.proposed.quantities": "Quantité proposée",
	"prototype.card.proposed.readyForDispatch": "Ready for dispatch at PO receipt",
	"prototype.card.request.deliveries": "Livraison demandée",
	"prototype.card.request.information": "Produit demandé",
	"prototype.card.request.quantities": "Quantité demandée",
	"prototype.card.sheetweight": "Poids d’une feuille",
	"prototype.card.status.accepted": "Accepté",
	"prototype.card.status.materialnotfound": "Matériel non disponible",
	"prototype.card.status.notavailable": "Non disponible",
	"prototype.card.status.refusedbycustomer": "Refusé par le client",
	"prototype.card.status.requested": "Demandé",
	"prototype.production-po-reception-date": "Date de réception de la commande",
	"prototype.production.po-delivery": "Livraison",
	"prototype.production.po.order": "Commande",
	"prototype.status.accepted": "Accepté",
	"prototype.status.closed": "Fermée",
	"prototype.status.confirmed": "Confirmed",
	"prototype.status.decision": "Décision",
	"prototype.status.proposal": "Proposition",
	"prototype.status.refused": "Refusée",
	"prototype.tracker.status": "Statut du prototype",
	"qty-by-family.title.note": "Veuillez indiquer les quantités pour les périodes correspondantes pour cette famille",
	"quality.feedback.card.closed.issues": "Problèmes résolus",
	"quality.feedback.card.closed.paid": "Payé",
	"quality.feedback.card.closed.rejected": "Rejeté",
	"quality.feedback.card.details": "Voir les détails",
	"quality.feedback.card.open.issues": "Problèmes en cours",
	"quality.feedback.card.subtitle": "Détails des litiges résolus",
	"quality.feedback.card.title": "Retour qualité",
	"quality.first.selected.batch": "Vos lots livrés ou prêts à expédier pour la commande",
	"quality.guarantee.request": "Demande de garantie",
	"quality.information": "Informations sur la qualité",
	"quality.issue.save.failed": "Échec de l'envoi du litige.",
	"quality.issues.draft.edit": "Vous pourrez le modifier dans le brouillon de suivi.",
	"quality.issues.draft.saved.successfully": "Votre brouillon a été enregistré",
	"quality.issues.followup": "Vous pourrez le voir dans le suivi de vos litiges.",
	"quality.issues.save.failed.message": "Veuillez réessayer plus tard ou contacter ebusiness.support@arcelormittal.com",
	"quality.issues.submitted.successfully": "Votre litige a été envoyé avec succès.",
	"quality.max.selected.batch": "Lots sélectionnés (6 lots maximum)",
	"quapp.action.add.attach": "Ajout d'une pièce jointe",
	"quapp.action.add.attach.progress": "Ajouté en cours",
	"quapp.action.cancel": "Annuler le litige",
	"quapp.action.change": "Modifier",
	"quapp.action.delete": "Supprimer",
	"quapp.action.edit": "Modifier",
	"quapp.action.go.back": "Retourner",
	"quapp.action.save": "Enregistrer",
	"quapp.action.select.file": "Sélectionnez votre fichier",
	"quapp.action.send": "Envoyer",
	"quapp.action.view": "Voir",
	"quapp.actor.am": "ArcelorMittal",
	"quapp.actor.customer": "Client",
	"quapp.alert": "Alerte",
	"quapp.attach.audio": "Audio",
	"quapp.attach.file": "Fichier (PDF, excel, ...)",
	"quapp.attach.picture": "Image",
	"quapp.attach.record.sound": "Enregistrer un son",
	"quapp.attach.record.video": "Enregistrer une vidéo",
	"quapp.attach.take.picture": "Prendre une photo",
	"quapp.attach.video": "Vidéo",
	"quapp.detector": "Détecteur",
	"quapp.error": "Erreur",
	"quapp.loading": "Téléchargement ",
	"quapp.logout.warning1": "Attention!",
	"quapp.logout.warning2": "En vous déconnectant de l'application, vous perdrez les informations non sauvegardées!",
	"quapp.logout.warning3": "Vous avez actuellement {{value}} action(s) non synchronisée(s).",
	"quapp.logout.warning4": "Voulez-vous vraiment vous déconnecter?",
	"quapp.notif.claim.cancelled": "{{value}} a été annulé",
	"quapp.notif.claim.comment": "Commentaire : {{comment}}",
	"quapp.notif.claim.paid": "{{value}} a été payé ({{montant}}, {{quantité}}, {{unité}})",
	"quapp.notif.claim.refused": "{{value}} a été refusé",
	"quapp.notif.claim.warning": "{{value}} a été enregistré comme avertissement",
	"quapp.notif.label": "Litige mis à jour:",
	"quapp.notif.title": "SteelUser",
	"quapp.notification": "Notification",
	"quapp.page.not.found": "Page non trouvée",
	"quapp.process.closed": "Accepté ou refusé",
	"quapp.process.closed.paid": "Payé",
	"quapp.process.closed.refused": "Refusé",
	"quapp.process.closed.warning": "Enregistré comme Avertissement",
	"quapp.process.create": "En attente de connexion",
	"quapp.process.inprogress": "En cours de traitement par ArcelorMittal",
	"quapp.process.push": "Envoyé à ArcelorMittal",
	"quapp.process.push-cancel": "Annulation envoyée à ArcelorMittal",
	"quapp.process.push-update": "Modification envoyée à ArcelorMittal",
	"quapp.process.registered": "Enregistré par ArcelorMittal",
	"quapp.reader": "Lecteur",
	"quapp.validator": "Valideur",
	"quapp.warning": "Avertissement",
	"readonly.user.error": "Vous n'êtes pas autorisé à effectuer des actions en mode simulation. Vous pouvez uniquement consulter la vue client",
	"remove.notification": "Supprimer la notification",
	"remove.unrecognized.batch": "n'est pas un lot reconnu. Veuillez sélectionner un lot valide.",
	"request-feasibility": "Request feasibility",
	"request.card.information": "Information de la demande",
	"reset.order": "Réinitialisation de votre commande",
	"reset.order.confirmation": "Souhaitez-vous continuer quand même ?",
	"reset.order.warning.add.product.another.family": "Attention : Vous avez déjà un ou plusieurs produits d'une autre famille dans votre panier. L'ajout de ce produit réinitialisera le panier actuel (tous les produits sélectionnés).",
	"reset.order.warning.customer.change": "Attention : Le changement de client d'une commande réinitialise le panier en cours (tous les produits sélectionnés).",
	"saBusinessStatus.closed": "Clôturé",
	"saBusinessStatus.high.risk.external": "Risque externe élevé",
	"saBusinessStatus.high.risk.internal": "Risque interne élevé",
	"saBusinessStatus.high.runner": "Entraînement haut",
	"saBusinessStatus.low.runner": "Entraînement bas",
	"saBusinessStatus.on.hold": "En attente",
	"saBusinessStatus.running": "En cours",
	"saBusinessStatus.running.out": "En fin de vie",
	"saBusinessStatus.start.up": "Mise-en-marche",
	"sb.Cancel": "Annuler",
	"sb.Download": "Télécharger",
	"sb.choose.options": "Choisir les options",
	"sb.detailed.report": "Rapport détaillé",
	"sb.period": "Période",
	"sb.type": "Type",
	"scan.barcode": "Barcode",
	"scan.batch.choose": "Choose this batch",
	"scan.browser.title": "Batch recognition",
	"scan.customer": "Customer",
	"scan.dimensions": "Dimensions",
	"scan.get.closer": "Get closer to the label",
	"scan.go-batch-card": "Go to batch card",
	"scan.invoiced": "Invoiced",
	"scan.looking.batch.data": "Looking for Batch data...",
	"scan.looking.multi.batch.data": "Looking for related batches",
	"scan.material-scan": "Material scan",
	"scan.mill.order": "Mill order",
	"scan.quantity": "Quantity",
	"scan.quantity.optional": "Quantity (optional)",
	"scan.quantity.placeholder": "Type shipped quantity",
	"scan.select.batch": "Select your batch",
	"scan.serial.number": "Serial number",
	"scan.serial.number.placeholder": "Type serial number",
	"scan.supplier.order": "Supplier order",
	"scan.tip.disable-tips": "Disable tips",
	"scan.tip.message": "Can't scan a barcode? Check the settings (top right button) to check that you enabled the right scan mode for your barcode.",
	"scan.tip.ok": "Ok",
	"scan.tip.title": "Tip",
	"scan.title": "Scan the labels",
	"scan.weight": "Weight",
	"schedule-business-order-card.commercial-documents": "Documents commerciaux",
	"schedule-business-order-filter.customer-article-reference": "Référence article client",
	"schedule-business-order-filter.thickness": "Épaisseur (mm)",
	"schedule-business-order-filter.width": "Largeur (mm)",
	"schedule-business-order.SA-unit": "Unité SA",
	"schedule-business-order.card": "Suivi de commandes à Flux",
	"schedule-business-order.cem-partner": "Partenaire CEM",
	"schedule-business-order.certificate": "Certificat",
	"schedule-business-order.choice": "Choix",
	"schedule-business-order.country-of-scf": "Pays de SCF",
	"schedule-business-order.customer-expected-cumul": "Cumul à atteindre",
	"schedule-business-order.customer-realized-cumul": "Cumul atteint",
	"schedule-business-order.customer.article.reference": "Référence article client",
	"schedule-business-order.customer.order.number": "Numéro de commande client",
	"schedule-business-order.delivery": "Livraison",
	"schedule-business-order.delivery.address": "Adresse de livraison",
	"schedule-business-order.delivery.mode": "Mode de livraison",
	"schedule-business-order.final-use": "Utilisation final",
	"schedule-business-order.form": "Forme",
	"schedule-business-order.icon": "icône",
	"schedule-business-order.in-transit-stock": "Stock en transit",
	"schedule-business-order.incoterm": "Incoterm",
	"schedule-business-order.internal-diameter": "Diamètre interne (mm)",
	"schedule-business-order.interpretation-delivery-date": "Date de livraison",
	"schedule-business-order.lead-delay": "Avance / retard",
	"schedule-business-order.needs": "Besoins",
	"schedule-business-order.oil-reference": "Référence de l'huile",
	"schedule-business-order.order-follow-up-schedule": "Planification suivi commande",
	"schedule-business-order.order-reason": "Motif de la commande",
	"schedule-business-order.packing": "Emballage",
	"schedule-business-order.pds-instruction": "Instructions PDS",
	"schedule-business-order.plant-stock": "Stock usine",
	"schedule-business-order.product": "Informations sur le produit",
	"schedule-business-order.product.category": "Catégorie de produit",
	"schedule-business-order.protection": "Protection",
	"schedule-business-order.realized-cumul": "Cumul réalisé",
	"schedule-business-order.reference-of-alignment": "Référence d'alignement",
	"schedule-business-order.sa-business-status": "Statut de la commande à Flux",
	"schedule-business-order.sfc-country": "Pays SFC",
	"schedule-business-order.shortdescription": "Description courte",
	"schedule-business-order.situation-overview": "Aperçu de la situation",
	"schedule-business-order.standard": "Standard",
	"schedule-business-order.standard.steelgrade": "Nuance d’acier",
	"schedule-business-order.stock": "Stock",
	"schedule-business-order.stock-blocked": "Stock bloqué",
	"schedule-business-order.stock-partner": "Partenaire du stock",
	"schedule-business-order.supplier.order.number": "Numéro de commande fournisseur",
	"schedule-business-order.surface-aspect": "Aspect de la surface",
	"schedule-business-order.time-of-alignment": "Date de consommation",
	"schedule-business-order.transport-mode": "Transport mode",
	"schedule-business-order.wip": "WIP",
	"search.batches": "produits",
	"search.by": "recherche par",
	"search.certificates": "Certificats",
	"search.claim": "Litiges",
	"search.count.batches": "{{value}} produits",
	"search.count.closed": "{{value} litiges clos",
	"search.count.drafts": "{{value} brouillons",
	"search.count.orders": "{{value} commandes",
	"search.count.pending": "{{value} litiges en attente",
	"search.dispatch.advices": "Avis d'expédition",
	"search.display": "Afficher",
	"search.guarantees": "Garanties",
	"search.invoices": "Factures",
	"search.order.acknowledgments": "Accusés de réception",
	"search.placeholder": "Rechercher...",
	"search.see.result": "Voir le résultat",
	"search.see.results": "Voir les résultats {{value}}",
	"search.shipment": "Expédition",
	"search.shipments": "Expéditions",
	"section.filters": "Filtres",
	"see.all.batches": "See all batches",
	"see.all.documents": "Voir tous les documents",
	"select.auction.title": "Sélectionnez votre enchère",
	"select.new.administrator": "La suppression de cet utilisateur nécessitera la sélection d'un nouvel administrateur pour cette organisation :",
	"select.product.spec": "Filtrer le catalogue produits",
	"sent.closed.no.issue": "Aucun incident fermé",
	"sent.hide.process": "Masquer le processus",
	"sent.issue": "Litiges",
	"sent.pending.no.issue": "Aucun litige en attente",
	"sent.search.issues": "Rechercher litiges",
	"sent.show.process": "Afficher le processus",
	"sent.since": "Depuis {{value}}",
	"sent.status": "STATUT",
	"service.parameters.value": "Valeur",
	"services.Back": "RETOUR À L'AJOUT D'UN SERVICE",
	"services.management": "Gestion des services",
	"services.settings": "Paramètres",
	"settings.account": "Mon compte",
	"settings.actions": "Actions",
	"settings.activity": "Activité",
	"settings.activity-desc": "Dernière activité",
	"settings.add-all-services": "Ajouter tous les services",
	"settings.all-services-added": "Tous les services ajoutés à l'utilisateur",
	"settings.any": "N'importe lequel",
	"settings.boolean.off": "Désactivé",
	"settings.boolean.on": "Activé",
	"settings.business-id": "ID professionnel",
	"settings.change-simulated-user": "Changer l'utilisateur simulé",
	"settings.city": "Ville",
	"settings.company": "Société",
	"settings.date-format-dd/mm/yyyy": "jj/mm/aaaa",
	"settings.date-format-mm/dd/yyyy": "mm/jj/aaaa",
	"settings.delegation.changement": "Changer ma délégation d'organisation",
	"settings.download.aggregated": "Agrégé",
	"settings.download.duplicate": "Dupliquer",
	"settings.drag-drop-services-here": "Faites un glisser-déposer des services que vous souhaitez ajouter ici",
	"settings.drag-services-here": "Faites glisser les services ici pour les supprimer de l'utilisateur",
	"settings.email": "Email",
	"settings.faq": "FAQ",
	"settings.firstname": "Prénom",
	"settings.gender": "Sexe",
	"settings.general": "Paramètres généraux",
	"settings.general.date-format": "Format de la date",
	"settings.general.helper": "Paramètres des applications mobiles et éléments web",
	"settings.general.time-format": "Format de l'heure",
	"settings.generalSalesCondition": "Conditions générales de vente",
	"settings.identity": "Utilisateur",
	"settings.identity.desc": "Données personnelles de l'utilisateur",
	"settings.informational-visibilities": "Visibilités informationnelles",
	"settings.last-connection-date": "Date de dernière connexion",
	"settings.lastname": "Nom",
	"settings.legal-information": "Informations juridiques",
	"settings.legal-information.property": "L'application SteelUser est la propriété de ArcelorMittal FCE SA domiciliée au 24-26 Boulevard d'Avranches L-1160 Luxembourg, Luxembourg.",
	"settings.legal-information.questions": "Veuillez adresser toutes vos questions ou commentaires sur cette application à notre équipe e-services :",
	"settings.legal-information.require-registration": "L'utilisation de l'application nécessite une inscription.",
	"settings.login": "Connexion",
	"settings.logout": "Déconnexion",
	"settings.manage-info-visibilities": "Gérer les visibilités informationnelles",
	"settings.manage-services": "Gérer les services",
	"settings.name": "Nom",
	"settings.order.customer": "Numéro de commande client",
	"settings.order.number": "Numéro de commande",
	"settings.order.supplier": "Numéro de commande fournisseur",
	"settings.order.tracking": "Suivi de la commande",
	"settings.ordertracking.sorting.list": "Tri par défaut de la liste",
	"settings.organisation": "Organisation",
	"settings.organizations": "Organisations",
	"settings.organizations.desc": "Abonnement utilisateur d'une organisation",
	"settings.organizations.name": "Nom",
	"settings.organizations.role": "Rôle",
	"settings.organizations.visibilities.address": "Adresse",
	"settings.organizations.visibilities.name": "Nom/ville",
	"settings.other": "Autres paramètres",
	"settings.password-doesn't-match-rules": "Le mot de passe ne respecte pas les règles ci-dessous",
	"settings.password-updated-successfully": "Mot de passe mis à jour avec succès",
	"settings.phone": "Téléphone portable",
	"settings.phone-number": "Numéro de téléphone",
	"settings.privacy-policy": "Politique de confidentialité",
	"settings.privacypolicy.ContactUs": "Contactez le support E-business ",
	"settings.privacypolicy.ContactUsAddress": "Arcelormital FCE SA, 24-26 boulevard D’avranches L-1160 Luxembourg, Luxembourg",
	"settings.privacypolicy.ContactUsByEmail": "ou par e-mail à",
	"settings.privacypolicy.ContactUsPlease": "Veuillez adresser vos questions ou commentaires concernant cette politique de confidentialité à:",
	"settings.privacypolicy.GeneralInformation": "Informations générales",
	"settings.privacypolicy.GeneralInformationProperty": "SteelUser est la propriété d'ArcelorMittal France. ArcelorMittal France, société française immatriculée au registre du commerce et des sociétés de Bobigny sous le numéro 562 094 425, dont le siège social est situé Immeuble \"Le Cézanne, 6, rue André Campra, F-93200 Saint-Denis, France héberge le site SteelUser.com, coordonne la maintenance du site et s'occupe des fonctions d'intégration. En vous inscrivant comme membre de SteelUser, vous pouvez effectuer des transactions (achat, suivi de commande en ligne, accès aux documents de vente, etc.) sur Internet en toute sécurité et confidentialité.",
	"settings.privacypolicy.GeneralInformationWebservices": "La plateforme SteelUser offre aux clients d'ArcelorMittal des services web avancés tels que le suivi des commandes en ligne, la consultation des documents commerciaux, les ventes aux enchères de matériaux non primaires, la saisie des commandes en ligne et la consultation des données techniques. Elle simplifie et accélère les relations entre les acheteurs d'acier et ArcelorMittal.",
	"settings.privacypolicy.HypertextLinksContent": "Les liens hypertextes mis en place sur la plate-forme SteelUser en direction d'autres ressources présentes sur le réseau Internet, et notamment vers ses partenaires, ont fait l'objet d'une autorisation préalable, expresse et écrite. Les utilisateurs du site SteelUser peuvent mettre en place un hyperlien en direction de ce site sans l'autorisation expresse et préalable de ArcelorMittal.",
	"settings.privacypolicy.PersonalInformation": "Les informations personnelles que vous choisissez de soumettre",
	"settings.privacypolicy.PersonalInformationContent": "L'objectif de la plateforme SteelUser est de soutenir certains processus commerciaux entre ArcelorMittal, à savoir la gestion des commandes, le suivi des litiges, les ventes aux enchères, la libération des droits de propriété intellectuelle.",
	"settings.privacypolicy.PrivacyPolicy": "Politique de confidentialité",
	"settings.privacypolicy.PrivacyPolicyContent": "La protection de votre vie privée et de vos données personnelles est importante pour nous. ArcelorMittal a adopté une procédure de protection des données (\"Binding Corporate Rules\"). Cette procédure fournit une base juridique globale et simplifiée pour toutes les bases de données et applications partageant des données personnelles au sein du groupe. La procédure de protection des données d'ArcelorMittal est une procédure à l'échelle du groupe garantissant un standard minimum de protection des données personnelles partagées au niveau mondial, similaire à la protection offerte par les règles de l'UE. La procédure de protection des données d'ArcelorMittal (\"Binding Corporate Rules\") ainsi que les principales politiques sont publiées sur",
	"settings.privacypolicy.Property": "Propriété intellectuelle et industrielle",
	"settings.privacypolicy.PropertyContent": "Le contenu de la plateforme SteelUser (y compris, sans limitation de caractère, les textes, les images graphiques, les fichiers audio/vidéo, le code HTML, les boutons, les marques commerciales, les logiciels, les emblèmes) est la propriété d'ArcelorMittal, sauf indication contraire. Il respecte les droits relatifs aux tiers. Le contenu ne peut être commercialisé, distribué, transmis, copié, modifié de quelque manière que ce soit sans le consentement préalable et écrit d'ArcelorMittal. L'utilisation non autorisée du contenu de la plate-forme SteelUser est strictement interdite. Cela constitue une violation de la législation, y compris la propriété intellectuelle, commerciale, les noms commerciaux ou tout autre type de droits de la propriété industrielle. Les utilisateurs pourront télécharger, visualiser ou imprimer une copie de cette page sur un ordinateur personnel exclusivement pour un usage personnel et privé.",
	"settings.privacypolicy.Protection": "Protection des données personnelles",
	"settings.privacypolicy.Protection2years": "En cas d'inactivité de l'utilisateur pendant 2 ans, l'accès au SteelUser sera automatiquement supprimé. Les informations personnelles qui ne sont plus nécessaires pour atteindre les objectifs identifiés sont détruites, effacées ou rendues anonymes. ArcelorMittal a élaboré des directives et mis en œuvre des procédures pour régir la destruction des informations personnelles.",
	"settings.privacypolicy.ProtectionAbuse": "Les utilisateurs doivent s'abstenir, s'agissant des données nominatives auxquelles ils peuvent accéder dans toute base de données, de tout abus d'aucune sorte, ainsi que de tout acte susceptible de porter atteinte à la vie privée ou à la réputation des personnes.",
	"settings.privacypolicy.ProtectionCommunication": "ArcelorMittal communique aux utilisateurs que leurs données personnelles ne seront pas transmises à des tiers. Si nécessaire, l'autorisation sera demandée en expliquant les raisons et les activités pour lesquelles les informations seront utilisées une fois et si l'autorisation est donnée. Leurs données seront traitées avec une confidentialité absolue. Si pour une raison quelconque, le consentement de l'utilisateur pour le traitement et la cession de ses données peut être révoqué en contactant l'adresse référencée à la fin de cette section. Lorsque l'information demandée, nous comprenons que l'utilisateur accepte (i) que ArcelorMittal peut partager ses informations au sein de ses filiales (les sociétés sont indexées dans la page web www.arcelormittal.com) et (ii) permet à ArcelorMittal, d'utiliser cette information dans l'avenir pour informer l'utilisateur sur des questions ou des sujets d'intérêt pour l'utilisateur en relation avec ArcelorMittal et ses produits.",
	"settings.privacypolicy.ProtectionResponsible": "Lorsque nous avons donné à l'utilisateur (ou lorsque l'utilisateur a choisi) un mot de passe qui lui permet d'accéder à certaines parties du site SteelUser, l'utilisateur est responsable de la confidentialité de ce mot de passe. Nous demandons à l'utilisateur de ne pas partager son mot de passe avec qui que ce soit. L'utilisateur accepte (a) de nous informer immédiatement de toute utilisation non autorisée de son mot de passe ou de son compte ou de toute autre violation de la sécurité, et (b) de s'assurer que l'utilisateur quitte son compte à la fin de chaque session. Il incombe à l'utilisateur de contrôler la diffusion et l'utilisation de son mot de passe, de contrôler l'accès à son compte et son utilisation, et de nous informer lorsque l'utilisateur souhaite annuler son compte sur ce site. Nous ne sommes pas responsables de toute perte ou de tout dommage résultant du non-respect de cette disposition.",
	"settings.privacypolicy.ProtectionSecrecy": "ArcelorMittal s'engage à respecter son obligation de secret des données personnelles. Son devoir est de les traiter avec confidentialité et d'assumer les mesures de sécurité nécessaires de nature technique et organisationnelle pour éviter l'altération, la perte ou l'accès non autorisé de ces informations.",
	"settings.privacypolicy.ResponsabilitiesContent": "ArcelorMittal met en œuvre la plateforme SteelUser pour offrir aux utilisateurs des données et/ou des outils disponibles et vérifiés, mais ArcelorMittal n'est pas responsable des erreurs, du manque de disponibilité des données, et/ou de la présence d'un virus sur SteelUser.",
	"settings.privacypolicy.UseCookiesInstalled": "En visitant SteelUser, l'utilisateur accepte que des cookies soient installés dans son logiciel de navigation. Les cookies permettent d'enregistrer des informations pertinentes pour la navigation de l'utilisateur sur le site. Ils ne sont utilisés par SteelUser que pour assurer le bon fonctionnement des sections privées du site.",
	"settings.privacypolicy.UseCookiesNavigation": "Les paramètres du logiciel de navigation permettent à l'utilisateur d'être informé de la présence de cookies et de les refuser s'il le souhaite de la manière suivante :",
	"settings.privacypolicy.UseCookiesRefusing": "L'utilisateur est toutefois informé que le refus des cookies entraînera l'impossibilité pour lui d'accéder aux parties privées du site, notamment, il ne pourra pas effectuer de transactions en ligne.",
	"settings.privacypolicy.UseDataProvidedConsultrectify": "Certains utilisateurs joueront le rôle d'administrateur et géreront les profils des membres de leur entreprise. Les administrateurs doivent informer ces utilisateurs du droit qu'ils ont d'accéder, de modifier et de supprimer les profils qui les concernent. Chaque utilisateur du SteelUser dispose d'un droit de consultation et de rectification de ses données nominatives, qu'il peut exercer en écrivant à l'adresse suivante : Arcelormital FCE SA, 24-26 boulevard D'avranches L-1160 Luxembourg, Luxembourg ou par email à",
	"settings.privacypolicy.UseDataProvidedResponses": "L'utilisateur est informé que les réponses saisies dans SteelUser, notamment celles requises pour accéder aux sections privées dudit site en tant que membre, pourront être utilisées par ArcelorMittal, et transférées aux services chargés des opérations industrielles et commerciales, indispensables à la prise en compte et au traitement des transactions.",
	"settings.privacypolicy.UseGoogleAnalytics": "Utilisation de Google Analytics",
	"settings.privacypolicy.UseGoogleAnalyticsContent": "Les cookies Google Analytics sont utilisés pour collecter des informations sur la façon dont les visiteurs utilisent notre site. Nous utilisons ces informations pour compiler des rapports et nous aider à améliorer le site.  Les cookies collectent des informations sous une forme anonyme, notamment le nombre de visiteurs du site, la provenance des visiteurs et les pages qu'ils ont visitées. Pour obtenir des informations sur la manière dont Google utilise les données, veuillez consulter l'URL suivante :",
	"settings.privacypolicy.Worldwidetransfer": "Transfert mondial des données personnelles",
	"settings.privacypolicy.amwebsite": "Site web d'ArcelorMittal",
	"settings.privacypolicy.creditsforpictures": "Crédits pour les images",
	"settings.privacypolicy.hypertextlinks": "Liens hypertextes",
	"settings.privacypolicy.ifyouareusing": "Si vous utilisez",
	"settings.privacypolicy.responsabilities": "Responsabilités",
	"settings.privacypolicy.tableofcontent": "Table des matières",
	"settings.privacypolicy.usecookies": "Utilisation des cookies",
	"settings.privacypolicy.usedataprovided": "Utilisation des données fournies",
	"settings.privacypolicy.worldwidetransfercontent": "Les entités d'ArcelorMittal du monde entier peuvent avoir accès à SteelUser. Les données personnelles seront utilisées uniquement aux fins décrites dans la présente politique de confidentialité. Un niveau de protection adéquat sera assuré et des mesures de sécurité appropriées seront prises afin de protéger ces données personnelles contre toute destruction accidentelle ou illégale, perte accidentelle, altération, divulgation ou accès non autorisé. En utilisant SteelUser, vous consentez à un tel transfert.",
	"settings.product": "Produit",
	"settings.product.article": "Référence article client",
	"settings.product.standard.dimension": "Nuance d’acier + Dimensions",
	"settings.product.steelgrade": "Nuance(s) d'acier",
	"settings.profile": "Profil",
	"settings.remove-service": "Supprimer le service",
	"settings.remove-service-confirmation": "Souhaitez-vous vraiment supprimer ce service",
	"settings.requested.email": "Requested Email",
	"settings.sales.framework": "Cadre de vente",
	"settings.save-changes": "Enregistrer les modifications",
	"settings.scan": "Scanner",
	"settings.scan.beep": "Bip",
	"settings.scan.display-tip": "Conseil d'affichage",
	"settings.scan.mode": "Type de scannage",
	"settings.scan.mode.laser": "Scan laser / valeur unique",
	"settings.scan.mode.matrix": "Scan matrice / zones multiples",
	"settings.select.download-type": "Sélectionnez la façon dont vous souhaitez télécharger les données :",
	"settings.select.language": "Sélectionnez la langue:",
	"settings.select.order.number": "Sélectionnez la manière dont vous souhaitez afficher les références de la commande:",
	"settings.select.ordertracking.sortlist": "Sélectionnez la façon dont vous voulez trier votre liste dans le suivi des commandes:",
	"settings.select.product": "Sélectionnez la manière dont vous souhaitez afficher le produit:",
	"settings.select.scan.beep": "Voulez-vous entendre un bip à chaque fois que les valeurs sont reconnues:",
	"settings.select.scan.mode": "Sélectionnez la méthode de scan que vous souhaitez utiliser:",
	"settings.select.weight": "Sélectionnez la manière dont vous souhaitez afficher le poids:",
	"settings.services-mangement": "Gestion des services",
	"settings.snackbar.downloadType": "Désormais, votre type de téléchargement est le suivant : {{downloadType}}.",
	"settings.snackbar.language": "Votre langue est désormais le français.",
	"settings.snackbar.order": "L'affichage de votre référence de commande est désormais {{order}}.",
	"settings.snackbar.product": "Votre affichage produit est désormais {{product}}.",
	"settings.snackbar.visibility": "Vous serez désormais en mesure d'afficher les données pour {{visibility}} du fournisseur {{supplier}}.",
	"settings.snackbar.weight": "L'affichage du poids est désormais {{weight}}.",
	"settings.supplier": "Fournisseur",
	"settings.survey.wot.overview": "concernant la nouvelle page de présentation des commandes et des livraisons.",
	"settings.terms.of.use": "Conditions d'utilisation",
	"settings.time-format-12:00": "12:00",
	"settings.time-format-24:00": "24:00",
	"settings.update.validate": "Valider",
	"settings.user-update-error": "Une erreur s'est produite lors de la mise à jour de l'utilisateur, les modifications ne sont pas enregistrées",
	"settings.visibility": "Visibilité",
	"settings.visibility.changeimpact": "En modifiant cette valeur, cela impactera vos autres systèmes Steeluser.",
	"settings.visibility.data": "Je peux actuellement voir les données pour (Organisation - Fournisseur)",
	"settings.visibility.helper": "Sélectionner le cadre de vos applications mobiles et éléments web",
	"settings.visibility.info": "La visibilité sera partagée sur toutes les plateformes Steeluser (mobiles et web).",
	"settings.weight": "Poids",
	"settings.weight.gross": "Brut",
	"settings.weight.net": "Net",
	"share.view.share": "Partager",
	"shareview.success.message": "partagé avec succès",
	"shipment-card.data-not-found": "Shipment data not found",
	"shipment.card": "Carte d'expédition",
	"shipment.card.information": "Informations d'expédition",
	"shipment.dispatch-advice": "Avis d'expédition",
	"shipment.dispatch-advice-date": "Date de l'avis d'expédition",
	"shipment.dispatch-advice-number": "Numéro de l'avis d'expédition",
	"shipment.dispatch-date": "Date d'expédition",
	"shipment.filter.batch-number": "Numéro de lot",
	"shipment.filter.customer": "Client",
	"shipment.filter.customer-article-reference": "Référence article client",
	"shipment.filter.customer-order-number": "Numéro de commande client",
	"shipment.filter.dispatch-advice-date": "Date de l'avis d'expédition",
	"shipment.filter.dispatch-advice-number": "Numéro de l'avis d'expédition",
	"shipment.filter.dispatch-date": "Date d'expédition",
	"shipment.filter.mill": "Usine",
	"shipment.filter.ship-to": "Expédié à",
	"shipment.filter.sold-to": "Vendu à",
	"shipment.filter.standard-steelgrade": "Nuance d’acier",
	"shipment.filter.supplier-order-number": "Numéro de commande fournisseur",
	"shipment.filter.thickness": "Épaisseur",
	"shipment.filter.transport-mode": "Mode de transport",
	"shipment.filter.transport-reference": "N° de transport",
	"shipment.filter.width": "Largeur",
	"shipment.first": "Premier",
	"shipment.last": "Dernier",
	"shipment.shipped-qty-gross": "Qté brute expédiée (t)",
	"shipment.step": "Étape",
	"shipment.tmode.byairplane": "Par avion",
	"shipment.tmode.byinlandwaterways": "Par voie maritime intérieure",
	"shipment.tmode.byrail": "Par train",
	"shipment.tmode.byrail.feve": "Par train (FEVE)",
	"shipment.tmode.byrailroad": "Par train et voie routière",
	"shipment.tmode.byroad": "Par route",
	"shipment.tmode.bysea": "Maritime",
	"shipment.tmode.bytrain": "Train",
	"shipment.tmode.notspecified": "Non spécifié",
	"shipment.to": "Expédition vers",
	"shipment.transport-reference": "N° de transport",
	"simulated.customer.updated": "Le client simulé a été mis à jour.",
	"snackbar.add.existing.user.validation.mail-external": "User has been correctly created.",
	"snackbar.add.user.validation.mail-external": "User has been correctly created. An email has been sent to the new user to activate the account.",
	"snackbar.add.user.validation.mail-internal": "User has been correctly created. An email has been sent to the admin for validation.",
	"snackbar.offline": "Vous devez être connecté pour modifier un paramètre",
	"snackbar.survey": "Merci d'avoir pris le temps, votre retour d'information est très important pour nous.",
	"sortby.cdd.asc": "CDD asc",
	"sortby.cdd.desc": "CDD desc",
	"sortby.order.asc": "Commande asc",
	"sortby.order.desc": "Commande desc",
	"sortby.product.asc": "Produit asc",
	"sortby.product.desc": "Produit desc",
	"srvmg.requestor.description": "Agir en tant que demandeur SOX",
	"srvmg.requestor.label": "Demandeur",
	"srvmg.validator.description": "Agir en tant que validateur SOX",
	"srvmg.validator.label": "Validateur",
	"standard-steelgrade": "Standard steelgrade",
	"start.date": "Date de début",
	"status-group.blocked": "Stock bloqué",
	"status-group.in-consignment": "En stock de consignation",
	"status-group.in-prod": "En production",
	"status-group.in-transit": "En transit vers le client",
	"status-group.rtt": "prêt a expedier",
	"steelgrade-feasibility": "Steelgrade",
	"stock-alert.green": "Green",
	"stock-alert.orange": "Orange",
	"stock-alert.red": "Red",
	"submit.guarantee.request": "Soumettre votre demande de garantie",
	"supplier.comment": "Commentaire du fournisseur",
	"suppliergroup.amds": "ArcelorMittal Distribution Solutions",
	"suppliergroup.aperam": "Aperam",
	"suppliergroup.fce": "ArcelorMittal FCE",
	"survey.agree": "j'accepte",
	"survey.amount.of.time": "temps passé pour trouver les informations",
	"survey.answer.dialog.title": "Veuillez évaluer l'accessibilité de",
	"survey.clarity.information": "clarté des informations",
	"survey.disagree": "je ne suis pas d'accord",
	"survey.ease.find.information": "facile de trouver les informations",
	"survey.evaluate.statement": "Évaluer les 3 affirmations suivantes",
	"survey.header.title": "Donnez-nous votre avis",
	"survey.statements": "Je suis satisfait de",
	"survey.strongly": "Fortement",
	"table.no.results": "aucun résultat",
	"table.results": "{{value}} résultats",
	"term.policy": "Politique et conditions générales de vente",
	"title.product.catalogue": "Ajouter un nouveau produit à votre catalogue",
	"title.product.order": "Sélectionner le produit que vous souhaitez commander",
	"tmode.byair": "Par avion",
	"tmode.bysea": "Par voie maritime",
	"tmode.default": "_Par défaut",
	"tmode.inlandwaterway": "Voie maritime intérieure",
	"tmode.lorry": "Camion",
	"tmode.lorryrailway": "Camion + Chemin de fer",
	"tmode.othertospecify": "autre (à préciser)",
	"tmode.rail": "par train",
	"tmode.railwaylorry": "Chemin de fer + Camion",
	"total.quantity.period": "Quantité totale pour la période",
	"transport.mode": "Mode de transport",
	"transport.mode.boat": "Bateau",
	"transport.mode.plane": "Avion",
	"transport.mode.train": "Train",
	"transport.mode.truck": "Camion",
	"transversal.dashboard": "Tableau de bord",
	"transversal.dashboard.plural": "Tableaux de bord",
	"transversal.data-administration": "Administration",
	"transversal.data-center": "Centre de données",
	"transversal.data-center-batches": "Produits",
	"transversal.data-center-documents": "Documents commerciaux",
	"transversal.data-center-order": "Commandes",
	"transversal.data-center.batches": "Centre de données : Produits",
	"transversal.data-center.plural": "Centre de données",
	"transversal.data-center.prototype": "Prototypes",
	"transversal.data-center.users": "Utilisateurs",
	"transversal.delegated-to": "Délégué à",
	"transversal.eoffer": "eOffre",
	"transversal.equality": "eQualité",
	"transversal.go-back-to-old-steeluser": "Accès à l'ancien Steeluser",
	"transversal.guarantee-documents": "Documents de garantie",
	"transversal.home": "Accueil",
	"transversal.in-a-delegation": "(en délégation)",
	"transversal.lastbatches": "Derniers produits",
	"transversal.legal": "Légal",
	"transversal.order-tracking": "Suivi des commandes",
	"transversal.order.delivery": "Commandes et livraisons",
	"transversal.quality": "Qualité",
	"transversal.schedule-busiess-order": "Commandes à flux planifiées",
	"transversal.services": "Services",
	"transversal.shipments": "Expéditions",
	"transversal.simulation-of": "Simulation de",
	"transversal.steeluser": "SteelUser",
	"unit.kg": "kg",
	"unit.m2": "m²",
	"unit.pc": "Pièces",
	"unit.to": "Tonnes métriques",
	"unrecognized.batch": "Lot non reconnu",
	"upload.file.count.error.message": "-max-count- fichiers maximum par article",
	"upload.file.error.message": "Une erreur est survenue durant l’upload du fichier",
	"upload.file.maxitem.error.message": "3 fichiers maximum par article",
	"upload.file.mime.type.error.message": "PDF, DOC, XLS, PPT ou images uniquement autorisés. Le type de téléchargement est MIME--TYPE",
	"upload.file.name.error.message": "Invalid file name - Use alphanumeric, hyphens, spaces, underscores and at least 5 characters",
	"upload.file.size.error.message": "La taille maximum des fichiers autorisée est 20Mo",
	"upload.file.space.error.message": "Désolé: pas assez d’espace pour ajouter automatiquement le fichier modèle comme document joint",
	"upload.or": "ou",
	"user.belong.to": "J'appartiens à",
	"user.card.about-cookies": "Les cookies sont de petits fichiers textes utilisés par les sites web pour améliorer l'efficacité de l'expérience utilisateur. La loi indique que nous pouvons uniquement stocker les cookies sur votre appareil s'ils sont strictement nécessaires au fonctionnement de ce site. Pour tous les autres types de cookies, nous avons besoin de votre autorisation. Ce site utilise différents types de cookies. Certains cookies sont placés par les services tiers apparaissant sur nos pages. Vous pouvez à tout moment modifier ou retirer votre consentement dès que vous voyez la déclaration concernant les cookies sur notre site web. Pour plus d'informations concernant notre identité, nos coordonnées et notre gestion des données personnelles, veuillez consulter notre Politique de confidentialité.",
	"user.card.about-cookies.title": "À propos des cookies",
	"user.card.accept": "Accepter",
	"user.card.account-info": "Informations du compte",
	"user.card.allowed": "Autorisé",
	"user.card.apply": "Appliquer",
	"user.card.audience-measurement-cookies": "Nous utilisons des cookies de mesure d'audience dont la finalité est limitée à la seule mesure de l'audience du site ou de l'application : mesure des performances, détection des problèmes de navigation, optimisation des performances techniques ou de l'ergonomie, estimation de la puissance des serveurs nécessaires, analyse des contenus construits pour le compte exclusif d'Arcelor Mittal.",
	"user.card.audience-measurement-cookies.title": "Cookies de mesure du public",
	"user.card.cookies-exempt-from-consents.one": "Les cookies de stockage des choix exprimés par les utilisateurs sur le recueil des traceurs.",
	"user.card.cookies-exempt-from-consents.three": "Les cookies de personnalisation de l'interface utilisateur (par ex. le choix de la langue ou la présentation d'un service), où une telle personnalisation constitue un élément intrinsèque et prévu du service.",
	"user.card.cookies-exempt-from-consents.title": "Cookies ne nécessitant pas le consentement",
	"user.card.cookies-exempt-from-consents.two": "Les cookies destinés à l'authentification à un service, y compris ceux destinés à la sécurité du mécanisme d'authentification, par exemple en limitant les accès des robots ou les tentatives d'accès imprévues.",
	"user.card.details": "Détails",
	"user.card.not-allowed": "Non autorisé",
	"user.card.notifications": "Alertes",
	"user.card.notifications.no-data": "Vous n'avez pas de notification",
	"user.card.notifications.tab.description": "Description",
	"user.card.notifications.tab.details": "Détails",
	"user.card.notifications.tab.frequency": "Fréquence",
	"user.card.notifications.tab.service": "Service ",
	"user.card.notifications.tab.subscription": "Abonnement",
	"user.card.notifications.title": "Notifications",
	"user.card.notifications.title.desc": "Liste des alertes de cet utilisateur",
	"user.card.personalcard": "Votre compte",
	"user.card.personalize-privacy-settings.title": "Personnaliser vos paramètres de confidentialité",
	"user.card.privacy-settings": "Paramètres de confidentialité",
	"user.card.reject": "Rejeter",
	"user.card.security": "Sécurité",
	"user.card.security.1-lowercase-letter-rule": "1 lettre minuscule (a, b, c, d, e)",
	"user.card.security.1-number-rule": "1 chiffre (1, 2, 3, 4)",
	"user.card.security.1-special-character-rule": "1 caractère spécial (:, /, !, _, -, #, @)",
	"user.card.security.1-uppercase-letter-rule": "1 lettre majuscule (A, B, C, D, E)",
	"user.card.security.15-character-rule": "15 caractères minimum",
	"user.card.security.change-login-title": "Change your login",
	"user.card.security.change-password-title": "Modifier votre mot de passe",
	"user.card.security.confirm-password-match": "Le champ Confirmer le mot de passe doit correspondre au nouveau mot de passe",
	"user.card.security.password-must-contain-title": "Pour être validé, le mot de passe doit contenir au moins :",
	"user.card.security.username-error": "Please enter valid username",
	"user.card.security.your-current-password": "Votre mot de passe actuel",
	"user.card.security.your-login": "Your login",
	"user.card.security.your-new-password": "Votre nouveau mot de passe",
	"user.card.security.your-repeat-new-password": "Répétez votre nouveau mot de passe",
	"user.card.services": "Services",
	"user.card.services.no-data": "Vous ne disposez d'aucun service",
	"user.card.services.tab.desc": "Description",
	"user.card.services.tab.name": "Nom",
	"user.card.services.tab.settings": "Paramètres",
	"user.card.services.title": "Liste des services",
	"user.card.services.title.desc": "Liste de tous les services disponibles pour cet utilisateur dans le contexte fournisseur",
	"user.card.settings": "Paramètres",
	"user.expired": "Expired",
	"user.expiryDate": "Expiry date",
	"user.gender.mr": "M.",
	"user.gender.mrs": "Mme",
	"user.gender.ms": "Mlle",
	"user.language": "Langue",
	"user.need.connection": "Vous devez être authentifié pour accéder à cette partie.",
	"user.no.connection": "Vous devez disposer d'une connexion internet pour accéder à ce service.",
	"user.no.role": "Votre profil ne vous autorise pas à gérer ce litige. Veuillez contacter votre relais SteelUser pour obtenir un accès complet au service Litiges.",
	"user.no.service": "Votre profil ne vous autorise pas à gérer ce litige. Veuillez contacter votre relais SteelUser pour obtenir un accès complet au service Litiges.",
	"user.notifications.add.subscription": "Ajouter",
	"user.notifications.btn.add.subscription": "Ajouter abonnement",
	"user.notifications.dialog.subscription": "Ajouter un abonnement",
	"user.notifications.dropdown.frequency": "Fréquence",
	"user.notifications.dropdown.services": "Services",
	"user.notifications.dropdown.subscription": "Abonnement",
	"user.notifications.select.frequency": "Veuillez sélectionner une fréquence",
	"user.notifications.select.service": "Veuillez sélectionner un service",
	"user.notifications.select.subscription": "Veuillez sélectionner un abonnement",
	"user.see.data": "Je vois actuellement des données pour",
	"user.supplier": "Mon fournisseur",
	"user.user": "Utilisateur",
	"user.validation": "Un utilisateur est nécessaire",
	"user.validationDaysLeft": "ValidationDaysLeft",
	"userServiceInfo.services.management": "Services actifs",
	"userServiceInfo.services.settings": "Paramètres",
	"users.details-card.actions": "Actions",
	"users.list": "Liste des utilisateurs",
	"view.shared.success": "Souhaitez-vous vraiment supprimer ce brouillon {{value}} ?",
	"view.validation": "Une vue est nécessaire",
	"viewby.cdd.asc": "CDD asc",
	"viewby.cdd.desc": "CDD desc",
	"viewby.mill.asc": "Usine asc",
	"viewby.mill.desc": "Usine desc",
	"viewby.product.asc": "Produit asc",
	"viewby.product.desc": "Produit desc",
	"viewby.step": "étape",
	"wait.message": "NE PAS APPUYER sur le bouton retour ni le bouton actualisation de votre navigateur",
	"wait.message.fastlane": "Merci DE NE PAS CLIQUER sur le bouton retour ou de raffraîchir votre navigateur",
	"wait.user.validation": "Waiting for user validation",
	"want.to.cancel.issue": "Do you really want to cancel this issue",
	"want.to.close": "Êtes-vous certain de vouloir fermer?",
	"want.to.delete.draft": "Souhaitez-vous vraiment supprimer ce brouillon",
	"want.to.delete.notification": "Voulez-vous vraiment supprimer cette notification",
	"warning-product-category": "Please select a product category.",
	"warning-standard-steelgrade": "Please select a standard steelgrade.",
	"warning-steelgrade": "Please select a steelgrade.",
	"warning-sub-category": "Please select a sub category.",
	"warning-thickness": "Please enter thickness.",
	"warning-width": "Please enter width.",
	"warning.closed.orders": "You are writing a comment on a closed order",
	"warning.maximum.1000": "Impossible de télécharger plus de 1000 enregistrements à la fois",
	"warning.maximum.30": "Impossible de télécharger plus de 30 enregistrements à la fois",
	"woe.noitems": "Aucun élément",
	"workflow-steps.next.error": "Une erreur s'est produite, veuillez contacter l'administrateur SteelUser",
	"xcarb-document.card": "XCarb® Document",
	"xcarb.label": "XCarb®"
};
